
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2rynm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6SsN4 = parcelRequire("6SsN4");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $jmjWc = parcelRequire("jmjWc");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7boqA = parcelRequire("7boqA");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $1xpoY = parcelRequire("1xpoY");


var $8zMP3 = parcelRequire("8zMP3");


var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");

/* SpaceNavigationRelatedContent.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $aRGok = parcelRequire("aRGok");





var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");








var $fR63l = parcelRequire("fR63l");


var $cS7ok = parcelRequire("cS7ok");


var $i9pyX = parcelRequire("i9pyX");





var $5ZqQS = parcelRequire("5ZqQS");





var $k8jyJ = parcelRequire("k8jyJ");

const $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH = 'spaceCurationThirdPartyAuth';
const $dddab7bf95955fb3$var$CONNECTION_PRODUCT_KEYS = {
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE]: [
        (0, $fR63l.ProductKeys3P).GoogleDrive
    ],
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT]: [
        (0, $fR63l.ProductKeys3P).OneDrive,
        (0, $fR63l.ProductKeys3P).Sharepoint
    ]
};
const $dddab7bf95955fb3$var$connectionProductKeySet = (product)=>{
    const productKeys = $dddab7bf95955fb3$var$CONNECTION_PRODUCT_KEYS[product];
    return productKeys ? new Set(productKeys) : undefined;
};
const $dddab7bf95955fb3$var$resourceBelongsToConnection = (resourceType, productKeySet, resourceTypeToProductKey)=>{
    const productKey = resourceTypeToProductKey[resourceType];
    return productKey !== undefined && productKeySet.has(productKey);
};
const $dddab7bf95955fb3$export$3d6949c2295aff10 = ({ products: products, cloudId: cloudId })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [optimisticallyAuthenticatedProducts, setOptimisticallyAuthenticatedProducts] = (0, $cozmU.useState)(new Set());
    const [revalidation, setRevalidation] = (0, $cozmU.useState)({
        done: false,
        confirmed: new Set()
    });
    const hasStartedRevalidationRef = (0, $cozmU.useRef)(false);
    const productsRef = (0, $cozmU.useRef)(products);
    productsRef.current = products;
    const thirdPartyTypesRef = (0, $cozmU.useRef)(null);
    const resolveThirdPartyTypes = (0, $cozmU.useCallback)(()=>{
        if (!thirdPartyTypesRef.current) thirdPartyTypesRef.current = (0, $cS7ok.getThirdPartyTypes)();
        return thirdPartyTypesRef.current;
    }, []);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>createAnalyticsEvent(event).fire(), [
        createAnalyticsEvent
    ]);
    const logException = (0, $cozmU.useCallback)((exception)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(exception, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS,
            partialFailure: true
        });
    }, []);
    const analytics = (0, $cozmU.useMemo)(()=>({
            searchSessionId: $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH,
            source: $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH,
            actionSubject: $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH,
            taskNamePrefix: $dddab7bf95955fb3$var$SPACE_CURATION_3P_AUTH,
            fireAnalyticsEvent: fireAnalyticsEvent,
            logException: logException
        }), [
        fireAnalyticsEvent,
        logException
    ]);
    const disabled = !cloudId || !userId || products.length === 0;
    const { thirdPartyConfigs: thirdPartyConfigs } = (0, $cS7ok.useThirdPartyConfig)({
        cloudId: cloudId,
        userId: userId ?? undefined,
        disabled: disabled,
        analytics: analytics
    });
    const markOptimisticallyAuthenticated = (0, $cozmU.useCallback)((product)=>{
        setOptimisticallyAuthenticatedProducts((prev)=>{
            const next = new Set(prev);
            next.add(product);
            return next;
        });
        const productKeySet = $dddab7bf95955fb3$var$connectionProductKeySet(product);
        if (userId && cloudId && productKeySet) resolveThirdPartyTypes().then((resourceTypeToProductKey)=>(0, $i9pyX.update3pConfigCacheEntry)(userId, cloudId, (config)=>config.map((resource)=>$dddab7bf95955fb3$var$resourceBelongsToConnection(resource.type, productKeySet, resourceTypeToProductKey) ? {
                        ...resource,
                        isUserOAuthed: true
                    } : resource)));
    }, [
        cloudId,
        userId,
        resolveThirdPartyTypes
    ]);
    const { authenticatedServices: authenticatedServices, unauthenticatedServices: unauthenticatedServices } = (0, $cozmU.useMemo)(()=>{
        const authenticated = {};
        const unauthenticated = {};
        for (const product of products){
            const productKeys = $dddab7bf95955fb3$var$CONNECTION_PRODUCT_KEYS[product];
            if (!productKeys) continue;
            let hasConfig = false;
            let isAuthenticated = false;
            let outboundAuthUrl;
            let icon;
            // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
            for (const productKey of productKeys){
                const config = thirdPartyConfigs?.[productKey];
                if (!config) continue;
                if (!hasConfig) {
                    icon = config.icon;
                    hasConfig = true;
                }
                if (!config.userNeedsOAuth) isAuthenticated = true;
                if (outboundAuthUrl === undefined && config.outboundAuthUrl) outboundAuthUrl = config.outboundAuthUrl;
            }
            if (!hasConfig) continue;
            const connected = isAuthenticated || optimisticallyAuthenticatedProducts.has(product) || revalidation.confirmed.has(product);
            const status = {
                isAuthenticated: connected,
                outboundAuthUrl: outboundAuthUrl,
                icon: icon
            };
            if (connected) authenticated[product] = status;
            else unauthenticated[product] = status;
        }
        return {
            authenticatedServices: authenticated,
            unauthenticatedServices: unauthenticated
        };
    }, [
        products,
        thirdPartyConfigs,
        optimisticallyAuthenticatedProducts,
        revalidation
    ]);
    const runRevalidation = (0, $cozmU.useCallback)(async (options)=>{
        const confirmed = new Set();
        if (!options?.skipFetch && cloudId && userId) try {
            const [resources, resourceTypeToProductKey] = await Promise.all([
                (0, $i9pyX.get3pSearchConfig)({
                    cloudId: cloudId,
                    userId: userId,
                    returnExpired: false,
                    onlyRefreshIfExpired: false
                }),
                resolveThirdPartyTypes()
            ]);
            for (const product of productsRef.current){
                const productKeySet = $dddab7bf95955fb3$var$connectionProductKeySet(product);
                if (!productKeySet) continue;
                // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
                const isConnected = resources?.some((resource)=>$dddab7bf95955fb3$var$resourceBelongsToConnection(resource.type, productKeySet, resourceTypeToProductKey) && resource.isUserOAuthed);
                if (isConnected) confirmed.add(product);
            }
        } catch  {}
        setRevalidation((prev)=>{
            const nextConfirmed = new Set(prev.confirmed);
            confirmed.forEach((product)=>nextConfirmed.add(product));
            return {
                done: true,
                confirmed: nextConfirmed
            };
        });
    }, [
        cloudId,
        userId,
        resolveThirdPartyTypes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasStartedRevalidationRef.current) return;
        if (disabled || thirdPartyConfigs === undefined) return;
        hasStartedRevalidationRef.current = true;
        const skipFetch = Object.keys(unauthenticatedServices).length === 0;
        runRevalidation({
            skipFetch: skipFetch
        });
    }, [
        disabled,
        thirdPartyConfigs,
        unauthenticatedServices,
        runRevalidation
    ]);
    const refetch = (0, $cozmU.useCallback)(async ()=>{
        await runRevalidation();
    }, [
        runRevalidation
    ]);
    const configLoading = !disabled && thirdPartyConfigs === undefined;
    const wouldShowAuthCard = !configLoading && Object.keys(unauthenticatedServices).length > 0;
    const isLoading = configLoading || wouldShowAuthCard && !revalidation.done;
    return {
        authenticatedServices: authenticatedServices,
        unauthenticatedServices: unauthenticatedServices,
        isLoading: isLoading,
        refetch: refetch,
        markOptimisticallyAuthenticated: markOptimisticallyAuthenticated
    };
};


/* ReviewContentSuggestionsModal.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlassian/perf-linting/no-quadratic-complexity */ /* eslint-disable @atlassian/perf-linting/no-chain-state-updates */ /* eslint-disable @atlassian/perf-linting/no-expensive-computations-in-render */ 









var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $RfroO = parcelRequire("RfroO");


var $4w5V7 = parcelRequire("4w5V7");


var $l3wuH = parcelRequire("l3wuH");


var $93fnf = parcelRequire("93fnf");


var $kUFQ0 = parcelRequire("kUFQ0");


var $I7hWB = parcelRequire("I7hWB");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");





var $4ez2K = parcelRequire("4ez2K");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");





var $kh0hi = parcelRequire("kh0hi");


var $1VhsF = parcelRequire("1VhsF");


var $7A1BE = parcelRequire("7A1BE");


var $hMaHH = parcelRequire("hMaHH");


var $2uDbg = parcelRequire("2uDbg");


var $lfoFx = parcelRequire("lfoFx");


var $lpNn5 = parcelRequire("lpNn5");


var $431p7 = parcelRequire("431p7");


var $lsxnT = parcelRequire("lsxnT");










/* SuggestionMovePopup.tsx generated by @compiled/babel-plugin v3.0.2 */ 



























var $4n1IT = parcelRequire("4n1IT");


var $bCECL = parcelRequire("bCECL");


var $4M98y = parcelRequire("4M98y");

/**
 * @generated SignedSource<<fae6dc9963c2cb70c50a749af89545fe>>
 * @relayHash 7c0e4d8486e54ba6e102ec5009505b19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f
const $190e7a369505d2bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
    }, v2 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ], v3 = [
        {
            "alias": "pageContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "folderContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "folder"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "whiteboardContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "databaseContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "database"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "embedContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "embed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentTitlesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentTitlesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7c0e4d8486e54ba6e102ec5009505b19",
            "id": "3b4a148a7952924e53af4161b0a5fc2ad94790986d10c32d96e9d7b55976cd6f",
            "metadata": {},
            "name": "useContentTitlesQuery",
            "operationKind": "query",
            "text": "query useContentTitlesQuery($ids:[ID!]!){pageContent:content(ids:$ids,type:\"page\"){nodes{id,title}},folderContent:content(ids:$ids,type:\"folder\"){nodes{id,title}},whiteboardContent:content(ids:$ids,type:\"whiteboard\"){nodes{id,title}},databaseContent:content(ids:$ids,type:\"database\"){nodes{id,title}},embedContent:content(ids:$ids,type:\"embed\"){nodes{id,title}}}"
        }
    };
}();
$190e7a369505d2bf$var$node.hash = "503b371610f42e1634360824bac2cefe";
var $190e7a369505d2bf$export$2e2bcd8739ae039 = $190e7a369505d2bf$var$node;






var $jMyy4 = parcelRequire("jMyy4");

const $877d8332f9570d6f$var$ContentTitlesQuery = (0, $190e7a369505d2bf$export$2e2bcd8739ae039);
const $877d8332f9570d6f$export$7610585fadab893e = (contentIds)=>{
    const ids = (0, $cozmU.useMemo)(()=>{
        const unique = [
            ...new Set(contentIds)
        ].filter(Boolean);
        return unique;
    }, [
        contentIds
    ]);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($877d8332f9570d6f$var$ContentTitlesQuery, {
        variables: {
            ids: ids
        },
        skip: ids.length === 0,
        __callerPackage__: "space-curation"
    });
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById } = (0, $cozmU.useMemo)(()=>{
        const titlesMap = new Map();
        const metaMap = new Map();
        const typedGroups = [
            {
                nodes: data?.pageContent ?? null,
                type: 'page'
            },
            {
                nodes: data?.folderContent ?? null,
                type: 'folder'
            },
            {
                nodes: data?.whiteboardContent ?? null,
                type: 'whiteboard'
            },
            {
                nodes: data?.databaseContent ?? null,
                type: 'database'
            },
            {
                nodes: data?.embedContent ?? null,
                type: 'embed'
            }
        ];
        for (const { nodes: nodes, type: type } of typedGroups){
            for (const node of nodes?.nodes ?? [])if (node?.id != null) {
                const title = node.title ?? '';
                titlesMap.set(node.id, title);
                metaMap.set(node.id, {
                    title: title,
                    type: type
                });
            }
        }
        return {
            titlesByContentId: titlesMap,
            contentMetaById: metaMap
        };
    }, [
        data
    ]);
    const isLoading = ids.length > 0 && loading;
    return {
        titlesByContentId: titlesByContentId,
        contentMetaById: contentMetaById,
        isLoading: isLoading
    };
};





const $e9fbe7b264ec157f$export$3e0409b11e4da6d2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.25 0C8.76904 0 9.26676 0.206236 9.63379 0.573242L12.9268 3.86621C13.2938 4.23324 13.5 4.73096 13.5 5.25V8H12V6H8.25C7.83579 6 7.5 5.66421 7.5 5.25V1.5H3.5C3.22386 1.5 3 1.72386 3 2V14C3 14.2761 3.22386 14.5 3.5 14.5H6V16H3.5C2.39543 16 1.5 15.1046 1.5 14V2C1.5 0.895431 2.39543 0 3.5 0H8.25ZM9 4.5H11.4395L9 2.06055V4.5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5819 12.3067C14.8222 12.6013 14.8048 13.036 14.5302 13.3106L11.7802 16.0606L10.7196 15.0001L12.1893 13.5303L7.74988 13.5303L7.74988 12.0303L12.1893 12.0303L10.7196 10.5606L11.7802 9.50006L14.5302 12.2501L14.5819 12.3067Z",
        fill: "currentColor"
    }));


const $e4c0d2b6b6e18559$var$styles = {
    movePopupContent: "_4FKVYE8HPE _39xV02ehCh",
    fallbackSectionLabel: "_4FKVYE1Y8M",
    fallbackParentRow: "_2mHwu8gVvo _4FKVYE2ADO _23rrnHo10F _0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0KLXrujOvk _1eOmH6o126 _3sFUREDdj4 _3gzVzLN4oS",
    fallbackParentTitle: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _2fwxA57p2s",
    fallbackParentIcon: "_3YEZNOdnbC",
    spinnerContainer: "_4FKVYE8HPE _3iDTPbQ4SZ _37wbyuDIqT"
};
const $e4c0d2b6b6e18559$var$i18n = (0, $kSwu1.defineMessages)({
    moveButton: {
        id: "space-curation.review-content-suggestions-modal.move-button",
        defaultMessage: "Move"
    },
    moveToTitle: {
        id: "space-curation.review-content-suggestions-modal.move-to-title",
        defaultMessage: "Move to"
    },
    suggested: {
        id: "space-curation.review-content-suggestions-modal.move-suggested",
        defaultMessage: "Suggested"
    },
    moveSuggestionTooltip: {
        id: "space-curation.review-content-suggestions-modal.move-suggestion-tooltip",
        defaultMessage: "Move suggestion to another parent"
    }
});
const $e4c0d2b6b6e18559$var$FallbackParentRow = ({ parentId: parentId, meta: meta, title: title, onMoveItemClick: onMoveItemClick })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onMoveItemClick(parentId);
    }, [
        onMoveItemClick,
        parentId
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $kh0hi.default), {
        key: parentId,
        xcss: $e4c0d2b6b6e18559$var$styles.fallbackParentRow,
        onClick: handleClick,
        testId: `suggestion-move-fallback-parent-${parentId}`
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $e4c0d2b6b6e18559$var$styles.fallbackParentIcon,
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $bCECL.ContentIcon), {
        type: meta?.type ?? 'page'
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $e4c0d2b6b6e18559$var$styles.fallbackParentTitle
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, meta?.title ?? title)));
};
const $e4c0d2b6b6e18559$export$de484dae570b7c31 = ({ suggestionId: suggestionId, spaceKey: spaceKey, isOpen: isOpen, onOpenChange: onOpenChange, onMoveSuggestion: onMoveSuggestion, fallbackParents: fallbackParents, currentParentId: currentParentId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const filteredFallbackParents = (0, $cozmU.useMemo)(()=>(fallbackParents ?? []).filter((id)=>id !== currentParentId), [
        fallbackParents,
        currentParentId
    ]);
    const fallbackParentIdStrings = (0, $cozmU.useMemo)(()=>filteredFallbackParents.map(String), [
        filteredFallbackParents
    ]);
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById, isLoading: isLoading } = (0, $877d8332f9570d6f$export$7610585fadab893e)(isOpen ? fallbackParentIdStrings : []);
    const handleMoveItemClick = (0, $cozmU.useCallback)((idOrAri)=>{
        const str = String(idOrAri);
        const rawId = str.includes('/') ? str.split('/').pop() ?? str : str;
        const numId = Number(rawId);
        if (!rawId || isNaN(numId)) return;
        onMoveSuggestion(suggestionId, numId);
        onOpenChange(false);
    }, [
        onMoveSuggestion,
        onOpenChange,
        suggestionId
    ]);
    const renderFallbackParentList = ()=>{
        if (isLoading) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e4c0d2b6b6e18559$var$styles.spinnerContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "small"
        }));
        const accessibleParents = filteredFallbackParents.filter((parentId)=>contentMetaById.has(String(parentId)));
        if (accessibleParents.length === 0) return null;
        return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e4c0d2b6b6e18559$var$styles.fallbackSectionLabel
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            weight: "semibold"
        }, formatMessage($e4c0d2b6b6e18559$var$i18n.suggested))), accessibleParents.map((parentId)=>/*#__PURE__*/ $cozmU.createElement($e4c0d2b6b6e18559$var$FallbackParentRow, {
                key: parentId,
                parentId: parentId,
                meta: contentMetaById.get(String(parentId)),
                title: titlesByContentId.get(String(parentId)),
                onMoveItemClick: handleMoveItemClick
            })));
    };
    const fallbackParentRows = isOpen && filteredFallbackParents.length > 0 ? renderFallbackParentList() : null;
    return /*#__PURE__*/ $cozmU.createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: ()=>onOpenChange(false),
        placement: "bottom-start",
        zIndex: 800,
        content: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $e4c0d2b6b6e18559$var$styles.movePopupContent
            }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                weight: "bold"
            }, formatMessage($e4c0d2b6b6e18559$var$i18n.moveToTitle)), /*#__PURE__*/ $cozmU.createElement((0, $4M98y.ContentTreeSearchBase), {
                spaceKey: spaceKey ?? '',
                onItemClick: handleMoveItemClick,
                contentId: "",
                includeFolders: true
            }, fallbackParentRows)),
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                isSelected: isOpen,
                icon: ()=>/*#__PURE__*/ $cozmU.createElement((0, $e9fbe7b264ec157f$export$3e0409b11e4da6d2), null),
                label: formatMessage($e4c0d2b6b6e18559$var$i18n.moveButton),
                onClick: ()=>onOpenChange(!isOpen),
                testId: `review-content-suggestion-move-button-${suggestionId}`,
                isTooltipDisabled: false,
                tooltip: {
                    content: formatMessage($e4c0d2b6b6e18559$var$i18n.moveSuggestionTooltip)
                }
            })
    });
};


/* SuggestionsFilterPopup.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $dPtk6 = parcelRequire("dPtk6");




















var $c0A7H = parcelRequire("c0A7H");







const $d46a749dcc1cd83e$var$messages = (0, $kSwu1.defineMessages)({
    googleDrive: {
        id: "space-curation.review-content-suggestions-modal.filter-source-google-drive",
        defaultMessage: "Google Drive"
    },
    loom: {
        id: "space-curation.review-content-suggestions-modal.filter-source-loom",
        defaultMessage: "Loom"
    },
    microsoft: {
        id: "space-curation.review-content-suggestions-modal.filter-source-microsoft",
        defaultMessage: "Microsoft"
    }
});
const $d46a749dcc1cd83e$export$fc6308b035f32dc = {
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE]: $d46a749dcc1cd83e$var$messages.googleDrive,
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).LOOM]: $d46a749dcc1cd83e$var$messages.loom,
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT]: $d46a749dcc1cd83e$var$messages.microsoft
};



var $fSlSx = parcelRequire("fSlSx");




const $a01761abc8be8172$var$i18n = (0, $kSwu1.defineMessages)({
    filterButtonLabel: {
        id: "space-curation.review-content-suggestions-modal.filter-button-label",
        defaultMessage: "Filter suggestions by source"
    },
    showOnlyFrom: {
        id: "space-curation.review-content-suggestions-modal.filter-show-only-from",
        defaultMessage: "Show only suggestions from"
    }
});
const $a01761abc8be8172$var$styles = {
    popupContent: "_4FKVYEgVvo _39xV02e7g8",
    sourceRow: "_4c065U2ADO _2Y7lL45zaO",
    heading: "_4c065U2ADO _2Y7lL45zaO",
    sourceName: "_2O5Vij7dHp _4ouGXIdnbC",
    iconWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC"
};
const $a01761abc8be8172$export$21d85d7a6ca378ad = ({ onClose: onClose, availableSources: availableSources })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false); // Available sources are, by definition, ones the user already has suggestions from, so every
    // one is filterable — no auth/connect gating is needed here.
    const visibleSources = (0, $cozmU.useMemo)(()=>availableSources.reduce((acc, ari)=>{
            const connection = (0, $k8jyJ.getConnectionForProviderId)(ari);
            if (connection) acc.push({
                ari: ari,
                connection: connection
            });
            return acc;
        }, []), [
        availableSources
    ]);
    const [enabledSources, setEnabledSources] = (0, $cozmU.useState)({}); // A source counts as enabled unless it has been explicitly toggled off (missing entry ⇒ on).
    const isEnabled = (0, $cozmU.useCallback)((source)=>enabledSources[source.ari] !== false, [
        enabledSources
    ]);
    const closePopup = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        const enabled = visibleSources.filter(isEnabled); // All available sources enabled ⇒ no filter (empty list); otherwise submit the chosen ARIs.
        onClose(enabled.length === visibleSources.length ? [] : enabled.map((source)=>source.ari));
    }, [
        onClose,
        isEnabled,
        visibleSources
    ]);
    const handleToggle = (ari)=>{
        setEnabledSources((prev)=>({
                ...prev,
                [ari]: prev[ari] === false
            }));
    };
    const enabledCount = (0, $cozmU.useMemo)(()=>visibleSources.reduce((count, source)=>isEnabled(source) ? count + 1 : count, 0), [
        isEnabled,
        visibleSources
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: closePopup,
        placement: "bottom-end",
        zIndex: 800,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a01761abc8be8172$var$styles.popupContent,
                testId: "suggestions-filter-popup-content"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.0"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $a01761abc8be8172$var$styles.heading
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                weight: "bold",
                color: "color.text.subtlest"
            }, formatMessage($a01761abc8be8172$var$i18n.showOnlyFrom))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.0"
            }, visibleSources.map((source)=>{
                const name = formatMessage((0, $d46a749dcc1cd83e$export$fc6308b035f32dc)[source.connection]);
                const checked = isEnabled(source);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    key: source.ari,
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "space.100",
                    xcss: $a01761abc8be8172$var$styles.sourceRow
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $a01761abc8be8172$var$styles.iconWrapper
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ConnectionLogo), {
                    connection: source.connection,
                    size: "xxsmall"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: $a01761abc8be8172$var$styles.sourceName
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    size: "medium"
                }, name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
                    label: name,
                    isChecked: checked,
                    isDisabled: checked && enabledCount === 1,
                    onChange: ()=>handleToggle(source.ari),
                    testId: `suggestions-filter-toggle-${source.connection}`
                }));
            })))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))),
                label: formatMessage($a01761abc8be8172$var$i18n.filterButtonLabel),
                appearance: "subtle",
                spacing: "compact",
                isSelected: isOpen,
                onClick: ()=>isOpen ? closePopup() : setIsOpen(true),
                testId: "suggestions-filter-button"
            })
    });
};







var $f7B1p = parcelRequire("f7B1p");




/**
 * @generated SignedSource<<2d2408509afa5edbb31555d7592c0d05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $583f0c72f724db55$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSetSpaceViewsSortTransientWriteFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$583f0c72f724db55$var$node.hash = "cca4dcc97ad7cd8994207d0b7df73299";
var $583f0c72f724db55$export$2e2bcd8739ae039 = $583f0c72f724db55$var$node;






var $ij4CE = parcelRequire("ij4CE");


const $320110e076811ccd$export$4820105a3dae0c48 = (spaceKey)=>{
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $583f0c72f724db55$export$2e2bcd8739ae039),
        fragmentSpec: (0, $583f0c72f724db55$export$2e2bcd8739ae039),
        __callerPackage__: "space-curation"
    });
    return (0, $cozmU.useCallback)((newSort)=>{
        writeFragmentInterop({
            fragmentId: `$ROOT_QUERY.userPreferences`,
            data: {
                spaceViewsPersistence: newSort,
                __typename: 'UserPreferences'
            },
            variables: {
                spaceKey: spaceKey
            }
        });
    }, [
        spaceKey,
        writeFragmentInterop
    ]);
};


const $55e1c5eec5b4b224$var$SUCCESS_FLAG_ID = 'space-navigation.suggestion-actions.success';
const $55e1c5eec5b4b224$var$i18n = (0, $kSwu1.defineMessages)({
    successFlagTitle: {
        id: "space-curation.suggestion-actions.success.title",
        defaultMessage: "{count, plural, one {{count} item added to space} other {{count} items added to space}}"
    },
    successFlagDescription: {
        id: "space-curation.suggestion-actions.success.description",
        defaultMessage: "Your selected content has been added to this space."
    },
    errorFlagTitle: {
        id: "space-curation.suggestion-actions.error.title",
        defaultMessage: "Failed to add items to space"
    },
    errorFlagDescription: {
        id: "space-curation.suggestion-actions.error.description",
        defaultMessage: "Something went wrong. Please try again."
    },
    viewLastUpdated: {
        id: "space-curation.suggestion-actions.success.view-last-updated",
        defaultMessage: "View last updated"
    }
});
const $55e1c5eec5b4b224$export$c9239e53ef385494 = ({ spaceKey: spaceKey, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const setSpaceViewsSortTransient = (0, $320110e076811ccd$export$4820105a3dae0c48)(spaceKey);
    const submitActions = async (allSuggestions, selectedIds, rejectedIds, { showFlags: showFlags = true } = {})=>{
        if (!spaceKey) return false;
        const actions = allSuggestions.map((s)=>({
                ...s,
                action: selectedIds.has(s.id) ? (0, $k8jyJ.Action).ACCEPT : rejectedIds.has(s.id) ? (0, $k8jyJ.Action).REJECT : (0, $k8jyJ.Action).IGNORE
            }));
        try {
            await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/actions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    actions: actions
                })
            });
            if (showFlags) flags?.showSuccessFlag({
                id: $55e1c5eec5b4b224$var$SUCCESS_FLAG_ID,
                title: formatMessage($55e1c5eec5b4b224$var$i18n.successFlagTitle, {
                    count: selectedIds.size
                }),
                description: formatMessage($55e1c5eec5b4b224$var$i18n.successFlagDescription),
                isAutoDismiss: false,
                actions: [
                    {
                        content: formatMessage($55e1c5eec5b4b224$var$i18n.viewLastUpdated),
                        onClick: ()=>{
                            setSpaceViewsSortTransient('RECENTLY_MODIFIED');
                            flags?.hideFlag($55e1c5eec5b4b224$var$SUCCESS_FLAG_ID);
                        }
                    }
                ]
            });
            return true;
        } catch  {
            if (showFlags) flags?.showErrorFlag({
                id: 'space-navigation.suggestion-actions.error',
                title: formatMessage($55e1c5eec5b4b224$var$i18n.errorFlagTitle),
                description: formatMessage($55e1c5eec5b4b224$var$i18n.errorFlagDescription),
                isAutoDismiss: true
            });
            return false;
        }
    };
    return {
        submitActions: submitActions
    };
};









var $hBkCm = parcelRequire("hBkCm");



const $b0a504e05d35a946$var$normalizeParentIds = (suggestions)=>suggestions.map((group)=>({
            ...group,
            parentId: group.parentId ?? null,
            // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
            remoteObjects: group.remoteObjects.map((obj)=>({
                    ...obj,
                    parentId: obj.parentId ?? null
                }))
        }));
const $b0a504e05d35a946$export$b1532bcf7c9b2548 = (spaceKey, sources)=>{
    const [groups, setGroups] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [isSuppressed, setIsSuppressed] = (0, $cozmU.useState)(false);
    const sourcesKey = sources ? [
        ...sources
    ].sort().join(',') : '';
    const refetch = (0, $cozmU.useCallback)(async ()=>{
        if (!spaceKey) {
            setGroups([]);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const selected = sourcesKey ? sourcesKey.split(',') : [];
            const params = new URLSearchParams();
            selected.forEach((source)=>params.append('sources', source));
            const queryString = params.toString();
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions${queryString ? `?${queryString}` : ''}`, {
                method: 'GET'
            });
            const data = await response.json();
            setGroups($b0a504e05d35a946$var$normalizeParentIds(data.suggestions ?? []));
            setIsSuppressed(false);
        } catch (error) {
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status === 404) setIsSuppressed(true);
        } finally{
            setIsLoading(false);
        }
    }, [
        spaceKey,
        sourcesKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        refetch();
    }, [
        refetch
    ]);
    return {
        groups: groups,
        isLoading: isLoading,
        refetch: refetch,
        isSuppressed: isSuppressed
    };
};


/**
 * @generated SignedSource<<08247c0e3353f502c6ab48ec21242ef6>>
 * @relayHash 0ca6fbc81dc6db0a2b75e5e31688f8f2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b02565943ba78281f88347582fa278755748b9ab1ccdcdbaf5300a1ad8b36d1
const $f039663526f9375a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectAvailableSources"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchAvailableSourcesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchAvailableSourcesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0ca6fbc81dc6db0a2b75e5e31688f8f2",
            "id": "7b02565943ba78281f88347582fa278755748b9ab1ccdcdbaf5300a1ad8b36d1",
            "metadata": {},
            "name": "useFetchAvailableSourcesQuery",
            "operationKind": "query",
            "text": "query useFetchAvailableSourcesQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectAvailableSources(cloudId:$cloudId,spaceKey:$spaceKey)}"
        }
    };
}();
$f039663526f9375a$var$node.hash = "965970e949d0f5bb2e85206332f80ad9";
var $f039663526f9375a$export$2e2bcd8739ae039 = $f039663526f9375a$var$node;








const $be72420aa1928141$export$4d5f1f6a2bca3255 = (0, $f039663526f9375a$export$2e2bcd8739ae039);
const $be72420aa1928141$export$e83bdb5bee7fb6bb = ({ spaceKey: spaceKey, cloudId: cloudId, skip: skip = false })=>{
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($be72420aa1928141$export$4d5f1f6a2bca3255, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: skip || !spaceKey,
        interopApolloAggClient: true,
        __callerPackage__: "space-curation"
    });
    const availableSources = (0, $cozmU.useMemo)(()=>{
        const raw = data?.confluence_remoteObjectAvailableSources;
        if (!raw) return [];
        return [
            ...new Set(raw.filter((source)=>Boolean(source)))
        ];
    }, [
        data
    ]);
    return {
        availableSources: availableSources,
        isLoading: loading
    };
};






var $1kHsc = parcelRequire("1kHsc");




const $b3f0a9dc40fecba0$var$NAME = (0, $irVI7.SPACE_CURATION_REVIEW_SUGGESTIONS_EXPERIENCE);
const $b3f0a9dc40fecba0$export$c8d4c1de2c630478 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            name: $b3f0a9dc40fecba0$var$NAME
        });
        return ()=>{
            const state = experienceTracker.getExperienceState($b3f0a9dc40fecba0$var$NAME);
            if (state && !state.hasStopped) experienceTracker.abort({
                name: $b3f0a9dc40fecba0$var$NAME,
                reason: 'Modal closed before suggestions rendered'
            });
        };
    }, [
        experienceTracker
    ]);
    return (0, $cozmU.useMemo)(()=>({
            succeed: ()=>experienceTracker.succeed({
                    name: $b3f0a9dc40fecba0$var$NAME
                }),
            fail: ()=>experienceTracker.fail({
                    name: $b3f0a9dc40fecba0$var$NAME,
                    error: new Error('Space curation review modal rendered zero suggestions')
                }),
            abortNotProvisioned: ()=>experienceTracker.abort({
                    name: $b3f0a9dc40fecba0$var$NAME,
                    reason: 'Suggestions endpoint returned 404 (feature not provisioned)'
                })
        }), [
        experienceTracker
    ]);
};


/* eslint-disable @atlassian/perf-linting/no-quadratic-complexity */ 








const $f140ec3197f8db13$var$hashStringToInt = (str)=>{
    let hash = 5381;
    for(let i = 0; i < str.length; i++)// eslint-disable-next-line no-bitwise
    hash = hash * 33 ^ str.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    return hash >>> 0;
};
const $f140ec3197f8db13$export$b647b214edf4111 = (suggestion, titlesByContentId)=>{
    const { explanation: explanation, relatedPages: relatedPages } = suggestion;
    const hasExplanation = Boolean(explanation);
    const firstRelatedPageId = relatedPages?.[0];
    const relatedPageTitle = firstRelatedPageId ? titlesByContentId.get(String(firstRelatedPageId)) ?? '' : '';
    const hasRelated = relatedPageTitle.length > 0;
    const candidates = [];
    if (hasRelated) candidates.push('related');
    if (hasExplanation) candidates.push('explanation');
    if (candidates.length === 0) return null;
    return candidates[$f140ec3197f8db13$var$hashStringToInt(suggestion.id) % candidates.length];
};


function $1bc25cf918df8e30$export$6ec3dc3eba258cc5({ spaceId: spaceId, spaceKey: spaceKey, orderedSuggestions: orderedSuggestions, titlesByContentId: titlesByContentId, selectedItems: selectedItems, rejectedItems: rejectedItems, isLoading: isLoading, isFetchingSuggestions: isFetchingSuggestions, isSuppressed: isSuppressed, isFilterApplied: isFilterApplied, filterKey: filterKey, modalOpenTimestamp: modalOpenTimestamp, reviewSuggestionsExperience: reviewSuggestionsExperience }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const openTimestampRef = (0, $cozmU.useRef)(modalOpenTimestamp ?? Date.now());
    const dismissMethodRef = (0, $cozmU.useRef)('close_button');
    const latestValuesRef = (0, $cozmU.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        orderedSuggestions: orderedSuggestions,
        titlesByContentId: titlesByContentId,
        selectedItems: selectedItems,
        rejectedItems: rejectedItems,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestValuesRef.current = {
        spaceId: spaceId,
        spaceKey: spaceKey,
        orderedSuggestions: orderedSuggestions,
        titlesByContentId: titlesByContentId,
        selectedItems: selectedItems,
        rejectedItems: rejectedItems,
        createAnalyticsEvent: createAnalyticsEvent
    };
    const hasFiredScreenEventRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredScreenEventRef.current) return;
        if (isFetchingSuggestions) return;
        hasFiredScreenEventRef.current = true;
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, createAnalyticsEvent: cae } = latestValuesRef.current;
        cae({
            type: 'sendScreenEvent',
            data: {
                name: 'curationModule',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestionCount: suggestions.length
                }
            }
        }).fire();
    }, [
        isFetchingSuggestions
    ]);
    const renderedFilterKeyRef = (0, $cozmU.useRef)(null);
    const observedFetchForKeyRef = (0, $cozmU.useRef)(null);
    const hasConcludedExperienceRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isFetchingSuggestions) {
            observedFetchForKeyRef.current = filterKey;
            return;
        }
        if (isLoading) return;
        if (renderedFilterKeyRef.current === filterKey) return;
        const isInitialRender = renderedFilterKeyRef.current === null;
        if (!isInitialRender && observedFetchForKeyRef.current !== filterKey) return;
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, titlesByContentId: titles, createAnalyticsEvent: cae } = latestValuesRef.current;
        const renderedSuggestions = suggestions.map((s, rankIndex)=>({
                suggestionId: s.id,
                suggestionUrl: s.url,
                sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(s.url),
                providerId: s.providerId,
                rankIndex: rankIndex,
                suggestedParentId: s.parentId,
                reasoningType: (0, $f140ec3197f8db13$export$b647b214edf4111)(s, titles),
                score: s.score
            }));
        renderedFilterKeyRef.current = filterKey;
        cae({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'suggestions',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    modalLoadLatencyMs: Math.max(0, Date.now() - openTimestampRef.current),
                    suggestions: renderedSuggestions,
                    filterKey: isFilterApplied ? filterKey : undefined
                }
            }
        }).fire();
        if (!hasConcludedExperienceRef.current) {
            if (isSuppressed) {
                hasConcludedExperienceRef.current = true;
                reviewSuggestionsExperience.abortNotProvisioned();
            } else if (renderedSuggestions.length > 0) {
                hasConcludedExperienceRef.current = true;
                reviewSuggestionsExperience.succeed();
            } else if (!isFilterApplied) {
                hasConcludedExperienceRef.current = true;
                reviewSuggestionsExperience.fail();
            }
        }
    }, [
        isFetchingSuggestions,
        isLoading,
        filterKey,
        isSuppressed,
        isFilterApplied,
        reviewSuggestionsExperience
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === 'Escape') dismissMethodRef.current = 'escape';
        };
        document.addEventListener('keydown', handleKeyDown);
        return ()=>document.removeEventListener('keydown', handleKeyDown);
    }, []);
    const fireDismissed = (0, $cozmU.useCallback)(()=>{
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, rejectedItems: rejected, createAnalyticsEvent: cae } = latestValuesRef.current;
        const rejectedSuggestions = suggestions.filter((s)=>rejected.has(s.id)).map((s)=>({
                suggestionId: s.id,
                suggestionUrl: s.url,
                sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(s.url),
                providerId: s.providerId
            }));
        cae({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationModule',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestionCountAtDismiss: suggestions.length,
                    dismissMethod: dismissMethodRef.current,
                    timeInModuleMs: Date.now() - openTimestampRef.current,
                    rejectedItemCount: rejected.size,
                    rejectedSuggestions: rejectedSuggestions
                }
            }
        }).fire();
        dismissMethodRef.current = 'close_button';
    }, []);
    const fireAccepted = (0, $cozmU.useCallback)(()=>{
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, titlesByContentId: titles, selectedItems: selected, rejectedItems: rejected, createAnalyticsEvent: cae } = latestValuesRef.current;
        const suggestionAcceptancePayload = (s)=>({
                suggestionId: s.id,
                suggestionUrl: s.url,
                sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(s.url),
                providerId: s.providerId,
                targetFolderId: s.parentId,
                folderWasRecommended: true,
                reasoningType: (0, $f140ec3197f8db13$export$b647b214edf4111)(s, titles),
                score: s.score
            });
        const acceptedSuggestions = suggestions.filter((s)=>selected.has(s.id)).map(suggestionAcceptancePayload);
        const dismissedSuggestions = suggestions.filter((s)=>!selected.has(s.id) && !rejected.has(s.id)).map(suggestionAcceptancePayload);
        const rejectedSuggestions = suggestions.filter((s)=>rejected.has(s.id)).map(suggestionAcceptancePayload);
        cae({
            type: 'sendTrackEvent',
            data: {
                action: 'accepted',
                actionSubject: 'suggestions',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    count: acceptedSuggestions.length,
                    acceptedSuggestions: acceptedSuggestions,
                    dismissedSuggestions: dismissedSuggestions,
                    rejectedSuggestions: rejectedSuggestions
                }
            }
        }).fire();
        acceptedSuggestions.forEach((s)=>{
            cae({
                type: 'sendTrackEvent',
                data: {
                    action: 'createdByFlow',
                    actionSubject: 'content',
                    objectType: 'embed',
                    containerType: 'space',
                    containerId: si,
                    source: 'containerNavigation',
                    attributes: {
                        spaceId: si,
                        spaceKey: sk,
                        contentType: 'embed',
                        flow: 'spaceCuration',
                        suggestionId: s.suggestionId,
                        sourceType: s.sourceType,
                        providerId: s.providerId
                    }
                }
            }).fire();
        });
    }, []);
    const fireSubmitFailed = (0, $cozmU.useCallback)(()=>{
        const { spaceId: si, spaceKey: sk, orderedSuggestions: suggestions, selectedItems: selected, rejectedItems: rejected, createAnalyticsEvent: cae } = latestValuesRef.current;
        const attemptedSuggestionPayload = (s)=>({
                suggestionId: s.id,
                suggestionUrl: s.url,
                sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(s.url),
                providerId: s.providerId
            });
        const acceptedSuggestions = suggestions.filter((s)=>selected.has(s.id)).map(attemptedSuggestionPayload);
        const rejectedSuggestions = suggestions.filter((s)=>rejected.has(s.id)).map(attemptedSuggestionPayload);
        cae({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'suggestions',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    acceptedCount: acceptedSuggestions.length,
                    rejectedCount: rejectedSuggestions.length,
                    acceptedSuggestions: acceptedSuggestions,
                    rejectedSuggestions: rejectedSuggestions
                }
            }
        }).fire();
    }, []);
    return {
        openTimestamp: openTimestampRef.current,
        fireDismissed: fireDismissed,
        fireAccepted: fireAccepted,
        fireSubmitFailed: fireSubmitFailed
    };
}
function $1bc25cf918df8e30$export$180fd386dd30f08f({ spaceId: spaceId, spaceKey: spaceKey, reason: reason, openTimestamp: openTimestamp }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredErrorEventRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredErrorEventRef.current) return;
        hasFiredErrorEventRef.current = true;
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'curationModuleErrorState',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    reason: reason,
                    modalLoadLatencyMs: Math.max(0, Date.now() - openTimestamp)
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        spaceId,
        spaceKey,
        reason,
        openTimestamp
    ]);
}
function $1bc25cf918df8e30$export$39012d7f97d73746({ spaceId: spaceId, spaceKey: spaceKey }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const latestValuesRef = (0, $cozmU.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestValuesRef.current = {
        spaceId: spaceId,
        spaceKey: spaceKey,
        createAnalyticsEvent: createAnalyticsEvent
    };
    const fireSuggestionClicked = (0, $cozmU.useCallback)((suggestion)=>{
        const { spaceId: si, spaceKey: sk, createAnalyticsEvent: cae } = latestValuesRef.current;
        cae({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'suggestion',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestionId: suggestion.id,
                    suggestionUrl: suggestion.url,
                    suggestedParentId: suggestion.parentId,
                    sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(suggestion.url),
                    providerId: suggestion.providerId,
                    score: suggestion.score
                }
            }
        }).fire();
    }, []);
    return {
        fireSuggestionClicked: fireSuggestionClicked
    };
}
const $1bc25cf918df8e30$var$SUGGESTION_PREVIEW_MIN_DWELL_MS = 500;
function $1bc25cf918df8e30$export$92bdbf4fb19eb351({ spaceId: spaceId, spaceKey: spaceKey }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const latestValuesRef = (0, $cozmU.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestValuesRef.current = {
        spaceId: spaceId,
        spaceKey: spaceKey,
        createAnalyticsEvent: createAnalyticsEvent
    };
    const previewedSuggestionRef = (0, $cozmU.useRef)(null);
    const previewStartRef = (0, $cozmU.useRef)(null);
    const firePreviewed = (0, $cozmU.useCallback)(()=>{
        const suggestion = previewedSuggestionRef.current;
        const startedAt = previewStartRef.current;
        previewedSuggestionRef.current = null;
        previewStartRef.current = null;
        if (!suggestion || startedAt === null) return;
        const previewDwellMs = Date.now() - startedAt;
        if (previewDwellMs < $1bc25cf918df8e30$var$SUGGESTION_PREVIEW_MIN_DWELL_MS) return;
        const { spaceId: si, spaceKey: sk, createAnalyticsEvent: cae } = latestValuesRef.current;
        cae({
            type: 'sendUIEvent',
            data: {
                action: 'previewed',
                actionSubject: 'suggestion',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    suggestionId: suggestion.id,
                    suggestionUrl: suggestion.url,
                    suggestedParentId: suggestion.parentId,
                    sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(suggestion.url),
                    providerId: suggestion.providerId,
                    previewDwellMs: previewDwellMs
                }
            }
        }).fire();
    }, []);
    const trackPreviewChange = (0, $cozmU.useCallback)((suggestion)=>{
        if (previewedSuggestionRef.current?.id === suggestion?.id) return;
        firePreviewed();
        previewedSuggestionRef.current = suggestion;
        previewStartRef.current = suggestion ? Date.now() : null;
    }, [
        firePreviewed
    ]);
    const flushPreviewAnalytics = (0, $cozmU.useCallback)(()=>{
        firePreviewed();
    }, [
        firePreviewed
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            firePreviewed();
        };
    }, [
        firePreviewed
    ]);
    return {
        trackPreviewChange: trackPreviewChange,
        flushPreviewAnalytics: flushPreviewAnalytics
    };
}




var $e0Gob = parcelRequire("e0Gob");








var $9KSWX = parcelRequire("9KSWX");

const $5422395b6b83e82b$var$i18n = (0, $kSwu1.defineMessages)({
    internalTesting: {
        id: "space-curation.internal-testing-lozenge",
        defaultMessage: "Internal Testing"
    }
});
const $5422395b6b83e82b$export$4bbb2bbe329f52e4 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "accent-gray"
    }, intl.formatMessage($5422395b6b83e82b$var$i18n.internalTesting));
};






var $iLX84 = parcelRequire("iLX84");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");

const $444ac254b74f8acb$var$CreatorInfoQuery = (0, $iLX84.default)`query useCreatorInfoQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`;
const $444ac254b74f8acb$export$949ad1c6f51713db = (accountIds)=>{
    const [creatorInfoMap, setCreatorInfoMap] = (0, $cozmU.useState)(new Map());
    const uniqueIds = (0, $cozmU.useMemo)(()=>[
            ...new Set(accountIds.filter(Boolean))
        ], [
        accountIds
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (uniqueIds.length === 0) {
            setCreatorInfoMap(new Map());
            return;
        }
        let cancelled = false;
        (async ()=>{
            try {
                const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
                    query: $444ac254b74f8acb$var$CreatorInfoQuery,
                    variables: {
                        accountIds: uniqueIds
                    },
                    forceRelay: false,
                    interopApolloAggClient: true,
                    __callerPackage__: "space-curation"
                });
                if (cancelled) return;
                error?.graphQLErrors?.forEach((e)=>(0, $7Sm4c.markErrorAsHandled)(e));
                const map = new Map();
                if (data?.users) {
                    for (const user of data.users)if (user?.accountId && user.name) map.set(user.accountId, {
                        displayName: user.name,
                        avatarUrl: user.picture || `/wiki/aa-avatar/${user.accountId}`
                    });
                }
                setCreatorInfoMap(map);
            } catch (err) {
                // Non-critical: preview will just not show author info
                if (err instanceof Error) (0, $7Sm4c.markErrorAsHandled)(err);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        uniqueIds
    ]);
    return creatorInfoMap;
};








const $9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_OPERATION = 'LoomVideoThumbnailHydration';
const $9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_QUERY = `
	query LoomVideoThumbnailHydration($ids: [ID!]!) {
		loom_videos(ids: $ids) {
			id
			thumbnails {
				default
				static
			}
		}
	}
`;
/**
 * Returns true if the ARI belongs to a video entity (e.g. Loom).
 * Video ARIs from Data Depot follow the pattern: ari:cloud:graph::video/...
 */ function $9e42ae08d7ac1183$var$isVideoAri(ari) {
    return ari.includes('::video/');
}
/**
 * Extracts the Loom video ID from a loom.com share URL.
 * e.g. "https://www.loom.com/share/abc123" → "abc123"
 */ function $9e42ae08d7ac1183$var$extractLoomVideoId(url) {
    try {
        const parsed = new URL(url);
        if (!parsed.hostname.includes('loom.com')) return null;
        const parts = parsed.pathname.split('/');
        const shareIndex = parts.indexOf('share');
        if (shareIndex >= 0 && shareIndex + 1 < parts.length) return parts[shareIndex + 1];
        return null;
    } catch  {
        return null;
    }
}
/**
 * Constructs a proper Loom video ARI from its components.
 * Format: ari:cloud:loom:{cloudId}:video/activation/{activationId}/{videoId}
 */ function $9e42ae08d7ac1183$var$buildLoomAri(cloudId, activationId, videoId) {
    return `ari:cloud:loom:${cloudId}:video/activation/${activationId}/${videoId}`;
}
/**
 * Fetch fresh Loom video thumbnails directly from AGG's loom_videos query.
 * The suggestions API stores Loom thumbnail URLs from Data Depot with signed tokens
 * that are expired by the time we render them. This function queries AGG's loom_videos
 * field directly to get fresh signed URLs, similar to how SmartLinks resolves Loom thumbnails.
 */ async function $9e42ae08d7ac1183$var$fetchLoomVideoThumbnails(entityIdToUrl, cloudId, activationId) {
    const loomAriToEntityId = new Map();
    for (const [entityId, url] of entityIdToUrl){
        const loomVideoId = $9e42ae08d7ac1183$var$extractLoomVideoId(url);
        if (loomVideoId) {
            const loomAri = $9e42ae08d7ac1183$var$buildLoomAri(cloudId, activationId, loomVideoId);
            loomAriToEntityId.set(loomAri, entityId);
        }
    }
    if (loomAriToEntityId.size === 0) return {
        thumbnails: new Map()
    };
    const loomAris = [
        ...loomAriToEntityId.keys()
    ];
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/graphql?q=${$9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_OPERATION}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_QUERY,
                variables: {
                    ids: loomAris
                },
                operationName: $9e42ae08d7ac1183$var$LOOM_VIDEO_THUMBNAIL_OPERATION
            })
        });
        const json = await response.json();
        if (json.errors?.length) return {
            error: new Error(json.errors.map((e)=>e.message ?? 'GraphQL error').join('; '))
        };
        const thumbnails = new Map();
        // Build a reverse lookup from video ID suffix → entity ID for fallback matching.
        // The returned ARI may have a different activationId than what we sent.
        const videoIdToEntityId = new Map();
        const loomAriEntries = Array.from(loomAriToEntityId.entries());
        for(let i = 0; i < loomAriEntries.length; i++){
            const [loomAri, graphEntityId] = loomAriEntries[i];
            const lastSlash = loomAri.lastIndexOf('/');
            if (lastSlash >= 0) videoIdToEntityId.set(loomAri.substring(lastSlash + 1), graphEntityId);
        }
        const videos = json.data?.loom_videos ?? [];
        for(let i = 0; i < videos.length; i++){
            const video = videos[i];
            const thumbnailUrl = video.thumbnails?.static ?? video.thumbnails?.default;
            if (!video.id || !thumbnailUrl) continue;
            let entityId = loomAriToEntityId.get(video.id);
            if (!entityId) {
                const lastSlash = video.id.lastIndexOf('/');
                const returnedVideoId = lastSlash >= 0 ? video.id.substring(lastSlash + 1) : '';
                entityId = videoIdToEntityId.get(returnedVideoId);
            }
            if (entityId) thumbnails.set(entityId, thumbnailUrl);
        }
        return {
            thumbnails: thumbnails
        };
    } catch (e) {
        return {
            error: e instanceof Error ? e : new Error('Failed to fetch Loom video thumbnails')
        };
    }
}
const $9e42ae08d7ac1183$export$faa6742940bdf3c4 = (suggestions, cloudId, activationId)=>{
    const [state, dispatch] = (0, $cozmU.useReducer)((_prev, next)=>next, {
        thumbnailsByEntityId: new Map(),
        isLoading: false,
        error: null
    });
    // Build a stable key from video entity IDs
    const videoEntries = [];
    for (const s of suggestions)if ($9e42ae08d7ac1183$var$isVideoAri(s.id)) videoEntries.push([
        s.id,
        s.url
    ]);
    const stableKey = JSON.stringify(videoEntries);
    const fetchThumbnails = (0, $cozmU.useCallback)(async ()=>{
        const entries = JSON.parse(stableKey);
        if (entries.length === 0) return;
        const entityIdToUrl = new Map(entries);
        const result = await $9e42ae08d7ac1183$var$fetchLoomVideoThumbnails(entityIdToUrl, cloudId, activationId);
        const hasError = 'error' in result;
        const thumbnails = hasError ? new Map() : result.thumbnails;
        // Preload images so they render instantly when the component uses the URL
        const preloadPromises = [];
        for (const [, url] of thumbnails)preloadPromises.push(new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>resolve();
            img.onerror = ()=>resolve();
            img.src = url;
        }));
        await Promise.all(preloadPromises);
        dispatch({
            thumbnailsByEntityId: thumbnails,
            isLoading: false,
            error: hasError ? result.error : null
        });
    }, [
        stableKey,
        cloudId,
        activationId
    ]);
    (0, $cozmU.useEffect)(()=>{
        fetchThumbnails();
    }, [
        fetchThumbnails
    ]);
    return state;
};


var $90c94b26b50862e3$exports = {};
$90c94b26b50862e3$exports = new URL("preview-thumbnail-fallback.2f93bc33.svg", import.meta.url).toString();






var $10315a023767e43f$exports = {};
$10315a023767e43f$exports = new URL("connect-arrow.348feda5.png", import.meta.url).toString();



var $dJySn = parcelRequire("dJySn");


var $3WMx1 = parcelRequire("3WMx1");

const $e0ce0b995765d610$var$i18n = (0, $kSwu1.defineMessages)({
    addItemsToSpace: {
        id: "space-curation.review-content-suggestions-modal.add-items-to-space",
        defaultMessage: "Add {count, plural, one {# item} other {# items}} to space"
    },
    bringTogetherTitle: {
        id: "space-curation.review-content-suggestions-modal.bring-together-title",
        defaultMessage: "Bring together the content that matters"
    },
    bringTogetherDescription: {
        id: "space-curation.review-content-suggestions-modal.bring-together-description",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "Add these suggestions and they'll be organized in this space."
    },
    internalTestingDisclaimer: {
        id: "space-curation.review-content-suggestions-modal.internal-testing-disclaimer",
        defaultMessage: "This is legacy UI that will not be shipped. It is available internally for quality testing only."
    },
    openSuggestion: {
        id: "space-curation.review-content-suggestions-modal.open-suggestion",
        defaultMessage: "Open {title}"
    },
    untitled: {
        id: "space-curation.review-content-suggestions-modal.untitled",
        defaultMessage: "Untitled"
    },
    loading: {
        id: "space-curation.review-content-suggestions-modal.loading",
        defaultMessage: "Loading"
    },
    submitting: {
        id: "space-curation.review-content-suggestions-modal.submitting",
        defaultMessage: "Adding..."
    },
    rejectSuggestion: {
        id: "space-curation.review-content-suggestions-modal.reject-suggestion",
        defaultMessage: "Reject {title}"
    },
    resetSuggestion: {
        id: "space-curation.review-content-suggestions-modal.reset-suggestion",
        defaultMessage: "Restore suggestion"
    },
    addToThisSpace: {
        id: "space-curation.review-content-suggestions-modal.add-to-this-space",
        defaultMessage: "Add to this space"
    },
    socialSignalRelatedPage: {
        id: "space-curation.review-content-suggestions-modal.social-signal-related-page",
        defaultMessage: "Related to <b>{pageName}</b>"
    },
    rejectSuggestionTooltip: {
        id: "space-curation.review-content-suggestions-modal.reject-suggestion-tooltip",
        defaultMessage: "Reject suggestion"
    },
    uncategorized: {
        id: "space-curation.review-content-suggestions-modal.uncategorized",
        defaultMessage: "Uncategorized"
    },
    closeModal: {
        id: "space-curation.review-content-suggestions-modal.close-modal",
        defaultMessage: "Close"
    },
    topRelevantSuggestions: {
        id: "space-curation.review-content-suggestions-modal.top-relevant-suggestions",
        defaultMessage: "Top 5 most relevant suggestions"
    },
    filterEmptyTitle: {
        id: "space-curation.review-content-suggestions-modal.filter-empty-title",
        defaultMessage: "No suggestions match your filters"
    },
    filterEmptyDescription: {
        id: "space-curation.review-content-suggestions-modal.filter-empty-description",
        defaultMessage: "Try removing your source filters to see all available suggestions."
    },
    filterEmptyClearButton: {
        id: "space-curation.review-content-suggestions-modal.filter-empty-clear-button",
        defaultMessage: "Remove filters"
    },
    errorStateHeader: {
        id: "space-curation.review-content-suggestions-modal.error-state-header",
        defaultMessage: "Something went wrong"
    },
    errorStateDescription: {
        id: "space-curation.review-content-suggestions-modal.error-state-description",
        defaultMessage: "We couldn't load suggestions for this space. Try again, or check your network connection."
    },
    errorStateRetryButton: {
        id: "space-curation.review-content-suggestions-modal.error-state-retry-button",
        defaultMessage: "Try again"
    }
});
const $e0ce0b995765d610$var$MODAL_WIDTH = 'calc(100vw - 192px)';
const $e0ce0b995765d610$var$MODAL_HEIGHT = 'calc(100vh - 128px)';
const $e0ce0b995765d610$var$MODAL_MAX_WIDTH = '1280px';
const $e0ce0b995765d610$var$MODAL_MAX_HEIGHT = '720px';
const $e0ce0b995765d610$var$styles = {
    layout: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _39xV02lz2S _0jFU0V4uAA _1EqgXlnM2E _0NUa3r5m2b",
    leftPanel: "_2mHwu8NHnM _4bt5LAnQyn _2WAcuGnQyn _3YEZNOdnbC _1bHrqE715P _3iDTPbQ4SZ _0aFT5vbt8w _46hvQmp0Oa _0xmtkop0Oa _0LQT5Ep0Oa _03SyCPp0Oa",
    rightPanel: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc _1mT5xdRAKS _0mcu6jyzSk _3kIZMxyzSk _0LQT5Ep0Oa",
    closeButtonWrapper: "_1mT5xdWVPG _2IhTon5zaO _4ApkO25zaO _42Yu6BHOnL",
    groupListScrollArea: "_2O5Vij7dHp _2WAcuGIZbP _3oUqlsYbGa _4kiQYAdnbC",
    groupCard: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8",
    groupRow: "_2mHwu82ADO _46hvQm2ADO _0xmtkoPgdg _0LQT5E8HPE _03SyCP8HPE",
    groupIconSlot: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    groupTitleWrapper: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _4ouGXIdnbC",
    itemsList: "_4bt5LAYvD1 _2WAcuGYvD1 _2Y7lL41Y8M _4kiQYAdnbC _0xmtko1Y8M",
    itemRowContainer: "_23rrnHNQBp _0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _42Yu6BdnbC _39xV02N91d _1eOmH6o126",
    itemRowContainerHovered: "_42Yu6B7dHp",
    suggestionLinkWrapper: "_2mHwu88HPE _2O5Vij7dHp _4ouGXIdnbC _3iDTPbQ4SZ _0hPCNLchRC",
    suggestionLink: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _3TGfC9LRg7 _4ouGXIdnbC _1UtDYzy7kJ _2O5Vij7dHp _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0DCa9Dy7kJ",
    suggestionDescription: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _4ouGXIdnbC",
    suggestionReasonCallout: "_0bjKvD8fU6 _2mHwu82ADO _43nrzT1Y8M _39xV02N91d _0hPCNLchRC",
    suggestionReasonIcon: "_3iDTPbQ4SZ _3YEZNOdnbC _43nrzT1Y8M",
    suggestionIconSlot: "_39xV02UF4f _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    suggestionTitleWrapper: "_4bt5LAnQyn _2WAcuGnQyn _2O5Vij7dHp _4ouGXIdnbC",
    leftPanelHeader: "_0Of8r22ADO",
    contentPreviewContainer: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _2O5Vij7dHp _0hPCNLDIqT _37wbyuDIqT _39xV02N91d _1mT5xdRAKS",
    contentPreviewUnit: "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02N91d _0jFU0Vxf28",
    contentPreviewDecorativeBackground: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC",
    contentPreviewIllustration: "_1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT",
    contentPreviewIconTopLeft: "_2mHwu82ADO _23rrnH0bPn _1mT5xdWVPG _2IhTonuNcX _3OE6xYRxTa _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _42Yu6BAM5m",
    contentPreviewIconBottomRight: "_23rrnH0bPn _1mT5xdWVPG _0Bm75GUF4f _4ApkO2Wvdz _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _42Yu6BAM5m",
    contentPreviewIconVisible: "_1YKVNs7dHp",
    contentPreviewIconHidden: "_1YKVNsdnbC _1pp6NdYbGa",
    contentPreviewSparkle: "_1mT5xdWVPG _2IhTonRxTa _4ApkO2Wvdz _1VJPcakyhv _42Yu6BAM5m",
    contentPreviewGoogleDriveIcon: "_1VJPcaZwt9 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    contentPreviewLoomIcon: "_1VJPcasvOR _0GTcwR9LX5",
    contentPreviewArrowTopLeft: "_1VJPcaP6fN _2xTnZxTbio",
    contentPreviewDarkBlueBox: "_1mT5xdWVPG _39xV02qMLO _0jFU0VIkEs _0KLXruDM2k _1VJPcaUsxL _0Bm75GLYhK _3OE6xYLYhK",
    contentPreviewCard: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ _0aFT5vbt8w _39xV02PyJ7 _0jFU0Vn5H1 _0KLXrulfZc _1mT5xdRAKS",
    contentPreviewImageContainer: "_4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0NUa3rlwhp _3YEZNOdnbC",
    contentPreviewImageFallback: "_39xV02N91d _0jFU0VymWf _0KLXrumhAQ _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    contentPreviewProductLabel: "_3YEZNOdnbC _43nrzTIZbP",
    contentPreviewCardPadding: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4FKVYEkG2W _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0xmtko5zaO _39xV02N91d",
    itemRow: "_2mHwu81Y8M _4c065U2ADO _2Y7lL42ADO _1eOmH6o126",
    unselectedLink: "_0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
    loadingOverlay: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02lz2S _0jFU0V4uAA _1EqgXlnM2E _0NUa3r5m2b",
    errorState: "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02lz2S _0jFU0V4uAA _1EqgXlnM2E _0NUa3r5m2b",
    thumbsDownButton: "_0bjKvDKxmn _4FKVYE1Y8M _23rrnHyKLB _3YEZNOdnbC _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrujOvk _1eOmH6KcZT",
    itemRowContainerRejected: "_0KLXruVrZW",
    suggestionsListHeader: "_0LQT5EPgdg _46hvQm2ADO _03SyCP2ADO",
    filterEmptyState: "_4c065UVa5s _2Y7lL45zaO _2fwxA5DIqT"
};
const $e0ce0b995765d610$var$SuggestionItemRow = ({ spaceKey: spaceKey, suggestion: suggestion, isSelected: isSelected, isRejected: isRejected, onToggleSelectItem: onToggleSelectItem, onRejectItem: onRejectItem, onMoveSuggestion: onMoveSuggestion, onSuggestionHover: onSuggestionHover, onSuggestionClick: onSuggestionClick, titlesByContentId: titlesByContentId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const logoKey = (0, $k8jyJ.getSuggestionLogoKeyFromContentUrl)(suggestion.url); // Tracks immediate mouse-over state for row UI elements (Move button, row highlight)
    const [isRowHovered, setIsRowHovered] = (0, $cozmU.useState)(false);
    const [isMovePopupOpen, setIsMovePopupOpen] = (0, $cozmU.useState)(false);
    const { reasonLabel: reasonLabel, hasReason: hasReason } = (0, $cozmU.useMemo)(()=>{
        const { explanation: explanation, relatedPages: relatedPages } = suggestion;
        const firstRelatedPageId = relatedPages?.[0];
        const relatedPageTitle = firstRelatedPageId ? titlesByContentId.get(String(firstRelatedPageId)) ?? '' : ''; // Reuse the shared resolver so the reason shown here matches the reasoningType logged in analytics.
        const choice = (0, $f140ec3197f8db13$export$b647b214edf4111)(suggestion, titlesByContentId);
        if (choice === null) return {
            reasonLabel: null,
            hasReason: false
        };
        if (choice === 'related') return {
            reasonLabel: formatMessage($e0ce0b995765d610$var$i18n.socialSignalRelatedPage, {
                pageName: relatedPageTitle,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                        weight: "medium",
                        size: "small",
                        color: isRejected ? 'color.text.disabled' : undefined
                    }, chunks)
            }),
            hasReason: true
        };
        return {
            reasonLabel: explanation,
            hasReason: true
        };
    }, [
        suggestion,
        titlesByContentId,
        formatMessage,
        isRejected
    ]); // Clamp the explanation to the number of lines it occupies at rest, so it truncates (rather
    // than wrapping and growing the row) when hover buttons narrow the callout.
    const descRef = (0, $cozmU.useRef)(null);
    const [descLineCount, setDescLineCount] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useLayoutEffect)(()=>{
        // Skip while narrowed (hovered / move-popup open) so the clamp reflects the at-rest width.
        if (!hasReason || isRowHovered || isMovePopupOpen) return;
        const el = descRef.current;
        if (!el) return;
        const measure = ()=>{
            // Line-height comes from the Text (its small-size metrics), not the wrapper Box.
            const textEl = el.firstElementChild ?? el;
            const computed = getComputedStyle(textEl);
            let lineHeight = parseFloat(computed.lineHeight);
            if (!Number.isFinite(lineHeight) || lineHeight <= 0) lineHeight = (parseFloat(computed.fontSize) || 16) * 1.4;
            setDescLineCount(Math.max(1, Math.round(el.scrollHeight / lineHeight)));
        };
        measure();
        if (typeof ResizeObserver === 'undefined') return;
        const resizeObserver = new ResizeObserver(measure);
        resizeObserver.observe(el);
        return ()=>resizeObserver.disconnect();
    }, [
        hasReason,
        reasonLabel,
        isRowHovered,
        isMovePopupOpen
    ]);
    const handleShow = ()=>{
        if (isRejected) return;
        setIsRowHovered(true);
        onSuggestionHover?.(suggestion);
    };
    const handleHide = ()=>{
        if (isRejected) return;
        setIsRowHovered(false);
    };
    const handleMovePopupOpenChange = (open)=>{
        setIsMovePopupOpen(open);
        if (open) handleHide();
    };
    (0, $cozmU.useEffect)(()=>{
        if (!isSelected) {
            handleHide();
            handleMovePopupOpenChange(false);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($e0ce0b995765d610$var$styles.itemRowContainer, !isRejected && isRowHovered && $e0ce0b995765d610$var$styles.itemRowContainerHovered, isRejected && $e0ce0b995765d610$var$styles.itemRowContainerRejected),
        onMouseEnter: handleShow,
        onMouseLeave: handleHide,
        onFocusCapture: handleShow,
        onBlur: (event)=>{
            if (event.currentTarget.contains(event.relatedTarget)) return;
            handleHide();
        },
        testId: `review-content-suggestion-row-${suggestion.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        xcss: $e0ce0b995765d610$var$styles.itemRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.suggestionLinkWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ), {
        style: isRejected ? {
            opacity: 0.5
        } : undefined,
        xcss: $e0ce0b995765d610$var$styles.suggestionIconSlot,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: logoKey,
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: suggestion.url,
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": formatMessage($e0ce0b995765d610$var$i18n.openSuggestion, {
            title: suggestion.title
        }),
        xcss: (0, $w6R6I.cx)($e0ce0b995765d610$var$styles.suggestionLink, !isSelected && $e0ce0b995765d610$var$styles.unselectedLink),
        onClick: ()=>onSuggestionClick?.(suggestion)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.suggestionTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1,
        color: isRejected ? 'color.text.disabled' : undefined
    }, suggestion.title)), hasReason && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $e0ce0b995765d610$var$styles.suggestionReasonCallout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.suggestionReasonIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4w5V7))), {
        label: "",
        size: "small",
        color: isRejected ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtlest, #6B6E76)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: descRef,
        xcss: $e0ce0b995765d610$var$styles.suggestionDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: isRejected ? 'color.text.disabled' : 'color.text.subtle',
        maxLines: descLineCount
    }, reasonLabel))))), !isRejected && (isRowHovered || isMovePopupOpen) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e4c0d2b6b6e18559$export$de484dae570b7c31), {
        suggestionId: suggestion.id,
        spaceKey: spaceKey,
        isOpen: isMovePopupOpen,
        onOpenChange: handleMovePopupOpenChange,
        onMoveSuggestion: onMoveSuggestion,
        fallbackParents: suggestion.fallbackParents,
        currentParentId: suggestion.parentId ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($e0ce0b995765d610$var$i18n.rejectSuggestionTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        xcss: $e0ce0b995765d610$var$styles.thumbsDownButton,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onRejectItem(suggestion.id);
        },
        "aria-label": formatMessage($e0ce0b995765d610$var$i18n.rejectSuggestion, {
            title: suggestion.title
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })))), isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))),
        label: formatMessage($e0ce0b995765d610$var$i18n.resetSuggestion, {
            title: suggestion.title
        }),
        appearance: "subtle",
        spacing: "compact",
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onRejectItem(suggestion.id);
        }
    })), !isRejected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        isChecked: isSelected,
        onChange: ()=>onToggleSelectItem(suggestion.id)
    }))));
};
const $e0ce0b995765d610$var$SuggestionGroupRow = ({ parentTitle: parentTitle, parentType: parentType, suggestions: suggestions, isGroupSelected: isGroupSelected, selectedItems: selectedItems, rejectedItems: rejectedItems, spaceKey: spaceKey, parentId: parentId, toggleSelectGroup: toggleSelectGroup, onToggleSelectItem: onToggleSelectItem, onRejectItem: onRejectItem, onGroupHoverChange: onGroupHoverChange, onMoveSuggestion: onMoveSuggestion, onSuggestionHover: onSuggestionHover, onSuggestionClick: onSuggestionClick, titlesByContentId: titlesByContentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.groupCard,
        onMouseEnter: isGroupSelected ? ()=>onGroupHoverChange(parentId, true) : undefined,
        onMouseLeave: isGroupSelected ? ()=>onGroupHoverChange(parentId, false) : undefined,
        onFocusCapture: isGroupSelected ? ()=>onGroupHoverChange(parentId, true) : undefined,
        onBlur: isGroupSelected ? (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) onGroupHoverChange(parentId, false);
        } : undefined,
        testId: `review-content-suggestion-group-card-${parentId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        xcss: $e0ce0b995765d610$var$styles.groupRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        shouldWrap: false,
        grow: "fill",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.groupIconSlot
    }, parentType === 'page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7A1BE))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.groupTitleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        maxLines: 1
    }, parentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
        isChecked: isGroupSelected,
        onChange: ()=>toggleSelectGroup(suggestions)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.itemsList
    }, suggestions.map((suggestion)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$SuggestionItemRow, {
            key: suggestion.id,
            suggestion: suggestion,
            isSelected: selectedItems.has(suggestion.id),
            isRejected: rejectedItems.has(suggestion.id),
            spaceKey: spaceKey,
            onToggleSelectItem: onToggleSelectItem,
            onRejectItem: onRejectItem,
            onMoveSuggestion: onMoveSuggestion,
            onSuggestionHover: onSuggestionHover,
            onSuggestionClick: onSuggestionClick,
            titlesByContentId: titlesByContentId
        }))));
};
const $e0ce0b995765d610$var$ModalLeftPanel = ({ groupedSuggestionsWithTitles: groupedSuggestionsWithTitles, contentMetaById: contentMetaById, selectedItems: selectedItems, rejectedItems: rejectedItems, toggleSelectGroup: toggleSelectGroup, toggleSelectItem: toggleSelectItem, onRejectItem: onRejectItem, onGroupHoverChange: onGroupHoverChange, onMoveSuggestion: onMoveSuggestion, onSuggestionHover: onSuggestionHover, onSuggestionClick: onSuggestionClick, spaceKey: spaceKey, titlesByContentId: titlesByContentId, onFilterClose: onFilterClose, filterResetKey: filterResetKey, isFilteredEmpty: isFilteredEmpty, onClearFilters: onClearFilters, availableSources: availableSources })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, (0, $6mKj3.expVal)('confluence_autonomous_space_curation_filtering', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: $e0ce0b995765d610$var$styles.suggestionsListHeader,
        testId: "suggestions-list-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage($e0ce0b995765d610$var$i18n.topRelevantSuggestions)), availableSources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a01761abc8be8172$export$21d85d7a6ca378ad), {
        key: filterResetKey,
        onClose: onFilterClose,
        availableSources: availableSources
    })), isFilteredEmpty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.filterEmptyState,
        testId: "suggestions-filter-empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage($e0ce0b995765d610$var$i18n.filterEmptyTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($e0ce0b995765d610$var$i18n.filterEmptyDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClearFilters,
        testId: "suggestions-filter-empty-clear-button"
    }, formatMessage($e0ce0b995765d610$var$i18n.filterEmptyClearButton)))) : [
        ...groupedSuggestionsWithTitles.entries()
    ].map(([parentId, { parentTitle: parentTitle, suggestions: groupSuggestions }])=>{
        const isGroupSelected = groupSuggestions.some((s)=>selectedItems.has(s.id));
        const parentType = parentId !== null ? contentMetaById.get(String(parentId))?.type : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$SuggestionGroupRow, {
            key: String(parentId),
            parentTitle: parentTitle || formatMessage(parentId === null ? $e0ce0b995765d610$var$i18n.uncategorized : $e0ce0b995765d610$var$i18n.untitled),
            parentType: parentType,
            suggestions: groupSuggestions,
            isGroupSelected: isGroupSelected,
            selectedItems: selectedItems,
            rejectedItems: rejectedItems,
            parentId: parentId,
            toggleSelectGroup: toggleSelectGroup,
            onToggleSelectItem: toggleSelectItem,
            onRejectItem: onRejectItem,
            onGroupHoverChange: onGroupHoverChange,
            onMoveSuggestion: onMoveSuggestion,
            onSuggestionHover: onSuggestionHover,
            onSuggestionClick: onSuggestionClick,
            spaceKey: spaceKey,
            titlesByContentId: titlesByContentId
        });
    }));
};
const $e0ce0b995765d610$var$PreviewContent = ({ imageUrl: imageUrl, imageLoading: imageLoading, title: title, description: description, productLogoKey: productLogoKey, authorName: authorName, authorAvatarUrl: authorAvatarUrl })=>{
    const [imageError, setImageError] = (0, $cozmU.useState)(false);
    const [avatarError, setAvatarError] = (0, $cozmU.useState)(false);
    const [imageLoaded, setImageLoaded] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewImageContainer
    }, !imageLoading && (!imageUrl || imageError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewImageFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($90c94b26b50862e3$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "100%"
    })), imageUrl && !imageError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: imageUrl,
        alt: "",
        width: "100%",
        onLoad: ()=>setImageLoaded(true),
        onError: ()=>setImageError(true),
        style: {
            display: imageLoaded ? 'block' : 'none'
        }
    })), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        maxLines: 2
    }, productLogoKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- inline logo alignment can't use xcss
    , {
        style: {
            display: 'inline-flex',
            verticalAlign: '-3px',
            marginRight: '6px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: productLogoKey,
        size: "xxsmall"
    })), title), authorName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, authorAvatarUrl && !avatarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: authorAvatarUrl,
        alt: "",
        width: "16",
        height: "16",
        style: {
            borderRadius: '50%'
        },
        onError: ()=>setAvatarError(true)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, authorName)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 3
    }, description));
};
const $e0ce0b995765d610$var$ModalRightPanel = ({ previewConnection: previewConnection, previewImageUrl: previewImageUrl, previewImageLoading: previewImageLoading, previewTitle: previewTitle, previewDescription: previewDescription, previewProductLogoKey: previewProductLogoKey, previewAuthorName: previewAuthorName, previewAuthorAvatarUrl: previewAuthorAvatarUrl, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showGoogleDrive = !previewConnection || previewConnection === (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE;
    const showLoom = !previewConnection || previewConnection === (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).LOOM;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.rightPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.closeButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($e0ce0b995765d610$var$i18n.closeModal),
        appearance: "subtle",
        onClick: onClose,
        isTooltipDisabled: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewUnit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewDecorativeBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dJySn))),
        alt: "",
        "aria-hidden": "true"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewIllustration
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewDarkBlueBox
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewSparkle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3WMx1))),
        alt: "",
        "aria-hidden": "true",
        width: "75",
        height: "83"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($e0ce0b995765d610$var$styles.contentPreviewIconTopLeft, showGoogleDrive ? $e0ce0b995765d610$var$styles.contentPreviewIconVisible : $e0ce0b995765d610$var$styles.contentPreviewIconHidden)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewGoogleDriveIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: "google-drive",
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewArrowTopLeft
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($10315a023767e43f$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "61",
        height: "36"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($e0ce0b995765d610$var$styles.contentPreviewIconBottomRight, showLoom ? $e0ce0b995765d610$var$styles.contentPreviewIconVisible : $e0ce0b995765d610$var$styles.contentPreviewIconHidden)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewLoomIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: "loom",
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($10315a023767e43f$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "61",
        height: "36"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewCardPadding
    }, previewConnection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$PreviewContent, {
        key: previewImageUrl || previewTitle,
        imageUrl: previewImageUrl,
        imageLoading: previewImageLoading,
        title: previewTitle,
        description: previewDescription,
        productLogoKey: previewProductLogoKey,
        authorName: previewAuthorName,
        authorAvatarUrl: previewAuthorAvatarUrl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0Gob.ContentPreviewPlaceholder), null), previewConnection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.contentPreviewProductLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ConnectionLogo), {
        connection: previewConnection,
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $d46a749dcc1cd83e$export$fc6308b035f32dc)[previewConnection]))))))))));
};
const $e0ce0b995765d610$var$ModalErrorState = ({ onClose: onClose, onRetry: onRetry, spaceId: spaceId, spaceKey: spaceKey, reason: reason, openTimestamp: openTimestamp })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $1bc25cf918df8e30$export$180fd386dd30f08f)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        reason: reason,
        openTimestamp: openTimestamp
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.errorState,
        testId: "review-content-suggestions-modal-error-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.closeButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($e0ce0b995765d610$var$i18n.closeModal),
        appearance: "subtle",
        onClick: onClose,
        isTooltipDisabled: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: formatMessage($e0ce0b995765d610$var$i18n.errorStateHeader),
        description: formatMessage($e0ce0b995765d610$var$i18n.errorStateDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: onRetry
        }, formatMessage($e0ce0b995765d610$var$i18n.errorStateRetryButton)),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $431p7.IllustrationComponent), {
                illustrationKey: "ErrorGeneral",
                alt: "",
                width: 160,
                height: 160
            })
    }));
};
const $e0ce0b995765d610$export$8a4b505874e89d07 = ({ spaceKey: spaceKey, spaceId: spaceId, modalOpenTimestamp: modalOpenTimestamp, onClose: onClose, onSaveSuccess: onSaveSuccess, onDecisionSubmitted: onDecisionSubmitted, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)(); // Source identifiers (provider ARIs) the user has narrowed to. Empty means "no filter".
    const [appliedSources, setAppliedSources] = (0, $cozmU.useState)(()=>[]);
    const [filterResetKey, setFilterResetKey] = (0, $cozmU.useState)(0);
    const [isReapplyingFilters, setIsReapplyingFilters] = (0, $cozmU.useState)(false);
    const isFilterApplied = appliedSources.length > 0;
    const handleFilterPopupClose = (0, $cozmU.useCallback)((sources)=>{
        setAppliedSources(sources);
    }, []);
    const clearFilters = (0, $cozmU.useCallback)(()=>{
        setIsReapplyingFilters(true);
        setAppliedSources([]);
        setFilterResetKey((key)=>key + 1);
    }, []);
    const { groups: groups, isLoading: isFetchingSuggestions, isSuppressed: isSuppressed, refetch: refetch } = (0, $b0a504e05d35a946$export$b1532bcf7c9b2548)(spaceKey, (0, $6mKj3.expVal)('confluence_autonomous_space_curation_filtering', 'isEnabled', false) ? appliedSources : undefined);
    const reviewSuggestionsExperience = (0, $b3f0a9dc40fecba0$export$c8d4c1de2c630478)();
    const [suggestionOverrides, setSuggestionOverrides] = (0, $cozmU.useState)(()=>new Map());
    const allSuggestions = (0, $cozmU.useMemo)(()=>groups.flatMap((g)=>g.remoteObjects).map((s)=>{
            const override = suggestionOverrides.get(s.id);
            return override ? {
                ...s,
                ...override
            } : s;
        }), [
        groups,
        suggestionOverrides
    ]);
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { availableSources: availableSources } = (0, $be72420aa1928141$export$e83bdb5bee7fb6bb)({
        spaceKey: spaceKey,
        cloudId: cloudId,
        skip: !(0, $6mKj3.expVal)('confluence_autonomous_space_curation_filtering', 'isEnabled', false)
    });
    const { thumbnailsByEntityId: loomThumbnails, isLoading: isLoomLoading } = (0, $9e42ae08d7ac1183$export$faa6742940bdf3c4)(allSuggestions, cloudId, activationId);
    const [selectedItems, setSelectedItems] = (0, $cozmU.useState)(()=>new Set());
    const [rejectedItems, setRejectedItems] = (0, $cozmU.useState)(()=>new Set());
    const [_isHoveringGroupList, setIsHoveringGroupList] = (0, $cozmU.useState)(false);
    const [_hoveredParentId, setHoveredParentId] = (0, $cozmU.useState)(null);
    const [hoveredSuggestion, setHoveredSuggestion] = (0, $cozmU.useState)(null);
    const previewConnection = hoveredSuggestion ? (0, $k8jyJ.getConnectionFromContentUrl)(hoveredSuggestion.url) : undefined;
    const [previewParentId, setPreviewParentId] = (0, $cozmU.useState)(groups[0]?.parentId);
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const parentIds = (0, $cozmU.useMemo)(()=>{
        const overriddenIds = [
            ...suggestionOverrides.values()
        ].filter((o)=>o.parentId !== null).map((o)=>String(o.parentId));
        return [
            ...new Set([
                ...groups.filter((g)=>g.parentId !== null).map((g)=>String(g.parentId)),
                ...overriddenIds
            ])
        ];
    }, [
        groups,
        suggestionOverrides
    ]);
    const relatedPageIds = (0, $cozmU.useMemo)(()=>allSuggestions.flatMap((s)=>s.relatedPages ?? []).map((id)=>String(id)).filter(Boolean), [
        allSuggestions
    ]);
    const contentIdsForTitleLookup = (0, $cozmU.useMemo)(()=>[
            ...new Set([
                ...parentIds,
                ...relatedPageIds
            ])
        ], [
        parentIds,
        relatedPageIds
    ]);
    const { titlesByContentId: titlesByContentId, contentMetaById: contentMetaById, isLoading: isLoadingTitles } = (0, $877d8332f9570d6f$export$7610585fadab893e)(contentIdsForTitleLookup);
    const { submitActions: submitActions } = (0, $55e1c5eec5b4b224$export$c9239e53ef385494)({
        spaceKey: spaceKey,
        flags: flags
    });
    const creatorAccountIds = (0, $cozmU.useMemo)(()=>allSuggestions.map((s)=>s.creatorAccountId).filter(Boolean), [
        allSuggestions
    ]);
    const creatorInfoMap = (0, $444ac254b74f8acb$export$949ad1c6f51713db)(creatorAccountIds);
    const hasCompletedInitialLoadRef = (0, $cozmU.useRef)(false);
    if (!isFetchingSuggestions && !isLoadingTitles) hasCompletedInitialLoadRef.current = true;
    const isInitialLoading = !hasCompletedInitialLoadRef.current && (isFetchingSuggestions || isLoadingTitles); // A user-initiated retry from the error state should show the loading view, even though
    // background refetches (post initial load) intentionally do not.
    const [isRetrying, setIsRetrying] = (0, $cozmU.useState)(false);
    const isLoading = isInitialLoading || isSubmitting || isRetrying || isReapplyingFilters;
    const hasFetchedSuggestions = groups.some((group)=>group.remoteObjects.length > 0);
    const wasFetchingSuggestionsRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (isFetchingSuggestions) {
            wasFetchingSuggestionsRef.current = true;
            return;
        }
        if (wasFetchingSuggestionsRef.current || hasFetchedSuggestions) {
            wasFetchingSuggestionsRef.current = false;
            setIsReapplyingFilters(false);
        }
    }, [
        isFetchingSuggestions,
        hasFetchedSuggestions
    ]);
    const isFilteredEmpty = !isLoading && !isSuppressed && !hasFetchedSuggestions && isFilterApplied;
    const showErrorState = !isLoading && (isSuppressed || !hasFetchedSuggestions && !isFilterApplied);
    const handleRetry = (0, $cozmU.useCallback)(async ()=>{
        setIsRetrying(true);
        try {
            await refetch();
        } finally{
            setIsRetrying(false);
        }
    }, [
        refetch
    ]);
    const groupedSuggestionsWithTitles = (0, $cozmU.useMemo)(()=>{
        const originalGroups = new Map();
        const newGroups = new Map();
        const originalParentIds = new Set(groups.map((g)=>g.parentId));
        allSuggestions.forEach((suggestion)=>{
            const pid = suggestion.parentId;
            const isNewGroup = !originalParentIds.has(pid);
            const target = isNewGroup ? newGroups : originalGroups;
            const existing = target.get(pid);
            if (existing) target.set(pid, {
                ...existing,
                suggestions: [
                    ...existing.suggestions,
                    suggestion
                ]
            });
            else target.set(pid, {
                parentTitle: pid !== null ? titlesByContentId.get(String(pid)) ?? '' : '',
                suggestions: [
                    suggestion
                ]
            });
        });
        const nullGroup = originalGroups.get(null);
        if (nullGroup) originalGroups.delete(null);
        const result = new Map([
            ...originalGroups.entries(),
            ...newGroups.entries()
        ]);
        if (nullGroup) result.set(null, nullGroup);
        return result;
    }, [
        allSuggestions,
        titlesByContentId,
        groups
    ]); // The analytics events below log suggestions in the order the user actually sees them, which is
    // the flattened group order (grouped by parent, uncategorized last, moved items relocated) —
    // not the raw fetch order of `allSuggestions`.
    const orderedSuggestions = (0, $cozmU.useMemo)(()=>[
            ...groupedSuggestionsWithTitles.values()
        ].flatMap((group)=>group.suggestions), [
        groupedSuggestionsWithTitles
    ]);
    const { openTimestamp: openTimestamp, fireDismissed: fireDismissed, fireAccepted: fireAccepted, fireSubmitFailed: fireSubmitFailed } = (0, $1bc25cf918df8e30$export$6ec3dc3eba258cc5)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        orderedSuggestions: orderedSuggestions,
        titlesByContentId: titlesByContentId,
        selectedItems: selectedItems,
        rejectedItems: rejectedItems,
        isLoading: isLoading,
        isFetchingSuggestions: isFetchingSuggestions,
        isSuppressed: isSuppressed,
        isFilterApplied: isFilterApplied,
        modalOpenTimestamp: modalOpenTimestamp,
        reviewSuggestionsExperience: reviewSuggestionsExperience,
        filterKey: appliedSources
    });
    const { trackPreviewChange: trackPreviewChange, flushPreviewAnalytics: flushPreviewAnalytics } = (0, $1bc25cf918df8e30$export$92bdbf4fb19eb351)({
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    const { fireSuggestionClicked: fireSuggestionClicked } = (0, $1bc25cf918df8e30$export$39012d7f97d73746)({
        spaceId: spaceId,
        spaceKey: spaceKey
    });
    const handleSuggestionHover = (0, $cozmU.useCallback)((suggestion)=>{
        setHoveredSuggestion(suggestion);
        trackPreviewChange(suggestion);
    }, [
        trackPreviewChange
    ]);
    const handleSuggestionClick = (0, $cozmU.useCallback)((suggestion)=>{
        fireSuggestionClicked(suggestion);
    }, [
        fireSuggestionClicked
    ]);
    const handleClose = async ()=>{
        flushPreviewAnalytics();
        fireDismissed();
        if (rejectedItems.size > 0) {
            const rejectedSuggestions = allSuggestions.filter((s)=>rejectedItems.has(s.id));
            const ok = await submitActions(rejectedSuggestions, new Set(), rejectedItems, {
                showFlags: false
            });
            if (ok && onDecisionSubmitted && (0, $6mKj3.expVal)('confluence_space_curation_decision_feedback', 'isEnabled', false)) onDecisionSubmitted({
                accepted: [],
                rejected: rejectedSuggestions,
                trigger: 'closeWithRejections'
            });
            await onClose(true);
        } else await onClose(false);
    };
    const handleAdd = async ()=>{
        setIsSubmitting(true);
        try {
            const ok = await submitActions(allSuggestions, selectedItems, rejectedItems);
            if (ok) {
                fireAccepted();
                if (onDecisionSubmitted && (0, $6mKj3.expVal)('confluence_space_curation_decision_feedback', 'isEnabled', false)) onDecisionSubmitted({
                    accepted: allSuggestions.filter((s)=>selectedItems.has(s.id)),
                    rejected: allSuggestions.filter((s)=>rejectedItems.has(s.id)),
                    trigger: 'addToSpace'
                });
                const acceptedParentIds = [
                    ...new Set(allSuggestions.filter((s)=>selectedItems.has(s.id)).map((s)=>s.parentId).filter((id)=>id !== null))
                ];
                await onSaveSuccess(acceptedParentIds);
            } else fireSubmitFailed();
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleMoveSuggestion = (0, $cozmU.useCallback)((suggestionId, newParentId)=>{
        setSuggestionOverrides((prev)=>new Map(prev).set(suggestionId, {
                parentId: newParentId
            }));
        setPreviewParentId(newParentId);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (previewParentId === undefined || groups.length === 0) {
            setPreviewParentId(groups[0]?.parentId);
            return;
        }
        if (!groupedSuggestionsWithTitles.has(previewParentId)) setPreviewParentId(groups[0]?.parentId);
    }, [
        groups,
        previewParentId,
        groupedSuggestionsWithTitles
    ]);
    const handleGroupHoverChange = (parentId, isHovering)=>{
        setIsHoveringGroupList(isHovering);
        setHoveredParentId(isHovering ? parentId : null);
        if (isHovering) setPreviewParentId(parentId);
    };
    const toggleSelectItem = (itemId)=>{
        setSelectedItems((prev)=>{
            const next = new Set(prev);
            if (next.has(itemId)) next.delete(itemId);
            else next.add(itemId);
            return next;
        });
    };
    const toggleRejectItem = (itemId)=>{
        setRejectedItems((prev)=>{
            const next = new Set(prev);
            if (next.has(itemId)) next.delete(itemId);
            else {
                // Selecting a reject removes the item from selected
                next.add(itemId);
                setSelectedItems((prevSelected)=>{
                    const nextSelected = new Set(prevSelected);
                    nextSelected.delete(itemId);
                    return nextSelected;
                });
            }
            return next;
        });
    };
    const toggleSelectGroup = (groupSuggestions)=>{
        const allSelected = groupSuggestions.every((s)=>selectedItems.has(s.id));
        setSelectedItems((prev)=>{
            const next = new Set(prev);
            groupSuggestions.forEach((s)=>{
                if (allSelected) next.delete(s.id);
                else next.add(s.id);
            });
            return next;
        });
    };
    let overlayContent = null;
    if (isLoading) overlayContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.loadingOverlay,
        testId: "review-content-suggestions-modal-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        label: isSubmitting ? formatMessage($e0ce0b995765d610$var$i18n.submitting) : formatMessage($e0ce0b995765d610$var$i18n.loading)
    }));
    else if (showErrorState) overlayContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$ModalErrorState, {
        onClose: handleClose,
        onRetry: handleRetry,
        spaceId: spaceId,
        spaceKey: spaceKey,
        reason: isSuppressed ? 'notProvisioned' : 'empty',
        openTimestamp: openTimestamp
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: handleClose,
        width: "auto"
    }, overlayContent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        xcss: $e0ce0b995765d610$var$styles.layout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.leftPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.leftPanelHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        shouldWrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        as: "h1"
    }, formatMessage($e0ce0b995765d610$var$i18n.bringTogetherTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5422395b6b83e82b$export$4bbb2bbe329f52e4), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($e0ce0b995765d610$var$i18n.bringTogetherDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning",
        testId: "review-content-suggestions-modal-internal-testing-disclaimer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($e0ce0b995765d610$var$i18n.internalTestingDisclaimer))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e0ce0b995765d610$var$styles.groupListScrollArea
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$ModalLeftPanel, {
        groupedSuggestionsWithTitles: groupedSuggestionsWithTitles,
        contentMetaById: contentMetaById,
        selectedItems: selectedItems,
        rejectedItems: rejectedItems,
        toggleSelectGroup: toggleSelectGroup,
        toggleSelectItem: toggleSelectItem,
        onRejectItem: toggleRejectItem,
        onGroupHoverChange: handleGroupHoverChange,
        onMoveSuggestion: handleMoveSuggestion,
        onSuggestionHover: handleSuggestionHover,
        onSuggestionClick: handleSuggestionClick,
        spaceKey: spaceKey,
        titlesByContentId: titlesByContentId,
        onFilterClose: handleFilterPopupClose,
        filterResetKey: filterResetKey,
        isFilteredEmpty: isFilteredEmpty,
        onClearFilters: clearFilters,
        availableSources: availableSources
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: ()=>void handleAdd(),
        isDisabled: selectedItems.size === 0
    }, selectedItems.size > 0 ? formatMessage($e0ce0b995765d610$var$i18n.addItemsToSpace, {
        count: selectedItems.size
    }) : formatMessage($e0ce0b995765d610$var$i18n.addToThisSpace)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$var$ModalRightPanel, {
        onClose: handleClose,
        previewImageUrl: hoveredSuggestion ? loomThumbnails.get(hoveredSuggestion.id) ?? hoveredSuggestion.iconUrl : undefined,
        previewImageLoading: isLoomLoading && hoveredSuggestion !== null && hoveredSuggestion.id.includes('::video/') && !loomThumbnails.has(hoveredSuggestion.id),
        previewTitle: hoveredSuggestion?.title,
        previewDescription: hoveredSuggestion?.description,
        previewProductLogoKey: hoveredSuggestion ? (0, $k8jyJ.getSuggestionLogoKeyFromContentUrl)(hoveredSuggestion.url) : undefined,
        previewConnection: previewConnection,
        previewAuthorName: hoveredSuggestion?.creatorAccountId ? creatorInfoMap.get(hoveredSuggestion.creatorAccountId)?.displayName : undefined,
        previewAuthorAvatarUrl: hoveredSuggestion?.creatorAccountId ? creatorInfoMap.get(hoveredSuggestion.creatorAccountId)?.avatarUrl : undefined
    })));
};
const $e0ce0b995765d610$export$c9ce09b966ffa4f7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e0ce0b995765d610$export$8a4b505874e89d07, {
            ...props,
            flags: flags
        }));


/* SuggestionDecisionFeedbackModal.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");

























const $f378d4894d4fbad0$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "space-curation.suggestion-decision-feedback-modal.title",
        defaultMessage: "Help us improve suggestions"
    },
    description: {
        id: "space-curation.suggestion-decision-feedback-modal.description",
        defaultMessage: "Tell us why you made these choices. Every question is optional."
    },
    acceptedHeading: {
        id: "space-curation.suggestion-decision-feedback-modal.accepted-heading",
        defaultMessage: "Added to space"
    },
    rejectedHeading: {
        id: "space-curation.suggestion-decision-feedback-modal.rejected-heading",
        defaultMessage: "Rejected"
    },
    acceptedGroupLabel: {
        id: "space-curation.suggestion-decision-feedback-modal.accepted-group-label",
        defaultMessage: "Why did you add {title}?"
    },
    rejectedGroupLabel: {
        id: "space-curation.suggestion-decision-feedback-modal.rejected-group-label",
        defaultMessage: "Why did you reject {title}?"
    },
    reasonRelevant: {
        id: "space-curation.suggestion-decision-feedback-modal.reason.relevant",
        defaultMessage: "Relevant to this space"
    },
    reasonUseful: {
        id: "space-curation.suggestion-decision-feedback-modal.reason.useful",
        defaultMessage: "Useful for my team"
    },
    reasonGoodLocation: {
        id: "space-curation.suggestion-decision-feedback-modal.reason.good-location",
        defaultMessage: "Suggested location was right"
    },
    reasonUpToDate: {
        id: "space-curation.suggestion-decision-feedback-modal.reason.up-to-date",
        defaultMessage: "Up to date"
    },
    reasonNotRelevant: {
        id: "space-curation.suggestion-decision-feedback-modal.reason.not-relevant",
        defaultMessage: "Not relevant to this space"
    },
    reasonWrongLocation: {
        id: "space-curation.suggestion-decision-feedback-modal.reason.wrong-location",
        defaultMessage: "Wrong location"
    },
    reasonOutdated: {
        id: "space-curation.suggestion-decision-feedback-modal.reason.outdated",
        defaultMessage: "Outdated"
    },
    reasonDuplicate: {
        id: "space-curation.suggestion-decision-feedback-modal.reason.duplicate",
        defaultMessage: "Already in this space"
    },
    reasonShouldNotBeShared: {
        id: "space-curation.suggestion-decision-feedback-modal.reason.should-not-be-shared",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "Shouldn't be shared here"
    },
    skip: {
        id: "space-curation.suggestion-decision-feedback-modal.skip",
        defaultMessage: "Skip"
    },
    submit: {
        id: "space-curation.suggestion-decision-feedback-modal.submit",
        defaultMessage: "Send feedback"
    }
});
const $f378d4894d4fbad0$var$REASONS = {
    accepted: [
        {
            value: 'relevant',
            label: $f378d4894d4fbad0$var$i18n.reasonRelevant
        },
        {
            value: 'useful',
            label: $f378d4894d4fbad0$var$i18n.reasonUseful
        },
        {
            value: 'goodLocation',
            label: $f378d4894d4fbad0$var$i18n.reasonGoodLocation
        },
        {
            value: 'upToDate',
            label: $f378d4894d4fbad0$var$i18n.reasonUpToDate
        }
    ],
    rejected: [
        {
            value: 'notRelevant',
            label: $f378d4894d4fbad0$var$i18n.reasonNotRelevant
        },
        {
            value: 'wrongLocation',
            label: $f378d4894d4fbad0$var$i18n.reasonWrongLocation
        },
        {
            value: 'outdated',
            label: $f378d4894d4fbad0$var$i18n.reasonOutdated
        },
        {
            value: 'duplicate',
            label: $f378d4894d4fbad0$var$i18n.reasonDuplicate
        },
        {
            value: 'shouldNotBeShared',
            label: $f378d4894d4fbad0$var$i18n.reasonShouldNotBeShared
        }
    ]
};
const $f378d4894d4fbad0$var$styles = {
    row: "_4c065U8HPE _4auqkJNvrM _2yjt2x6wH8 _3mHaMX9r67",
    logo: "_3YEZNOdnbC _3iDTPbQ4SZ",
    title: "_4ouGXIdnbC"
};
const $f378d4894d4fbad0$var$SuggestionReasonRow = ({ suggestion: suggestion, decision: decision, selectedReasons: selectedReasons, onToggleReason: onToggleReason })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleChange = (0, $cozmU.useCallback)((event)=>onToggleReason(suggestion.id, event.currentTarget.value), [
        onToggleReason,
        suggestion.id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f378d4894d4fbad0$var$styles.row,
        role: "group",
        "aria-label": formatMessage(decision === 'accepted' ? $f378d4894d4fbad0$var$i18n.acceptedGroupLabel : $f378d4894d4fbad0$var$i18n.rejectedGroupLabel, {
            title: suggestion.title
        }),
        testId: `suggestion-decision-feedback-row-${suggestion.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f378d4894d4fbad0$var$styles.logo,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: (0, $k8jyJ.getSuggestionLogoKeyFromContentUrl)(suggestion.url),
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f378d4894d4fbad0$var$styles.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        maxLines: 1
    }, suggestion.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        rowSpace: "space.050",
        shouldWrap: true
    }, $f378d4894d4fbad0$var$REASONS[decision].map((reason)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            key: reason.value,
            value: reason.value,
            label: formatMessage(reason.label),
            isChecked: selectedReasons.has(reason.value),
            onChange: handleChange
        })))));
};
const $f378d4894d4fbad0$export$20673ad638dbfdbc = ({ decision: decision, spaceId: spaceId, spaceKey: spaceKey, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [reasonsBySuggestionId, setReasonsBySuggestionId] = (0, $cozmU.useState)(()=>new Map());
    const { accepted: accepted, rejected: rejected, trigger: trigger } = decision;
    const hasSelections = reasonsBySuggestionId.size > 0;
    const mountValuesRef = (0, $cozmU.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        decision: decision,
        createAnalyticsEvent: createAnalyticsEvent
    });
    (0, $cozmU.useEffect)(()=>{
        const { spaceId: si, spaceKey: sk, decision: d, createAnalyticsEvent: cae } = mountValuesRef.current;
        cae({
            type: 'sendScreenEvent',
            data: {
                name: 'suggestionFeedbackModal',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    trigger: d.trigger,
                    acceptedCount: d.accepted.length,
                    rejectedCount: d.rejected.length
                }
            }
        }).fire();
    }, []);
    const handleToggleReason = (0, $cozmU.useCallback)((suggestionId, reason)=>{
        setReasonsBySuggestionId((prev)=>{
            const reasons = new Set(prev.get(suggestionId));
            if (reasons.has(reason)) reasons.delete(reason);
            else reasons.add(reason);
            const next = new Map(prev);
            if (reasons.size > 0) next.set(suggestionId, reasons);
            else next.delete(suggestionId);
            return next;
        });
    }, []);
    const handleSkip = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'suggestionFeedbackModal',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    trigger: trigger,
                    hadSelections: hasSelections
                }
            }
        }).fire();
        onClose();
    };
    const handleSubmit = ()=>{
        const toAnsweredPayloads = (suggestions, decisionType)=>suggestions.flatMap((s)=>{
                const reasons = reasonsBySuggestionId.get(s.id);
                return reasons ? [
                    {
                        suggestionId: s.id,
                        sourceType: (0, $k8jyJ.getSuggestionProductKeyFromContentUrl)(s.url),
                        providerId: s.providerId,
                        decision: decisionType,
                        reasons: Array.from(reasons)
                    }
                ] : [];
            });
        const feedback = toAnsweredPayloads(accepted, 'accepted').concat(toAnsweredPayloads(rejected, 'rejected'));
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'submitted',
                actionSubject: 'suggestionFeedback',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    trigger: trigger,
                    acceptedCount: accepted.length,
                    rejectedCount: rejected.length,
                    answeredCount: feedback.length,
                    feedback: feedback
                }
            }
        }).fire();
        onClose();
    };
    const renderSection = (suggestions, decisionType, heading)=>suggestions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            as: "h3"
        }, formatMessage(heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, suggestions.map((s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f378d4894d4fbad0$var$SuggestionReasonRow, {
                key: s.id,
                suggestion: s,
                decision: decisionType,
                selectedReasons: reasonsBySuggestionId.get(s.id) ?? new Set(),
                onToggleReason: handleToggleReason
            }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: handleSkip,
        width: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage($f378d4894d4fbad0$var$i18n.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, formatMessage($f378d4894d4fbad0$var$i18n.description)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, renderSection(accepted, 'accepted', $f378d4894d4fbad0$var$i18n.acceptedHeading), renderSection(rejected, 'rejected', $f378d4894d4fbad0$var$i18n.rejectedHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleSkip
    }, formatMessage($f378d4894d4fbad0$var$i18n.skip)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleSubmit,
        isDisabled: !hasSelections
    }, formatMessage($f378d4894d4fbad0$var$i18n.submit))));
};



var $eKTWO = parcelRequire("eKTWO");

/* StackedContentIcons.tsx generated by @compiled/babel-plugin v3.0.2 */ 














const $715aa91ca8191370$var$ICON_SIZE = {
    small: 'xxsmall',
    medium: 'xsmall',
    large: 'small'
};
const $715aa91ca8191370$var$i18n = (0, $kSwu1.defineMessages)({
    googleDriveIconAlt: {
        id: "space-curation.space-navigation.google-drive-icon.alt",
        defaultMessage: "Google Drive icon"
    },
    onedriveIconAlt: {
        id: "space-curation.space-navigation.onedrive-icon.alt",
        defaultMessage: "OneDrive icon"
    },
    loomIconAlt: {
        id: "space-curation.space-navigation.loom-icon.alt",
        defaultMessage: "Loom icon"
    }
});
const $715aa91ca8191370$var$styles = {
    wrapper: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _2xTnZx2ADO _1RrJLiBwqQ",
    iconSlotFirst: "_0bjKvDKxmn _3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0GTcwRdnbC _1mT5xdRAKS _42Yu6BgtVO _1VJPcahzcQ",
    iconSlotSingle: "_0bjKvDKxmn _3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0GTcwRdnbC _1mT5xdRAKS",
    iconSlotSecond: "_0bjKvDKxmn _3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0GTcwR5UaJ _1mT5xdRAKS _42Yu6B7dHp _1VJPcaiTT8",
    iconSlotThird: "_0bjKvDKxmn _3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0GTcwR5UaJ _1mT5xdRAKS _42Yu6BdnbC"
};
const $715aa91ca8191370$var$ICON_ALT_KEY = {
    'google-drive': 'googleDriveIconAlt',
    onedrive: 'onedriveIconAlt',
    loom: 'loomIconAlt'
};
const $715aa91ca8191370$var$SLOT_STYLES = [
    $715aa91ca8191370$var$styles.iconSlotFirst,
    $715aa91ca8191370$var$styles.iconSlotSecond,
    $715aa91ca8191370$var$styles.iconSlotThird
];
const $715aa91ca8191370$export$8f11c373898e3cd4 = ({ variant: variant = 'small', testId: testId = 'stacked-content-icons', singleIcon: singleIcon, singleIconNode: singleIconNode, icons: icons })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const size = $715aa91ca8191370$var$ICON_SIZE[variant];
    if (singleIconNode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.wrapper,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.iconSlotSingle
    }, singleIconNode));
    if (singleIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.wrapper,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.iconSlotSingle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
        logoKey: singleIcon,
        size: size,
        label: formatMessage($715aa91ca8191370$var$i18n[$715aa91ca8191370$var$ICON_ALT_KEY[singleIcon]])
    })));
    const iconList = icons ?? [
        'google-drive',
        'onedrive'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $715aa91ca8191370$var$styles.wrapper,
        testId: testId
    }, iconList.map((key, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: key,
            xcss: (0, $w6R6I.cx)($715aa91ca8191370$var$SLOT_STYLES[index])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fSlSx.ProductLogo), {
            logoKey: key,
            size: size,
            label: formatMessage($715aa91ca8191370$var$i18n[$715aa91ca8191370$var$ICON_ALT_KEY[key]])
        }))));
};





/* ThirdPartyAuthentication.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $7zxJs = parcelRequire("7zxJs");


var $eEPSE = parcelRequire("eEPSE");


























var $6TaGl = parcelRequire("6TaGl");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");

const $cb6359e6e5610133$var$i18n = (0, $kSwu1.defineMessages)({
    moreOptions: {
        id: "space-curation.close-menu.more-options",
        defaultMessage: "More options"
    },
    remindTomorrow: {
        id: "space-curation.close-menu.remind-tomorrow",
        defaultMessage: "Remind me tomorrow"
    },
    neverShowAgain: {
        id: "space-curation.close-menu.never-show-again",
        defaultMessage: "Never show again"
    }
});
const $cb6359e6e5610133$export$4805c143e51c45b4 = ({ onDismiss: onDismiss, onNeverShowAgain: onNeverShowAgain })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        isOpen: isOpen,
        onOpenChange: ({ isOpen: nextIsOpen })=>setIsOpen(nextIsOpen),
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        ...iconProps,
                        size: "small"
                    }),
                appearance: "subtle",
                spacing: "compact",
                label: intl.formatMessage($cb6359e6e5610133$var$i18n.moreOptions),
                isTooltipDisabled: false
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: ()=>{
            setIsOpen(false);
            onDismiss();
        }
    }, intl.formatMessage($cb6359e6e5610133$var$i18n.remindTomorrow)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: ()=>{
            setIsOpen(false);
            onNeverShowAgain();
        }
    }, intl.formatMessage($cb6359e6e5610133$var$i18n.neverShowAgain))));
};






const $4a7342ec49ac4fa7$export$2c06ec8998ac1741 = ()=>{
    const dismissAction = async ({ neverShowAgain: neverShowAgain = false, remindTomorrow: remindTomorrow = false, undoNeverShowAgain: undoNeverShowAgain = false } = {})=>{
        // Mutually exclusive params, matching backend precedence: undoNeverShowAgain > remindTomorrow > neverShowAgain.
        const params = undoNeverShowAgain ? new URLSearchParams({
            undoNeverShowAgain: 'true'
        }) : remindTomorrow ? new URLSearchParams({
            remindTomorrow: 'true'
        }) : new URLSearchParams({
            neverShowAgain: String(neverShowAgain)
        });
        await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/remote-objects/suggestions/dismiss?${params.toString()}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
    };
    return {
        dismissAction: dismissAction
    };
};







const $225bc84a53ca9cda$var$ThirdPartyAuthenticationModal = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "B_q1L",
    name: "ThirdPartyAuthenticationModal",
    loader: async ()=>(await (parcelRequire("lbRgq"))).ThirdPartyAuthenticationModal
});
const $225bc84a53ca9cda$var$styles = {
    container: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _4FKVYE8HPE _0KLXruVva3 _3138422ADO _1mT5xdRAKS",
    topRow: "_3iDTPbQ4SZ _0hPCNLchRC _37wbyuI7V3 _1DCdHi1Y8M",
    mainAction: "_2mHwu81Y8M _4FKVYEPgdg _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _0KLXrujOvk _39xV02N91d _2fwxA57p2s"
};
const $225bc84a53ca9cda$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "space-curation.space-navigation.third-party-auth.title",
        defaultMessage: "Make the most of docs, sheets, slides, and folders"
    },
    titleGoogleDrive: {
        id: "space-curation.space-navigation.third-party-auth.title-google-drive",
        defaultMessage: "Connect to Google Drive to bring content into your space."
    },
    titleMicrosoft: {
        id: "space-curation.space-navigation.third-party-auth.title-microsoft",
        defaultMessage: "Connect to Microsoft to bring content into your space."
    },
    titleMulti: {
        id: "space-curation.space-navigation.third-party-auth.title-multi",
        defaultMessage: "Connect to apps to bring content into your space."
    },
    connect: {
        id: "space-curation.space-navigation.third-party-auth.connect-apps",
        defaultMessage: "Connect apps"
    },
    connectProvider: {
        id: "space-curation.space-navigation.third-party-auth.connect-provider",
        defaultMessage: "Connect {providerName}"
    },
    successFlagTitle: {
        id: "space-curation.space-navigation.third-party-auth.success-title-v2",
        defaultMessage: "{providerName} connected"
    },
    successFlagDescription: {
        id: "space-curation.space-navigation.third-party-auth.success-description",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We're on it! Rovo is looking for content for this space, check back later."
    },
    cancelledFlagTitle: {
        id: "space-curation.space-navigation.third-party-auth.cancelled-title",
        defaultMessage: "Connection cancelled"
    },
    cancelledFlagDescription: {
        id: "space-curation.space-navigation.third-party-auth.cancelled-description-v2",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "Couldn't connect {providerName}. Please try again."
    },
    errorFlagTitle: {
        id: "space-curation.space-navigation.third-party-auth.error-title",
        defaultMessage: "Connection failed"
    },
    errorFlagDescription: {
        id: "space-curation.space-navigation.third-party-auth.error-description-v2",
        defaultMessage: "Something went wrong connecting {providerName}. Please try again."
    },
    remindTomorrowSuccessTitle: {
        id: "space-curation.space-navigation.third-party-auth.remind-tomorrow.success-title",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "Got it, we'll check back later"
    },
    remindTomorrowSuccessDescription: {
        id: "space-curation.space-navigation.third-party-auth.remind-tomorrow.success-description",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We'll remind you about these suggestions again in 24 hours."
    },
    neverShowAgainSuccessTitle: {
        id: "space-curation.space-navigation.third-party-auth.never-show-again.success-title",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We won't show this again"
    },
    neverShowAgainSuccessDescription: {
        id: "space-curation.space-navigation.third-party-auth.never-show-again.success-description",
        defaultMessage: "You will no longer see curation suggestions in this space."
    },
    dismissErrorTitle: {
        id: "space-curation.space-navigation.third-party-auth.dismiss.error-title",
        defaultMessage: "Something went wrong"
    },
    dismissErrorDescription: {
        id: "space-curation.space-navigation.third-party-auth.dismiss.error-description",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We couldn't update your preference. Please try again."
    }
});
const $225bc84a53ca9cda$export$55683e4280ace85d = ({ unauthenticatedServices: unauthenticatedServices, onThirdPartyAuthRefetch: onThirdPartyAuthRefetch, onAuthSuccess: onAuthSuccess, spaceId: spaceId, mountTimestamp: mountTimestamp })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(true);
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const hasFiredRenderedRef = (0, $cozmU.useRef)(false);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { dismissAction: dismissAction } = (0, $4a7342ec49ac4fa7$export$2c06ec8998ac1741)();
    const eligibleConnectors = (0, $cozmU.useMemo)(()=>(0, $k8jyJ.AUTH_OPTIONS).filter((option)=>unauthenticatedServices[option] && Boolean(unauthenticatedServices[option]?.outboundAuthUrl)), [
        unauthenticatedServices
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isVisible && spaceId && !hasFiredRenderedRef.current) {
            hasFiredRenderedRef.current = true;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'rendered',
                    actionSubject: 'curationEntry',
                    source: 'containerNavigation',
                    attributes: {
                        spaceId: spaceId,
                        spaceKey: spaceKey,
                        entryPoint: 'authEntry',
                        suggestionCount: 0,
                        eligibleConnectors: eligibleConnectors,
                        renderLatencyMs: Date.now() - mountTimestamp
                    }
                }
            }).fire();
        }
    }, [
        isVisible,
        spaceId,
        spaceKey,
        eligibleConnectors,
        createAnalyticsEvent,
        mountTimestamp
    ]);
    const handleDismiss = async (flags)=>{
        if (spaceId) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'authEntry',
                    dismissMethod: 'close_button'
                }
            }
        }).fire();
        try {
            await dismissAction({
                remindTomorrow: true
            });
            setIsVisible(false);
            flags?.showSuccessFlag({
                id: 'space-curation.space-navigation.third-party-auth.remind-tomorrow.success',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.remindTomorrowSuccessTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.remindTomorrowSuccessDescription),
                isAutoDismiss: true
            });
        } catch  {
            // If the dismiss POST fails, keep the card visible so the
            // preference is not silently lost.
            flags?.showErrorFlag({
                id: 'space-curation.space-navigation.third-party-auth.remind-tomorrow.error',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.dismissErrorTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.dismissErrorDescription),
                isAutoDismiss: true
            });
        }
    };
    const handleNeverShowAgain = async (flags)=>{
        if (spaceId) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'authEntry',
                    dismissMethod: 'never_show_again'
                }
            }
        }).fire();
        try {
            await dismissAction({
                neverShowAgain: true
            });
            setIsVisible(false);
            flags?.showSuccessFlag({
                id: 'space-curation.space-navigation.third-party-auth.never-show-again.success',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.neverShowAgainSuccessTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.neverShowAgainSuccessDescription),
                isAutoDismiss: true
            });
        } catch  {
            // If the never-show-again POST fails, keep the card visible so
            // the preference is not silently lost.
            flags?.showErrorFlag({
                id: 'space-curation.space-navigation.third-party-auth.never-show-again.error',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.dismissErrorTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.dismissErrorDescription),
                isAutoDismiss: true
            });
        }
    };
    if (!isVisible || eligibleConnectors.length === 0) return null;
    const getProviderName = (option)=>{
        switch(option){
            case (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE:
                return 'Google Drive';
            case (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT:
                return 'Microsoft';
            default:
                return option;
        }
    };
    const handleConnect = async (option, flags)=>{
        const authUrl = unauthenticatedServices[option]?.outboundAuthUrl;
        if (!authUrl) return;
        const providerName = getProviderName(option);
        try {
            await (0, $eEPSE.auth)(authUrl);
            onAuthSuccess?.(option);
            await onThirdPartyAuthRefetch();
            flags?.showSuccessFlag({
                id: 'space-curation.third-party-auth.success',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.successFlagTitle, {
                    providerName: providerName
                }),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.successFlagDescription),
                isAutoDismiss: true
            });
        } catch (error) {
            if (error instanceof (0, $7zxJs.AuthError) && error.type === 'auth_window_closed') flags?.showWarningFlag({
                id: 'space-curation.third-party-auth.cancelled',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.cancelledFlagTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.cancelledFlagDescription, {
                    providerName: providerName
                }),
                isAutoDismiss: true
            });
            else flags?.showErrorFlag({
                id: 'space-curation.third-party-auth.error',
                title: intl.formatMessage($225bc84a53ca9cda$var$i18n.errorFlagTitle),
                description: intl.formatMessage($225bc84a53ca9cda$var$i18n.errorFlagDescription, {
                    providerName: providerName
                }),
                isAutoDismiss: true
            });
        }
    };
    const singleConnector = eligibleConnectors.length === 1 ? eligibleConnectors[0] : undefined;
    const CONNECTOR_UI = {
        [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE]: {
            singleIcon: 'google-drive',
            titleMessage: intl.formatMessage($225bc84a53ca9cda$var$i18n.titleGoogleDrive)
        },
        [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT]: {
            singleIcon: 'onedrive',
            titleMessage: intl.formatMessage($225bc84a53ca9cda$var$i18n.titleMicrosoft)
        }
    };
    const singleConnectorIcon = singleConnector ? unauthenticatedServices[singleConnector]?.icon : undefined;
    const singleIcon = singleConnector ? CONNECTOR_UI[singleConnector].singleIcon : undefined;
    const titleText = singleConnector ? CONNECTOR_UI[singleConnector].titleMessage : intl.formatMessage($225bc84a53ca9cda$var$i18n.titleMulti);
    const connectText = singleConnector ? intl.formatMessage($225bc84a53ca9cda$var$i18n.connectProvider, {
        providerName: getProviderName(singleConnector)
    }) : intl.formatMessage($225bc84a53ca9cda$var$i18n.connect);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $225bc84a53ca9cda$var$styles.container,
            testId: "space-navigation-third-party-auth"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $225bc84a53ca9cda$var$styles.topRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: $225bc84a53ca9cda$var$styles.mainAction,
            onClick: ()=>{
                if (spaceId) createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'curationEntry',
                        source: 'containerNavigation',
                        attributes: {
                            spaceId: spaceId,
                            spaceKey: spaceKey,
                            entryPoint: 'authEntry',
                            eligibleConnectors: eligibleConnectors
                        }
                    }
                }).fire();
                if (singleConnector) handleConnect(singleConnector, flags);
                else setIsModalOpen(true);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $715aa91ca8191370$export$8f11c373898e3cd4), {
            singleIcon: singleIcon,
            singleIconNode: singleConnectorIcon ? singleConnectorIcon({
                size: 'small'
            }) : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text"
        }, titleText, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5422395b6b83e82b$export$4bbb2bbe329f52e4), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.link"
        }, connectText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb6359e6e5610133$export$4805c143e51c45b4), {
            onDismiss: ()=>void handleDismiss(flags),
            onNeverShowAgain: ()=>void handleNeverShowAgain(flags)
        }))), isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($225bc84a53ca9cda$var$ThirdPartyAuthenticationModal, {
            unauthenticatedServices: unauthenticatedServices,
            onClose: ()=>setIsModalOpen(false),
            onConnect: (option)=>void handleConnect(option, flags)
        })));
};












var $7xVCs = parcelRequire("7xVCs");

const $63396382d074ec43$var$PageTreeForceFetchRegistration = ({ pageTreeStateUpdater: pageTreeStateUpdater, onForceFetchPageIdsChange: onForceFetchPageIdsChange })=>{
    const forceFetchPageIds = (0, $cozmU.useCallback)((pageIds)=>{
        const uniquePageIds = new Set();
        pageIds.forEach((pageId)=>{
            const normalizedPageId = String(pageId);
            if (normalizedPageId) uniquePageIds.add(normalizedPageId);
        });
        uniquePageIds.forEach((pageId)=>{
            pageTreeStateUpdater.setForceFetchPageId(pageId);
        });
    }, [
        pageTreeStateUpdater
    ]);
    (0, $cozmU.useEffect)(()=>{
        onForceFetchPageIdsChange(forceFetchPageIds);
        return ()=>onForceFetchPageIdsChange(null);
    }, [
        forceFetchPageIds,
        onForceFetchPageIdsChange
    ]);
    return null;
};
const $63396382d074ec43$export$16d45ab5eeacae08 = ({ onForceFetchPageIdsChange: onForceFetchPageIdsChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($63396382d074ec43$var$PageTreeForceFetchRegistration, {
            pageTreeStateUpdater: pageTreeStateUpdater,
            onForceFetchPageIdsChange: onForceFetchPageIdsChange
        }));


const $4516149d204af1cd$var$styles = {
    container: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _4FKVYE5zaO _0KLXruVva3 _3138422ADO _1mT5xdRAKS",
    topRow: "_3iDTPbQ4SZ _0hPCNLchRC _37wbyuI7V3 _1DCdHi1Y8M",
    iconsWrapper: "_3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC",
    mainAction: "_2mHwu81Y8M _4FKVYEPgdg _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _0KLXrujOvk _39xV02N91d _2fwxA57p2s"
};
const $4516149d204af1cd$var$i18n = (0, $kSwu1.defineMessages)({
    addContent: {
        id: "space-curation.space-navigation.related-content.add-content",
        defaultMessage: "Add suggested content from your connected work apps"
    },
    addContentAction: {
        id: "space-curation.space-navigation.related-content.add-content-action",
        defaultMessage: "Review and add"
    },
    remindTomorrowSuccessTitle: {
        id: "space-curation.space-navigation.related-content.remind-tomorrow.success-title",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "Got it, we'll check back later"
    },
    remindTomorrowSuccessDescription: {
        id: "space-curation.space-navigation.related-content.remind-tomorrow.success-description",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We'll remind you about these suggestions again in 24 hours."
    },
    neverShowAgainSuccessTitle: {
        id: "space-curation.space-navigation.related-content.never-show-again.success-title",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We won't show this again"
    },
    neverShowAgainSuccessDescription: {
        id: "space-curation.space-navigation.related-content.never-show-again.success-description",
        defaultMessage: "You will no longer see curation suggestions in this space."
    },
    dismissErrorTitle: {
        id: "space-curation.space-navigation.related-content.dismiss.error-title",
        defaultMessage: "Something went wrong"
    },
    dismissErrorDescription: {
        id: "space-curation.space-navigation.related-content.dismiss.error-description",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We couldn't update your preference. Please try again."
    },
    undoAction: {
        id: "space-curation.space-navigation.related-content.never-show-again.undo-action",
        defaultMessage: "Undo"
    }
});
const $4516149d204af1cd$var$SpaceNavigationRelatedContentBody = ({ spaceKey: spaceKey, mountTimestamp: mountTimestamp, suggestionCount: suggestionCount, onDismiss: onDismiss, onNeverShowAgain: onNeverShowAgain, onModalClose: onModalClose, onSaveSuccessRefetch: onSaveSuccessRefetch, onDecisionSubmitted: onDecisionSubmitted, spaceId: spaceId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [modalOpenTimestamp, setModalOpenTimestamp] = (0, $cozmU.useState)(null);
    const isModalOpen = modalOpenTimestamp !== null;
    const forceFetchPageIdsRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const mountValuesRef = (0, $cozmU.useRef)({
        spaceId: spaceId,
        spaceKey: spaceKey,
        suggestionCount: suggestionCount,
        mountTimestamp: mountTimestamp,
        createAnalyticsEvent: createAnalyticsEvent
    });
    (0, $cozmU.useEffect)(()=>{
        const { spaceId: si, spaceKey: sk, suggestionCount: sc, mountTimestamp: mt, createAnalyticsEvent: cae } = mountValuesRef.current;
        cae({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: si,
                    spaceKey: sk,
                    entryPoint: 'suggestionsEntry',
                    suggestionCount: sc,
                    renderLatencyMs: Date.now() - mt
                }
            }
        }).fire();
    }, []);
    const handleDismiss = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'suggestionsEntry',
                    dismissMethod: 'close_button',
                    suggestionCountAtDismiss: suggestionCount
                }
            }
        }).fire();
        onDismiss();
    };
    const handleNeverShowAgain = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'curationEntry',
                source: 'containerNavigation',
                attributes: {
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    entryPoint: 'suggestionsEntry',
                    dismissMethod: 'never_show_again',
                    suggestionCountAtDismiss: suggestionCount
                }
            }
        }).fire();
        onNeverShowAgain();
    };
    const handleOpenModal = ()=>{
        setModalOpenTimestamp(Date.now());
    };
    const handleForceFetchPageIdsChange = (0, $cozmU.useCallback)((forceFetchPageIds)=>{
        forceFetchPageIdsRef.current = forceFetchPageIds;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4516149d204af1cd$var$styles.container,
        testId: "space-navigation-related-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4516149d204af1cd$var$styles.topRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $4516149d204af1cd$var$styles.iconsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $715aa91ca8191370$export$8f11c373898e3cd4), {
        variant: "medium",
        icons: [
            'loom',
            'google-drive',
            'onedrive'
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb6359e6e5610133$export$4805c143e51c45b4), {
        onDismiss: handleDismiss,
        onNeverShowAgain: handleNeverShowAgain
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $4516149d204af1cd$var$styles.mainAction,
        onClick: handleOpenModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, intl.formatMessage($4516149d204af1cd$var$i18n.addContent), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5422395b6b83e82b$export$4bbb2bbe329f52e4), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.link",
        weight: "medium"
    }, intl.formatMessage($4516149d204af1cd$var$i18n.addContentAction)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isModalOpen && modalOpenTimestamp !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0ce0b995765d610$export$c9ce09b966ffa4f7), {
        spaceKey: spaceKey,
        spaceId: spaceId,
        modalOpenTimestamp: modalOpenTimestamp,
        onClose: async (hadRejections)=>{
            setModalOpenTimestamp(null);
            await onModalClose(hadRejections);
        },
        onSaveSuccess: (acceptedParentIds)=>{
            setModalOpenTimestamp(null);
            onSaveSuccessRefetch();
            forceFetchPageIdsRef.current?.(acceptedParentIds);
        },
        onDecisionSubmitted: onDecisionSubmitted
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63396382d074ec43$export$16d45ab5eeacae08), {
        onForceFetchPageIdsChange: handleForceFetchPageIdsChange
    }));
};
const $4516149d204af1cd$export$8372b97ddec977cb = ({ spaceId: spaceId, suggestionCountFragmentRef: suggestionCountFragmentRef })=>suggestionCountFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentFromFragment, {
        spaceId: spaceId,
        suggestionCountFragmentRef: suggestionCountFragmentRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$LegacySpaceNavigationRelatedContent, {
        spaceId: spaceId
    });
const $4516149d204af1cd$var$LegacySpaceNavigationRelatedContent = ({ spaceId: spaceId })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const suggestionCountResult = (0, $eKTWO.useFetchSuggestionCount)({
        spaceKey: spaceKey,
        cloudId: cloudId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentInner, {
        spaceId: spaceId,
        spaceKey: spaceKey,
        cloudId: cloudId,
        suggestionCountResult: suggestionCountResult
    });
};
const $4516149d204af1cd$var$SpaceNavigationRelatedContentFromFragment = ({ spaceId: spaceId, suggestionCountFragmentRef: suggestionCountFragmentRef })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const suggestionCountResult = (0, $eKTWO.useFetchSuggestionCountFromFragment)({
        spaceKey: spaceKey,
        cloudId: cloudId,
        suggestionCountFragmentRef: suggestionCountFragmentRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentInner, {
        spaceId: spaceId,
        spaceKey: spaceKey,
        cloudId: cloudId,
        suggestionCountResult: suggestionCountResult
    });
};
const $4516149d204af1cd$var$ThirdPartyAuthenticationEntry = ({ cloudId: cloudId, spaceId: spaceId, mountTimestamp: mountTimestamp })=>{
    const { unauthenticatedServices: unauthenticatedServices, isLoading: isLoading, refetch: refetch, markOptimisticallyAuthenticated: markOptimisticallyAuthenticated } = (0, $dddab7bf95955fb3$export$3d6949c2295aff10)({
        products: [
            (0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE
        ],
        cloudId: cloudId
    });
    if (isLoading || Object.keys(unauthenticatedServices).length === 0) return null;
    (0, $6mKj3.manuallyLogExpExposure)('confluence_autonomous_space_curation');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $225bc84a53ca9cda$export$55683e4280ace85d), {
        unauthenticatedServices: unauthenticatedServices,
        onThirdPartyAuthRefetch: refetch,
        onAuthSuccess: markOptimisticallyAuthenticated,
        spaceId: spaceId,
        mountTimestamp: mountTimestamp
    });
};
const $4516149d204af1cd$var$SpaceNavigationRelatedContentInner = (props)=>{
    const [decision, setDecision] = (0, $cozmU.useState)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentEntry, {
        ...props,
        onDecisionSubmitted: setDecision
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, decision && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f378d4894d4fbad0$export$20673ad638dbfdbc), {
        decision: decision,
        spaceId: props.spaceId,
        spaceKey: props.spaceKey,
        onClose: ()=>setDecision(null)
    })));
};
const $4516149d204af1cd$var$SpaceNavigationRelatedContentEntry = ({ spaceId: spaceId, spaceKey: spaceKey, cloudId: cloudId, suggestionCountResult: suggestionCountResult, onDecisionSubmitted: onDecisionSubmitted })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(true);
    const mountTimestampRef = (0, $cozmU.useRef)(Date.now());
    const { dismissAction: dismissAction } = (0, $4a7342ec49ac4fa7$export$2c06ec8998ac1741)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { count: count, isLoading: isLoadingCount, isSuppressed: isSuppressed, refetch: refetchSuggestionCount } = suggestionCountResult;
    if (!spaceKey || !isVisible || isLoadingCount || isSuppressed) return null;
    if (count === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$ThirdPartyAuthenticationEntry, {
        cloudId: cloudId,
        spaceId: spaceId,
        mountTimestamp: mountTimestampRef.current
    });
    if (count > 0) {
        (0, $6mKj3.manuallyLogExpExposure)('confluence_autonomous_space_curation');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4516149d204af1cd$var$SpaceNavigationRelatedContentBody, {
                spaceKey: spaceKey,
                mountTimestamp: mountTimestampRef.current,
                suggestionCount: count,
                onDismiss: async ()=>{
                    try {
                        await dismissAction({
                            remindTomorrow: true
                        });
                        setIsVisible(false);
                        flags?.showSuccessFlag({
                            id: 'space-curation.space-navigation.related-content.remind-tomorrow.success',
                            title: intl.formatMessage($4516149d204af1cd$var$i18n.remindTomorrowSuccessTitle),
                            description: intl.formatMessage($4516149d204af1cd$var$i18n.remindTomorrowSuccessDescription),
                            isAutoDismiss: true
                        });
                    } catch  {
                        // If the dismiss POST fails, keep the card visible so the
                        // preference is not silently lost.
                        flags?.showErrorFlag({
                            id: 'space-curation.space-navigation.related-content.remind-tomorrow.error',
                            title: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorTitle),
                            description: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorDescription),
                            isAutoDismiss: true
                        });
                    }
                },
                onNeverShowAgain: async ()=>{
                    try {
                        await dismissAction({
                            neverShowAgain: true
                        });
                        setIsVisible(false);
                        const neverShowAgainSuccessFlagId = 'space-curation.space-navigation.related-content.never-show-again.success';
                        flags?.showSuccessFlag({
                            id: neverShowAgainSuccessFlagId,
                            title: intl.formatMessage($4516149d204af1cd$var$i18n.neverShowAgainSuccessTitle),
                            description: intl.formatMessage($4516149d204af1cd$var$i18n.neverShowAgainSuccessDescription),
                            actions: [
                                {
                                    content: intl.formatMessage($4516149d204af1cd$var$i18n.undoAction),
                                    onClick: async ()=>{
                                        try {
                                            await dismissAction({
                                                undoNeverShowAgain: true
                                            });
                                            setIsVisible(true);
                                            refetchSuggestionCount();
                                            createAnalyticsEvent({
                                                type: 'sendUIEvent',
                                                data: {
                                                    action: 'undoDismiss',
                                                    actionSubject: 'curationEntry',
                                                    source: 'containerNavigation',
                                                    attributes: {
                                                        spaceId: spaceId,
                                                        spaceKey: spaceKey,
                                                        entryPoint: 'suggestionsEntry',
                                                        dismissMethod: 'never_show_again'
                                                    }
                                                }
                                            }).fire();
                                            flags?.hideFlag(neverShowAgainSuccessFlagId);
                                        } catch  {
                                            flags?.showErrorFlag({
                                                id: 'space-curation.space-navigation.related-content.never-show-again.undo.error',
                                                title: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorTitle),
                                                description: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorDescription),
                                                isAutoDismiss: true
                                            });
                                        }
                                    }
                                }
                            ],
                            // No auto-dismiss so the Undo link stays actionable.
                            isAutoDismiss: false
                        });
                    } catch  {
                        // If the never-show-again POST fails, keep the card visible so
                        // the preference is not silently lost.
                        flags?.showErrorFlag({
                            id: 'space-curation.space-navigation.related-content.never-show-again.error',
                            title: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorTitle),
                            description: intl.formatMessage($4516149d204af1cd$var$i18n.dismissErrorDescription),
                            isAutoDismiss: true
                        });
                    }
                },
                onSaveSuccessRefetch: refetchSuggestionCount,
                onDecisionSubmitted: onDecisionSubmitted,
                onModalClose: (hadRejections)=>{
                    if (hadRejections) refetchSuggestionCount();
                },
                spaceId: spaceId
            }));
    }
};



var $9HB34 = parcelRequire("9HB34");


var $3pKmQ = parcelRequire("3pKmQ");




/**
 * @generated SignedSource<<9300299525f528ef70041e8a4735b6fc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $df9dad97eb1f9f95$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "CommonSpaceNavigationContent_space",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "SpaceOperationsFragment"
            },
            {
                "kind": "ScalarField",
                "name": "didContainUserContent"
            }
        ],
        "type": "Space"
    };
}();
$df9dad97eb1f9f95$var$node.hash = "df35b90fbfa838a0cb8503ca2715a1c6";
var $df9dad97eb1f9f95$export$2e2bcd8739ae039 = $df9dad97eb1f9f95$var$node;















var $huaOC = parcelRequire("huaOC");


var $04jMq = parcelRequire("04jMq");

/**
 * @generated SignedSource<<e18d311e5dcb174315def5c0a6f62fe2>>
 * @relayHash e08c660ac5bdc886bb33b567a945aed4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba
const $4d55e7bf74ef8f79$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceViewsControllerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e08c660ac5bdc886bb33b567a945aed4",
            "id": "2f68bbc6eea0c63985373f2abbf778bab314f10c540beac0c6a9175be185fbba",
            "metadata": {},
            "name": "SpaceViewsControllerQuery",
            "operationKind": "query",
            "text": "query SpaceViewsControllerQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$4d55e7bf74ef8f79$var$node.hash = "d33ab2e8cd8e66319f41302e5bdaa679";
var $4d55e7bf74ef8f79$export$2e2bcd8739ae039 = $4d55e7bf74ef8f79$var$node;















var $ds2zu = parcelRequire("ds2zu");


var $fg2tf = parcelRequire("fg2tf");


var $d5um7 = parcelRequire("d5um7");

var $jZuGB = parcelRequire("jZuGB");

var $gMhPZ = parcelRequire("gMhPZ");


var $3qtLb = parcelRequire("3qtLb");








var $b3j2Y = parcelRequire("b3j2Y");








var $k5uAm = parcelRequire("k5uAm");


var $lfFzM = parcelRequire("lfFzM");








var $i28ZW = parcelRequire("i28ZW");


var $j3kZx = parcelRequire("j3kZx");


var $gCFsY = parcelRequire("gCFsY");


var $2vuKf = parcelRequire("2vuKf");





var $bOLC6 = parcelRequire("bOLC6");


var $arWla = parcelRequire("arWla");










const $add9014203bde61c$var$stopOrSucceed = (name, attributes, error, experienceTracker)=>{
    if (error) experienceTracker.stopOnError({
        name: name,
        attributes: attributes,
        error: error
    });
    else experienceTracker.succeed({
        name: name,
        attributes: attributes
    });
};
const $add9014203bde61c$export$122d712fe0dbd67 = ({ loading: loading, error: error, persistenceError: persistenceError, persistenceUpdateLoading: persistenceUpdateLoading, persistenceUpdateError: persistenceUpdateError, spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, canManageContent: canManageContent })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeTrackedFetchMore = (0, $cozmU.useCallback)((fetchMore)=>()=>{
            experienceTracker.start({
                name: (0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE)
            });
            fetchMore();
        }, [
        experienceTracker
    ]);
    const trackedSetSpaceViewsSort = (0, $cozmU.useCallback)((newSort)=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE),
            attributes: {
                prevSort: spaceViewsSort
            }
        });
        setSpaceViewsSort(newSort);
    }, [
        experienceTracker,
        spaceViewsSort,
        setSpaceViewsSort
    ]);
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !persistenceUpdateLoading) {
            const attributes = {
                spaceViewsSort: spaceViewsSort
            };
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_INITIAL_EXPERIENCE), {
                spaceViewsSort: spaceViewsSort,
                canManageContent: canManageContent
            }, error || persistenceError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_CHANGE_EXPERIENCE), attributes, error || persistenceUpdateError, experienceTracker);
            $add9014203bde61c$var$stopOrSucceed((0, $irVI7.SPACE_VIEWS_PAGINATE_EXPERIENCE), attributes, error, experienceTracker);
        }
    }, [
        experienceTracker,
        loading,
        error,
        persistenceError,
        persistenceUpdateLoading,
        persistenceUpdateError,
        spaceViewsSort,
        canManageContent
    ]);
    return {
        makeTrackedFetchMore: makeTrackedFetchMore,
        trackedSetSpaceViewsSort: trackedSetSpaceViewsSort
    };
};



const $5a12275e9873d32f$var$SpaceViews = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-2bnv",
    name: "SpaceViews",
    loader: async ()=>(await (parcelRequire("4AohO"))).SpaceViews
});

const $5a12275e9873d32f$var$PagesItemActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctWVd",
    name: "PagesItemActions",
    loader: async ()=>(await (parcelRequire("24ns6"))).PagesItemActions
});

const $5a12275e9873d32f$var$ContentTreeSearchLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Dl_eE",
    name: "ContentTreeSearchLoader",
    loader: async ()=>(await (parcelRequire("beVTK"))).ContentTreeSearch
});
const $5a12275e9873d32f$var$i18n = (0, $kSwu1.defineMessages)({
    contentTitle: {
        id: "space-views.collapsible-section.title",
        defaultMessage: "Content"
    },
    multiSelectContentTitle: {
        id: "space-views.collapsible-section.title.multi-select",
        defaultMessage: "Multi-select content"
    }
});
const $5a12275e9873d32f$var$SpaceViewsControllerComponent = ({ spaceViewsRootFragmentRef: spaceViewsRootFragmentRef, initialPersistenceData: initialPersistenceData, pageTreeInitialDataFragmentRef: pageTreeInitialDataFragmentRef, onDragDropSuccess: onDragDropSuccess, isPeekingFromBlogs: isPeekingFromBlogs, spaceHasUserContent: spaceHasUserContent, homepageId: homepageId, onContentTreeLoadComplete: onContentTreeLoadComplete, pageTreeFinishedLoading: pageTreeFinishedLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    const { spaceViewsSort: spaceViewsSort, setSpaceViewsSort: setSpaceViewsSort, queryLoading: persistenceLoading, queryError: persistenceError, mutationLoading: persistenceUpdateLoading, mutationError: persistenceUpdateError } = (0, $bOLC6.useSpaceViewsOptions)(spaceKey, isLicensed, initialPersistenceData);
    const forceExpandBecauseViewingContentTree = pageContextContentType !== 'blogpost';
    const [isPageTreeLoading, setIsPageTreeLoading] = (0, $cozmU.useState)(true);
    const [pageTreeError, setPageTreeError] = (0, $cozmU.useState)();
    const [isSpaceViewsLoading, setIsSpaceViewsLoading] = (0, $cozmU.useState)(true);
    const [contentTreeSize, setContentTreeSize] = (0, $cozmU.useState)(0);
    const [isPageTreeEmpty, setIsPageTreeEmpty] = (0, $cozmU.useState)(false);
    const [spaceViewsError, setSpaceViewsError] = (0, $cozmU.useState)();
    const isPageTree = spaceViewsSort === 'TREE';
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    // Ref to the space views menu trigger button in the content header
    const spaceViewsMenuTriggerRef = (0, $cozmU.useRef)(null);
    const { data: data, loading: isSpaceAdminQueryLoading, error: isSpaceAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $4d55e7bf74ef8f79$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false),
        __callerPackage__: "space-views"
    });
    const { canManageContent: canManageContentOp, loading: operationsLoading } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false)
    });
    const loading = persistenceLoading || (isPageTree ? isPageTreeLoading : isSpaceViewsLoading) || isSpaceAdminQueryLoading && !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) || operationsLoading && (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const error = pageTreeError || spaceViewsError || isSpaceAdminQueryError;
    const canManageContent = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? Boolean(canManageContentOp) : Boolean(data?.space?.currentUser?.isAdmin);
    const canManageContentOrSuperAdmin = canManageContent || isSuperAdmin;
    const { trackedSetSpaceViewsSort: trackedSetSpaceViewsSort, makeTrackedFetchMore: makeTrackedFetchMore } = (0, $add9014203bde61c$export$122d712fe0dbd67)({
        loading: loading,
        error: error,
        persistenceError: persistenceError,
        persistenceUpdateLoading: persistenceUpdateLoading,
        persistenceUpdateError: persistenceUpdateError,
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        canManageContent: canManageContent
    });
    const { onEnterHoverTarget: showHoverPageCardOnEnterHoverTarget, closeAllHoverPageCards: closeAllHoverPageCards, startCloseHoverPageCardTimer: startCloseHoverPageCardTimer, clearHoverPageCardTimers: clearHoverPageCardTimers, showHoverPageCardForItem: showHoverPageCardForItem, isHoverPageCardOptedIn: isHoverPageCardOptedIn, onLeaveHoverTarget: onLeaveHoverTarget, onBlurHoverTarget: onBlurHoverTarget } = (0, $k5uAm.useHoverPageCard)(spaceViewsSort);
    const [shouldRenderAfterIcon, setShouldRenderAfterIcon] = (0, $cozmU.useState)(false);
    const onEnterHoverTarget = (0, $cozmU.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        showHoverPageCardOnEnterHoverTarget({
            itemID: itemID,
            isQuickActionsFocused: isQuickActionsFocused,
            hoverPageCardTriggerRef: hoverPageCardTriggerRef,
            isContextualCreateFocused: isContextualCreateFocused
        });
        setShouldRenderAfterIcon(true);
    }, [
        showHoverPageCardOnEnterHoverTarget,
        setShouldRenderAfterIcon
    ]);
    const { isExpanded: isExpanded, onExpansionToggle: onExpansionToggle } = (0, $j3kZx.useSpacePersistentExpansion)({
        sectionName: 'contentTree',
        collapsedByDefault: !forceExpandBecauseViewingContentTree,
        forceExpand: forceExpandBecauseViewingContentTree
    });
    const handleSpaceViewCleared = (0, $cozmU.useCallback)(()=>{
        // Focus the space views menu trigger button in the content header using React ref
        if (spaceViewsMenuTriggerRef.current) spaceViewsMenuTriggerRef.current.focus();
    }, [
        spaceViewsMenuTriggerRef
    ]);
    const renderContentTree = (0, $cozmU.useMemo)(()=>{
        if (persistenceLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arWla.FlexCenter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium"
        }));
        const hoverPageCardProps = {
            onEnterHoverTarget: onEnterHoverTarget,
            closeAllHoverPageCards: closeAllHoverPageCards,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget
        };
        if (isPageTree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$ContentTreeSearchLoader, {
            contentTreeSize: contentTreeSize,
            hideSearchRow: isPageTreeEmpty && spaceHasUserContent,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            isLicensed: isLicensed,
            canManageContentOrSuperAdmin: canManageContentOrSuperAdmin,
            ...hoverPageCardProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qtLb.PageTree), {
            initialDataFragmentRef: pageTreeInitialDataFragmentRef,
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isPeekingFromBlogs,
            isSuperAdmin: isSuperAdmin,
            setIsPageTreeLoading: setIsPageTreeLoading,
            setPageTreeError: setPageTreeError,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            homepageId: homepageId,
            setContentTreeSize: setContentTreeSize,
            setIsPageTreeEmpty: setIsPageTreeEmpty,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            ...hoverPageCardProps
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViews, {
            spaceRootFragmentRef: spaceViewsRootFragmentRef,
            spaceViewsSort: spaceViewsSort,
            setIsSpaceViewsLoading: setIsSpaceViewsLoading,
            setSpaceViewsError: setSpaceViewsError,
            trackedSetSpaceViewsSort: trackedSetSpaceViewsSort,
            makeTrackedFetchMore: makeTrackedFetchMore,
            spaceKey: spaceKey,
            contentId: contentId,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            contentTreeSize: contentTreeSize,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            onSpaceViewCleared: handleSpaceViewCleared,
            ...hoverPageCardProps
        });
    }, [
        persistenceLoading,
        spaceViewsRootFragmentRef,
        pageTreeInitialDataFragmentRef,
        onEnterHoverTarget,
        closeAllHoverPageCards,
        isHoverPageCardOptedIn,
        onLeaveHoverTarget,
        onBlurHoverTarget,
        isPageTree,
        spaceViewsSort,
        trackedSetSpaceViewsSort,
        makeTrackedFetchMore,
        spaceKey,
        contentId,
        shouldRenderAfterIcon,
        contentTreeSize,
        isPageTreeEmpty,
        spaceHasUserContent,
        onContentTreeLoadComplete,
        isLicensed,
        onDragDropSuccess,
        isPeekingFromBlogs,
        isSuperAdmin,
        homepageId,
        canManageContentOrSuperAdmin,
        handleSpaceViewCleared
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5um7.ExpandableMenuItem), {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMhPZ.ExpandableMenuItemTrigger), {
        elemBefore: isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fg2tf))), {
            label: "",
            color: "currentColor"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ds2zu))), {
            label: "",
            color: "currentColor"
        }),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$PagesItemActions, {
            isLicensed: isLicensed,
            edition: edition ?? undefined,
            selection: spaceViewsSort,
            setSelection: trackedSetSpaceViewsSort,
            spaceKey: spaceKey || '',
            expandContentSection: ()=>onExpansionToggle(true),
            onItemClick: ()=>onExpansionToggle(true),
            spaceHasUserContent: spaceHasUserContent,
            isPageTreeEmpty: isPageTreeEmpty,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            canManageContentOrSuperAdmin: canManageContentOrSuperAdmin,
            spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef
        })
    }, isMultiSelectActive ? formatMessage($5a12275e9873d32f$var$i18n.multiSelectContentTitle) : formatMessage($5a12275e9873d32f$var$i18n.contentTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZuGB.ExpandableMenuItemContent), null, renderContentTree, isHoverPageCardOptedIn && showHoverPageCardForItem.itemID ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gCFsY.LazySpaceHoverPageCard), {
        showHoverPageCardForItem: showHoverPageCardForItem,
        closeAllHoverPageCards: closeAllHoverPageCards,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        onBlurHoverTarget: onBlurHoverTarget,
        shouldUseAutomationDiscovery: true,
        key: showHoverPageCardForItem.itemID
    }) : null, persistenceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: persistenceError
    })));
};
const $5a12275e9873d32f$var$SpaceViewsControllerFromFragments = (props)=>{
    const initialPersistenceData = (0, $6SsN4.useFragment)((0, $bOLC6.SpaceViewsOptionsPersistenceFragment), props.spaceViewsPersistenceFragmentRef ?? null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViewsControllerComponent, {
        ...props,
        initialPersistenceData: initialPersistenceData ?? undefined
    });
};
const $5a12275e9873d32f$var$SpaceViewsControllerDataSource = (props)=>props.spaceViewsRootFragmentRef || props.spaceViewsPersistenceFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViewsControllerFromFragments, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViewsControllerComponent, props);
const $5a12275e9873d32f$export$5bb6552a789f7a6f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5a12275e9873d32f$var$SpaceViewsControllerDataSource, props));



var $jzS7A = parcelRequire("jzS7A");





var $hSqtY = parcelRequire("hSqtY");








var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");








const $72da3bb5b7695f3e$var$AgentContextItem = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Jxtoc",
    name: "AgentContextItem",
    loader: async ()=>(await (parcelRequire("6jT5w"))).AgentContextItem
});
const $72da3bb5b7695f3e$var$i18n = (0, $kSwu1.defineMessages)({
    suggestionsHeader: {
        id: "side-navigation.space-navigation.suggestions.header",
        defaultMessage: "Suggestions"
    },
    contentIntelligenceHeader: {
        id: "side-navigation.space-navigation.content-intelligence.header",
        defaultMessage: "Content intelligence"
    },
    contentIntelligenceLabsLozenge: {
        id: "side-navigation.space-navigation.content-intelligence.labs-lozenge",
        defaultMessage: "Labs"
    }
});
const $72da3bb5b7695f3e$export$c9895e116f0cb705 = (0, $df9dad97eb1f9f95$export$2e2bcd8739ae039);
const $72da3bb5b7695f3e$export$7716f65eb5d1a3fd = (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { showShortcutsSection: showShortcutsSection, space: space, spaceKey: spaceKey, quick: quick, homepageId: homepageId, loading: loading, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, onContentTreeLoadComplete: onContentTreeLoadComplete, shortcutsFragmentRef: shortcutsFragmentRef, spaceViewsRootFragmentRef: spaceViewsRootFragmentRef, spaceViewsPersistenceFragmentRef: spaceViewsPersistenceFragmentRef, treeInitialDataFragmentRef: treeInitialDataFragmentRef } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    const t1 = space?.operations;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $i28ZW.hasSpaceOperation)(t1, (0, $i28ZW.MANAGE_CONTENT));
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const canManageContent = t2;
    const isSuggestionsSelected = (0, $dPJCf.useIsOnRoute)((0, $1NBp8.SPACE_SUGGESTIONS));
    let t3;
    if ($[2] !== canManageContent || $[3] !== formatMessage || $[4] !== isAIEarlyAccessEnabled || $[5] !== isSuggestionsSelected || $[6] !== spaceKey) {
        t3 = canManageContent && isAIEarlyAccessEnabled && (0, $6mKj3.expVal)("confluence_space_organizer", "isEnabled", false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: (0, $1NBp8.SPACE_SUGGESTIONS).toUrl({
                spaceKey: spaceKey
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4w5V7))), {
                label: "",
                color: "currentColor"
            }),
            elemAfter: (0, $6mKj3.expVal)("confluence_content_intelligence", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: "discovery",
                isBold: true,
                testId: "space-content-intelligence-new-lozenge"
            }, formatMessage($72da3bb5b7695f3e$var$i18n.contentIntelligenceLabsLozenge)) : undefined,
            "data-testid": "space-suggestions-link",
            isSelected: isSuggestionsSelected
        }, formatMessage((0, $6mKj3.expVal)("confluence_content_intelligence", "isEnabled", false) ? $72da3bb5b7695f3e$var$i18n.contentIntelligenceHeader : $72da3bb5b7695f3e$var$i18n.suggestionsHeader));
        $[2] = canManageContent;
        $[3] = formatMessage;
        $[4] = isAIEarlyAccessEnabled;
        $[5] = isSuggestionsSelected;
        $[6] = spaceKey;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== isSpaceAdmin || $[9] !== quick || $[10] !== shortcutsFragmentRef || $[11] !== showShortcutsSection || $[12] !== space?.id || $[13] !== spaceKey) {
        t4 = showShortcutsSection && (shortcutsFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04jMq.ShortcutsSection), {
            isSpaceAdmin: isSpaceAdmin,
            spaceKey: spaceKey,
            spaceSidebarLinksFragmentRef: shortcutsFragmentRef,
            spaceId: space?.id || null
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04jMq.ShortcutsSection), {
            isSpaceAdmin: isSpaceAdmin,
            spaceKey: spaceKey,
            links: quick,
            spaceId: space?.id || null
        }));
        $[8] = isSpaceAdmin;
        $[9] = quick;
        $[10] = shortcutsFragmentRef;
        $[11] = showShortcutsSection;
        $[12] = space?.id;
        $[13] = spaceKey;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== homepageId || $[16] !== isBlogNavigation || $[17] !== loading || $[18] !== onContentTreeLoadComplete || $[19] !== onDragDropSuccess || $[20] !== pageTreeFinishedLoading || $[21] !== space?.didContainUserContent || $[22] !== spaceKey || $[23] !== spaceViewsPersistenceFragmentRef || $[24] !== spaceViewsRootFragmentRef || $[25] !== treeInitialDataFragmentRef) {
        t5 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-vc": "pageTree",
            "data-testid": "pageTree"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a12275e9873d32f$export$5bb6552a789f7a6f), {
            spaceViewsRootFragmentRef: spaceViewsRootFragmentRef,
            spaceViewsPersistenceFragmentRef: spaceViewsPersistenceFragmentRef,
            pageTreeInitialDataFragmentRef: treeInitialDataFragmentRef,
            key: spaceKey,
            homepageId: homepageId,
            onDragDropSuccess: onDragDropSuccess,
            isPeekingFromBlogs: isBlogNavigation,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            spaceHasUserContent: space?.didContainUserContent,
            pageTreeFinishedLoading: pageTreeFinishedLoading
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
        $[15] = homepageId;
        $[16] = isBlogNavigation;
        $[17] = loading;
        $[18] = onContentTreeLoadComplete;
        $[19] = onDragDropSuccess;
        $[20] = pageTreeFinishedLoading;
        $[21] = space?.didContainUserContent;
        $[22] = spaceKey;
        $[23] = spaceViewsPersistenceFragmentRef;
        $[24] = spaceViewsRootFragmentRef;
        $[25] = treeInitialDataFragmentRef;
        $[26] = t5;
    } else t5 = $[26];
    let t6;
    if ($[27] !== isAIEarlyAccessEnabled || $[28] !== isAdminHubAIEnabled || $[29] !== spaceKey) {
        t6 = isAdminHubAIEnabled && isAIEarlyAccessEnabled && (0, $6mKj3.expValEquals)("cc_space_agents_md_context", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($72da3bb5b7695f3e$var$AgentContextItem, {
            spaceKey: spaceKey
        })) : null;
        $[27] = isAIEarlyAccessEnabled;
        $[28] = isAdminHubAIEnabled;
        $[29] = spaceKey;
        $[30] = t6;
    } else t6 = $[30];
    let t7;
    if ($[31] !== blogsHidden || $[32] !== loading || $[33] !== pageTreeFinishedLoading || $[34] !== space || $[35] !== spaceKey || $[36] !== treeInitialDataFragmentRef) {
        t7 = !loading && !blogsHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jzS7A.BlogTree), {
            initialDataFragmentRef: treeInitialDataFragmentRef,
            spaceKey: spaceKey,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            spaceOperationsRef: (0, $6mKj3.expVal)("confluence_contextual_create_relay_space_ops", "isEnabled", false) ? space : undefined
        });
        $[31] = blogsHidden;
        $[32] = loading;
        $[33] = pageTreeFinishedLoading;
        $[34] = space;
        $[35] = spaceKey;
        $[36] = treeInitialDataFragmentRef;
        $[37] = t7;
    } else t7 = $[37];
    let t8;
    if ($[38] !== t3 || $[39] !== t4 || $[40] !== t5 || $[41] !== t6 || $[42] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4, t5, t6, t7);
        $[38] = t3;
        $[39] = t4;
        $[40] = t5;
        $[41] = t6;
        $[42] = t7;
        $[43] = t8;
    } else t8 = $[43];
    return t8;
};





/**
 * @generated SignedSource<<976d5e06a5e1ec0e9d9e5abdb0c16ab9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a5d9c903e21f4503$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isLicensed"
            }
        ],
        "kind": "Fragment",
        "name": "SpaceHeader_space",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    }
                ]
            },
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "condition": "isLicensed",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SpaceUserMetadata",
                        "kind": "LinkedField",
                        "name": "currentUser",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isAdmin"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isFavourited"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isWatched"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "containsExternalCollaborators"
            }
        ],
        "type": "Space"
    };
}();
$a5d9c903e21f4503$var$node.hash = "eedccc77702d6484eacdc7cac611d939";
var $a5d9c903e21f4503$export$2e2bcd8739ae039 = $a5d9c903e21f4503$var$node;















var $gC2EJ = parcelRequire("gC2EJ");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");




















var $hXDOc = parcelRequire("hXDOc");





var $eWwvy = parcelRequire("eWwvy");





var $j7B9O = parcelRequire("j7B9O");




















var $c9Rq0 = parcelRequire("c9Rq0");





var $cJ0FD = parcelRequire("cJ0FD");


var $57p4j = parcelRequire("57p4j");


var $iDrrr = parcelRequire("iDrrr");





var $3SChL = parcelRequire("3SChL");


var $3Awqk = parcelRequire("3Awqk");


var $2AgON = parcelRequire("2AgON");


var $35Nok = parcelRequire("35Nok");

var $73912064fa3e494e$exports = {};
$73912064fa3e494e$exports = new URL("Spaces.5611c4bd.gif", import.meta.url).toString();


var $18964624cf65ea0e$exports = {};
$18964624cf65ea0e$exports = new URL("Spaces-dark.4ceec6cd.gif", import.meta.url).toString();


var $8540facab6b6ae3f$exports = {};
$8540facab6b6ae3f$exports = new URL("Spaces-placeholder.5b3f2999.png", import.meta.url).toString();


var $ef7ad76e18d21f81$exports = {};
$ef7ad76e18d21f81$exports = new URL("Spaces-placeholder-dark.1c1d1b34.png", import.meta.url).toString();



var $aPGTj = parcelRequire("aPGTj");


var $2K2hA = parcelRequire("2K2hA");


var $6OwHS = parcelRequire("6OwHS");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $f37e6d818dab503c$var$STEP_ID = 'nth-user-orientation-editor-space-spotlight';
const $f37e6d818dab503c$export$febddff29c5b0caa = ({ children: children })=>{
    const { reset: reset, next: next, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($f37e6d818dab503c$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isVisible = currentStep === $f37e6d818dab503c$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($73912064fa3e494e$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($18964624cf65ea0e$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($8540facab6b6ae3f$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($ef7ad76e18d21f81$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $f37e6d818dab503c$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9Rq0.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        dismiss: handleDismiss,
        next: handleNext,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $f37e6d818dab503c$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, (()=>{
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: $f37e6d818dab503c$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aPGTj.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next)))));
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        return (0, $iDrrr.fg)('platform-dst-motion-uplift-spotlight') ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, spotlightCard));
    })())));
};



var $jlIaF = parcelRequire("jlIaF");











var $f6cdQ = parcelRequire("f6cdQ");











var $kz1Yj = parcelRequire("kz1Yj");








var $eGUIL = parcelRequire("eGUIL");

const $39cc7021b1f9471a$export$c915848be66d4457 = (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { showExCoMessaging: t1 } = t0;
    const showExCoMessaging = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { handleScrollToTop: handleScrollToTop } = (0, $eGUIL.useSideNavigation)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleScrollToTop) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "QuickAccess",
                    source: "spaceNavigation",
                    data: {
                        navigationLayer: "global",
                        navigationContainer: "sidebar",
                        navVersion: "4"
                    }
                }
            }).fire();
            handleScrollToTop();
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleScrollToTop;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    const t3 = showExCoMessaging && $39cc7021b1f9471a$var$additionalOffset;
    let t4;
    if ($[3] !== t3) {
        t4 = [
            $39cc7021b1f9471a$var$pressableStyles,
            $39cc7021b1f9471a$var$stickyWrapper,
            t3
        ];
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            borderColor: "transparent"
        };
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.050",
            alignInline: "center",
            alignBlock: "center"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            align: "center",
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $39cc7021b1f9471a$var$i18n.scrollToTopButtonLabel)));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== onClick || $[9] !== t4) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: t4,
            id: "scroll-to-top-button",
            onClick: onClick,
            style: t5
        }, t7);
        $[8] = onClick;
        $[9] = t4;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $39cc7021b1f9471a$var$offsetElement
        });
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9);
        $[12] = t8;
        $[13] = t10;
    } else t10 = $[13];
    return t10;
};
const $39cc7021b1f9471a$var$offsetElement = (0, $buxP3.xcss)({
    //this element keeps the spacing from he negative top margin tha hides the button
    height: '17px',
    width: `100%`,
    display: 'flex'
});
const $39cc7021b1f9471a$var$additionalOffset = (0, $buxP3.xcss)({
    top: `76px`
});
const $39cc7021b1f9471a$var$stickyWrapper = (0, $buxP3.xcss)({
    zIndex: 'card',
    // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
    display: 'flex',
    position: 'sticky',
    top: `62px`,
    // @ts-ignore not assignable to type 'MarginSpace | GlobalValue | undefined'
    marginTop: `-50px`,
    //this hides the button underneath the space header until the ser scrolls down
    marginLeft: `auto`,
    marginRight: 'auto'
});
const $39cc7021b1f9471a$var$pressableStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: 'radius.full',
    paddingInline: 'space.100',
    alignItems: 'center',
    justifyContent: 'center',
    width: '125px',
    height: '32px',
    flexShrink: '0',
    boxShadow: 'elevation.shadow.overlay',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    },
    ':focus': {
        outline: 'color.border.focused'
    }
});
const $39cc7021b1f9471a$var$i18n = (0, $kSwu1.defineMessages)({
    scrollToTopButtonLabel: {
        id: "side-navigation.global.scroll-to-top.button.label",
        defaultMessage: "Back to top"
    }
});















var $gyUf8 = parcelRequire("gyUf8");

















const $476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8HXE5",
    name: "LazySpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("cYvjs"))).SpaceMoreActionsMenuContent
});

const $476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZCfkL",
    name: "LazyRestrictedSpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("cYvjs"))).RestrictedSpaceMoreActionsMenuContent
});
const $476e0e4b3e7f33df$export$cd488ab2b367186 = (props)=>{
    const $ = (0, $bDgLe.c)(20);
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props) {
        t0 = ()=>{
            props.setIsOpen(!props.isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "spaceMoreActionsMenu",
                    source: "spaceNavigation",
                    attributes: {
                        navigationLayer: "container",
                        navigationContainer: "sidebar",
                        navVersion: "4",
                        componentType: "fixedItemButton",
                        itemId: "meatballDropdown",
                        canManageSettingsAutomation: props.canManageSettingsAutomation
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    const onClick = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== props) {
        t1 = (selection)=>(e)=>{
                e.stopPropagation();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "spaceMoreActionsMenuItem",
                        source: "spaceMoreActionsMenu",
                        attributes: {
                            navigationLayer: "container",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "fixedItemAction",
                            itemId: selection,
                            canManageSettingsAutomation: props.canManageSettingsAutomation
                        }
                    }
                }).fire();
                props.setIsOpen(false);
            };
        $[3] = createAnalyticsEvent;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const onMenuItemClicked = t1;
    let t2;
    if ($[6] !== props) {
        t2 = ()=>props.setIsOpen(false);
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== isLoggedIn || $[9] !== onMenuItemClicked || $[10] !== props) {
        t3 = ()=>isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            });
        $[8] = isLoggedIn;
        $[9] = onMenuItemClicked;
        $[10] = props;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onClick || $[13] !== props) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                icon: $476e0e4b3e7f33df$var$_temp,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $476e0e4b3e7f33df$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                isSelected: props.isOpen
            }), props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gyUf8.default), {
                testId: "space-more-actions-menu-blanket",
                isTinted: false,
                shouldAllowClickThrough: !props.isOpen,
                onBlanketClicked: ()=>props.setIsOpen(false)
            }) : null);
        $[12] = onClick;
        $[13] = props;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== props.isOpen || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            isOpen: props.isOpen,
            onClose: t2,
            content: t3,
            trigger: t4,
            placement: "right-start"
        });
        $[15] = props.isOpen;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
};
const $476e0e4b3e7f33df$var$i18n = (0, $kSwu1.defineMessages)({
    moreActions: {
        id: "side-navigation.space-navigation.more-actions",
        defaultMessage: "More actions"
    }
});
function $476e0e4b3e7f33df$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        ...iconProps,
        size: "small"
    });
}



const $6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6-_i-",
    loader: async ()=>(await (parcelRequire("inA63"))).ExternalCollaboratorsSpaceInformationMessage,
    name: 'ExternalCollaboratorsSpaceInformationMessage'
});
const $6f43a2e4204022e9$export$d6e867962d0f60bb = (0, $a5d9c903e21f4503$export$2e2bcd8739ae039);
const $6f43a2e4204022e9$var$MANAGE_USERS = 'manage_users';
const $6f43a2e4204022e9$var$MANAGE_NONLICENSED_USERS = 'manage_nonlicensed_users';
const $6f43a2e4204022e9$var$MANAGE_GUEST_USERS = 'manage_guest_users';
const $6f43a2e4204022e9$var$ARCHIVE = 'archive';
const $6f43a2e4204022e9$var$ADMINISTER = 'administer';
const $6f43a2e4204022e9$var$MANAGE_CONTENT = 'manage_content';
const $6f43a2e4204022e9$var$MANAGE_PUBLIC_LINKS = 'manage_public_links';
const $6f43a2e4204022e9$var$VIEW_ANALYTICS = 'view_analytics';
const $6f43a2e4204022e9$var$SpaceHeaderFromFragment = (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { spaceFragmentRef: spaceFragmentRef, isExternalCollaborator: isExternalCollaborator, externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef } = t0;
    const space = (0, $6SsN4.useFragment)($6f43a2e4204022e9$export$d6e867962d0f60bb, spaceFragmentRef);
    let t1;
    if ($[0] !== space.operations) {
        t1 = space.operations ?? [];
        $[0] = space.operations;
        $[1] = t1;
    } else t1 = $[1];
    const operations = t1;
    const showExCoMessaging = !isExternalCollaborator && space.containsExternalCollaborators;
    const t2 = space.id ?? "";
    const t3 = space.name ?? "";
    const t4 = space.key ?? "";
    const t5 = space.homepage?.id ?? undefined;
    const t6 = `${(0, $jlIaF.CONTEXT_PATH)}${space.icon?.path}`;
    const t7 = Boolean(space.currentUser?.isFavourited);
    const t8 = Boolean(space.currentUser?.isWatched);
    const t9 = space.currentUser?.isAdmin ?? false;
    let t10;
    if ($[2] !== operations) {
        t10 = operations.some($6f43a2e4204022e9$var$_temp);
        $[2] = operations;
        $[3] = t10;
    } else t10 = $[3];
    let t11;
    if ($[4] !== operations) {
        t11 = operations.some($6f43a2e4204022e9$var$_temp2);
        $[4] = operations;
        $[5] = t11;
    } else t11 = $[5];
    let t12;
    if ($[6] !== operations) {
        t12 = operations.some($6f43a2e4204022e9$var$_temp3);
        $[6] = operations;
        $[7] = t12;
    } else t12 = $[7];
    let t13;
    if ($[8] !== operations) {
        t13 = operations.some($6f43a2e4204022e9$var$_temp4);
        $[8] = operations;
        $[9] = t13;
    } else t13 = $[9];
    let t14;
    if ($[10] !== operations) {
        t14 = operations.some($6f43a2e4204022e9$var$_temp5);
        $[10] = operations;
        $[11] = t14;
    } else t14 = $[11];
    const t15 = space.type === "personal";
    const t16 = space.status === "archived";
    let t17;
    if ($[12] !== operations) {
        t17 = operations.some($6f43a2e4204022e9$var$_temp6);
        $[12] = operations;
        $[13] = t17;
    } else t17 = $[13];
    let t18;
    if ($[14] !== operations) {
        t18 = operations.some($6f43a2e4204022e9$var$_temp7);
        $[14] = operations;
        $[15] = t18;
    } else t18 = $[15];
    let t19;
    if ($[16] !== externalCollaboratorsSpaceFragmentRef || $[17] !== showExCoMessaging || $[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15 || $[24] !== t16 || $[25] !== t17 || $[26] !== t18 || $[27] !== t2 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$SpaceHeaderInner, {
            spaceId: t2,
            spaceName: t3,
            spaceKey: t4,
            homepageId: t5,
            iconPath: t6,
            isStarred: t7,
            isWatched: t8,
            isSpaceAdmin: t9,
            canManageSomeUsers: t10,
            canManageSettingsAutomation: t11,
            canManageContent: t12,
            canManagePublicLinks: t13,
            canViewAnalytics: t14,
            isPersonalSpace: t15,
            showExCoMessaging: showExCoMessaging,
            externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef,
            isSpaceArchived: t16,
            hasDeleteSpacePermission: t17,
            hasArchiveSpacePermission: t18
        });
        $[16] = externalCollaboratorsSpaceFragmentRef;
        $[17] = showExCoMessaging;
        $[18] = t10;
        $[19] = t11;
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
        $[23] = t15;
        $[24] = t16;
        $[25] = t17;
        $[26] = t18;
        $[27] = t2;
        $[28] = t3;
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
        $[34] = t9;
        $[35] = t19;
    } else t19 = $[35];
    return t19;
};
const $6f43a2e4204022e9$export$533fb76256978163 = (props)=>{
    const $ = (0, $bDgLe.c)(13);
    if (props.spaceFragmentRef) {
        let t0;
        if ($[0] !== props.externalCollaboratorsSpaceFragmentRef || $[1] !== props.isExternalCollaborator || $[2] !== props.spaceFragmentRef) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$SpaceHeaderFromFragment, {
                spaceFragmentRef: props.spaceFragmentRef,
                isExternalCollaborator: props.isExternalCollaborator,
                externalCollaboratorsSpaceFragmentRef: props.externalCollaboratorsSpaceFragmentRef
            });
            $[0] = props.externalCollaboratorsSpaceFragmentRef;
            $[1] = props.isExternalCollaborator;
            $[2] = props.spaceFragmentRef;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    }
    let containsExternalCollaborators;
    let externalCollaboratorsSpaceFragmentRef;
    let isExternalCollaborator;
    let spaceHeaderProps;
    if ($[4] !== props) {
        ({ isExternalCollaborator: isExternalCollaborator, containsExternalCollaborators: containsExternalCollaborators, externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef, ...spaceHeaderProps } = props);
        $[4] = props;
        $[5] = containsExternalCollaborators;
        $[6] = externalCollaboratorsSpaceFragmentRef;
        $[7] = isExternalCollaborator;
        $[8] = spaceHeaderProps;
    } else {
        containsExternalCollaborators = $[5];
        externalCollaboratorsSpaceFragmentRef = $[6];
        isExternalCollaborator = $[7];
        spaceHeaderProps = $[8];
    }
    const showExCoMessaging = !isExternalCollaborator && containsExternalCollaborators;
    let t0;
    if ($[9] !== externalCollaboratorsSpaceFragmentRef || $[10] !== showExCoMessaging || $[11] !== spaceHeaderProps) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$SpaceHeaderInner, {
            ...spaceHeaderProps,
            showExCoMessaging: showExCoMessaging,
            externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef
        });
        $[9] = externalCollaboratorsSpaceFragmentRef;
        $[10] = showExCoMessaging;
        $[11] = spaceHeaderProps;
        $[12] = t0;
    } else t0 = $[12];
    return t0;
};
const $6f43a2e4204022e9$var$SpaceHeaderInner = (t0)=>{
    const $ = (0, $bDgLe.c)(46);
    const { spaceId: spaceId, spaceName: spaceName, spaceKey: spaceKey, homepageId: homepageId, iconPath: iconPath, isStarred: isStarred, isWatched: isWatched, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, canManageSettingsAutomation: canManageSettingsAutomation, canManageContent: canManageContent, canManagePublicLinks: canManagePublicLinks, canViewAnalytics: canViewAnalytics, isPersonalSpace: isPersonalSpace, showExCoMessaging: showExCoMessaging, isSpaceArchived: isSpaceArchived, hasDeleteSpacePermission: hasDeleteSpacePermission, hasArchiveSpacePermission: hasArchiveSpacePermission, externalCollaboratorsSpaceFragmentRef: externalCollaboratorsSpaceFragmentRef } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId } = t1;
    const isContentArchived = (0, $j7B9O.useIsContentArchived)(contentId);
    const isSelected = (0, $dPJCf.useRouteName)($6f43a2e4204022e9$var$isOnSpaceRouteArgs) || isContentArchived;
    let t2;
    if ($[0] !== homepageId || $[1] !== spaceKey) {
        t2 = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }, homepageId ? {
            query: {
                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: homepageId
            }
        } : undefined);
        $[0] = homepageId;
        $[1] = spaceKey;
        $[2] = t2;
    } else t2 = $[2];
    const spaceOverviewHref = t2;
    let t3;
    if ($[3] !== externalCollaboratorsSpaceFragmentRef || $[4] !== showExCoMessaging || $[5] !== spaceKey) {
        t3 = showExCoMessaging ? (0, $6mKj3.expVal)("cc_perms_fix_guests_css_safari", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54RiZR3 _39xV02N91d"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader, {
            analyticsSource: "spaceHeader",
            messageType: "IN_SPACE",
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            spaceFragmentRef: externalCollaboratorsSpaceFragmentRef,
            isSubtle: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader, {
            analyticsSource: "spaceHeader",
            messageType: "IN_SPACE",
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            spaceFragmentRef: externalCollaboratorsSpaceFragmentRef,
            isSubtle: true
        })) : undefined;
        $[3] = externalCollaboratorsSpaceFragmentRef;
        $[4] = showExCoMessaging;
        $[5] = spaceKey;
        $[6] = t3;
    } else t3 = $[6];
    const description = t3;
    let t4;
    if ($[7] !== createAnalyticsEvent) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "spaceHeader",
                    source: "sideNavigation",
                    attributes: {
                        navVersion: 4
                    }
                }
            }).fire();
        };
        $[7] = createAnalyticsEvent;
        $[8] = t4;
    } else t4 = $[8];
    const onClick = t4;
    const [isMoreActionsOpen, setIsMoreActionsOpen] = (0, $cozmU.useState)(false);
    let t5;
    if ($[9] !== canManageContent || $[10] !== canManagePublicLinks || $[11] !== canManageSettingsAutomation || $[12] !== canManageSomeUsers || $[13] !== canViewAnalytics || $[14] !== hasArchiveSpacePermission || $[15] !== hasDeleteSpacePermission || $[16] !== isMoreActionsOpen || $[17] !== isSpaceAdmin || $[18] !== isSpaceArchived || $[19] !== isStarred || $[20] !== isWatched || $[21] !== spaceId || $[22] !== spaceKey) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $476e0e4b3e7f33df$export$cd488ab2b367186), {
            isOpen: isMoreActionsOpen,
            setIsOpen: setIsMoreActionsOpen,
            spaceId: spaceId,
            spaceKey: spaceKey,
            isStarred: isStarred,
            isWatched: isWatched,
            isSpaceAdmin: isSpaceAdmin,
            canManageSomeUsers: canManageSomeUsers,
            canManageSettingsAutomation: canManageSettingsAutomation,
            canManageContent: canManageContent,
            canManagePublicLinks: canManagePublicLinks,
            canViewAnalytics: canViewAnalytics,
            isSpaceArchived: isSpaceArchived,
            hasDeleteSpacePermission: hasDeleteSpacePermission,
            hasArchiveSpacePermission: hasArchiveSpacePermission
        });
        $[9] = canManageContent;
        $[10] = canManagePublicLinks;
        $[11] = canManageSettingsAutomation;
        $[12] = canManageSomeUsers;
        $[13] = canViewAnalytics;
        $[14] = hasArchiveSpacePermission;
        $[15] = hasDeleteSpacePermission;
        $[16] = isMoreActionsOpen;
        $[17] = isSpaceAdmin;
        $[18] = isSpaceArchived;
        $[19] = isStarred;
        $[20] = isWatched;
        $[21] = spaceId;
        $[22] = spaceKey;
        $[23] = t5;
    } else t5 = $[23];
    const moreActionsMenu = t5;
    let t6;
    if ($[24] !== iconPath || $[25] !== isPersonalSpace || $[26] !== isSpaceAdmin || $[27] !== spaceId || $[28] !== spaceKey) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$EditableSpaceIcon, {
            spaceId: spaceId,
            spaceKey: spaceKey,
            iconPath: iconPath,
            isSpaceAdmin: isSpaceAdmin,
            isPersonalSpace: isPersonalSpace
        });
        $[24] = iconPath;
        $[25] = isPersonalSpace;
        $[26] = isSpaceAdmin;
        $[27] = spaceId;
        $[28] = spaceKey;
        $[29] = t6;
    } else t6 = $[29];
    let t7;
    if ($[30] !== description || $[31] !== isSelected || $[32] !== moreActionsMenu || $[33] !== onClick || $[34] !== spaceName || $[35] !== spaceOverviewHref || $[36] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            href: spaceOverviewHref,
            isSelected: isSelected,
            onClick: onClick,
            elemBefore: t6,
            actions: moreActionsMenu,
            description: description
        }, spaceName);
        $[30] = description;
        $[31] = isSelected;
        $[32] = moreActionsMenu;
        $[33] = onClick;
        $[34] = spaceName;
        $[35] = spaceOverviewHref;
        $[36] = t6;
        $[37] = t7;
    } else t7 = $[37];
    let t8;
    if ($[38] !== spaceOverviewHref || $[39] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $6f43a2e4204022e9$var$stickyWrapper,
            "data-vc": "Nav4-space-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f43a2e4204022e9$var$SpaceHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f37e6d818dab503c$export$febddff29c5b0caa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
            name: "space-header",
            preloadUrl: spaceOverviewHref,
            preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
        }, t7)))));
        $[38] = spaceOverviewHref;
        $[39] = t7;
        $[40] = t8;
    } else t8 = $[40];
    let t9;
    if ($[41] !== showExCoMessaging) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39cc7021b1f9471a$export$c915848be66d4457), {
            showExCoMessaging: showExCoMessaging
        });
        $[41] = showExCoMessaging;
        $[42] = t9;
    } else t9 = $[42];
    let t10;
    if ($[43] !== t8 || $[44] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9);
        $[43] = t8;
        $[44] = t9;
        $[45] = t10;
    } else t10 = $[45];
    return t10;
};
const $6f43a2e4204022e9$var$EditableSpaceIcon = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { spaceId: spaceId, spaceKey: spaceKey, iconPath: iconPath, isSpaceAdmin: isSpaceAdmin, isPersonalSpace: isPersonalSpace } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isDialogOpen, setIsDialogOpen] = (0, $cozmU.useState)(false);
    const [shouldRenderDialog, setShouldRenderDialog] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== iconPath) {
        t1 = iconPath ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: iconPath,
            alt: "",
            "data-testid": "space-icon",
            "data-vc": "space-header-icon-image",
            "data-ssr-placeholder-ignored": true,
            role: "presentation",
            className: (0, $hekY6.default)([
                "_0bjKvDKTcp _39xV02oWWg _0jFU0VoWWg"
            ])
        }) : null;
        $[0] = iconPath;
        $[1] = t1;
    } else t1 = $[1];
    const image = t1;
    const canEdit = isSpaceAdmin && !isPersonalSpace;
    if (!canEdit) return image;
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage($6f43a2e4204022e9$var$i18n.editSpaceDetails);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const editLabel = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== experienceTracker || $[6] !== spaceId || $[7] !== spaceKey) {
        t3 = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            experienceTracker.start({
                name: (0, $irVI7.EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE),
                timeout: 10000
            });
            setShouldRenderDialog(true);
            setIsDialogOpen(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "editSpaceDetails",
                    source: "sideNavSpaceHeader",
                    containerType: "space",
                    containerId: spaceId,
                    attributes: {
                        navVersion: 4,
                        entryPoint: "sideNav",
                        spaceKey: spaceKey
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = experienceTracker;
        $[6] = spaceId;
        $[7] = spaceKey;
        $[8] = t3;
    } else t3 = $[8];
    const onClick = t3;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setShouldRenderDialog(true);
        };
        $[9] = t4;
    } else t4 = $[9];
    const onFocus = t4;
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setShouldRenderDialog(true);
        };
        $[10] = t5;
    } else t5 = $[10];
    const onMouseEnter = t5;
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsDialogOpen(true);
        };
        $[11] = t6;
    } else t6 = $[11];
    const onDialogOpen = t6;
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsDialogOpen(false);
        };
        $[12] = t7;
    } else t7 = $[12];
    const onDialogClose = t7;
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $6f43a2e4204022e9$var$editIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }));
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== editLabel || $[15] !== image || $[16] !== onClick) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? $6f43a2e4204022e9$var$iconButton : $6f43a2e4204022e9$var$iconButtonFallback,
            "aria-label": editLabel,
            onClick: onClick,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter
        }, image, t8);
        $[14] = editLabel;
        $[15] = image;
        $[16] = onClick;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== editLabel || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: editLabel
        }, t9);
        $[18] = editLabel;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== isDialogOpen || $[22] !== shouldRenderDialog || $[23] !== spaceKey) {
        t11 = shouldRenderDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            isOpen: isDialogOpen,
            onOpen: onDialogOpen,
            onClose: onDialogClose,
            entryPoint: "sideNav"
        });
        $[21] = isDialogOpen;
        $[22] = shouldRenderDialog;
        $[23] = spaceKey;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t10 || $[26] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t10, t11);
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
};
const $6f43a2e4204022e9$var$isOnSpaceRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_INDEX).name || routeName === (0, $1NBp8.SPACE_OVERVIEW).name
}; // Safari workaround: the LinkMenuItem `description` slot applies
// `-webkit-line-clamp: 1` which triggers a WebKit bug that clips inline-flex
// children (the "1 guest" button). Nesting our own `-webkit-box` with
// `line-clamp: 2` gives the content enough room that the clamp engine never
// has to truncate, avoiding the bug.
const $6f43a2e4204022e9$var$exCoMessageContainerStyles = null;
const $6f43a2e4204022e9$var$stickyWrapper = (0, $buxP3.xcss)({
    position: 'sticky',
    top: 'space.0',
    zIndex: 'navigation' // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
});
const $6f43a2e4204022e9$var$icon = null;
const $6f43a2e4204022e9$var$iconButton = (0, $buxP3.xcss)({
    border: "var(--ds-space-0, 0px)",
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$iconButtonFallback = (0, $buxP3.xcss)({
    border: 'none',
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$editIconWrapper = (0, $buxP3.xcss)({
    position: 'absolute',
    height: '24px',
    width: '24px',
    top: 'space.0',
    left: 'space.0',
    padding: 'space.050',
    opacity: 0,
    transition: 'opacity 0.5s ease',
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    backgroundColor: 'color.blanket',
    borderRadius: 'radius.medium'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f43a2e4204022e9$var$SpaceHeaderContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0Of8r28HPE _1wydGWdLIE _0KLXrulfZc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $6f43a2e4204022e9$var$i18n = (0, $kSwu1.defineMessages)({
    editSpaceDetails: {
        id: "side-navigation.space-navigation.header.edit-space-details",
        defaultMessage: "Edit space details"
    }
});
function $6f43a2e4204022e9$var$_temp(operation) {
    return operation?.operation === $6f43a2e4204022e9$var$MANAGE_USERS || operation?.operation === $6f43a2e4204022e9$var$MANAGE_NONLICENSED_USERS || operation?.operation === $6f43a2e4204022e9$var$MANAGE_GUEST_USERS;
}
function $6f43a2e4204022e9$var$_temp2(operation_0) {
    return operation_0?.operation === $6f43a2e4204022e9$var$ADMINISTER && operation_0?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp3(operation_1) {
    return operation_1?.operation === $6f43a2e4204022e9$var$MANAGE_CONTENT && operation_1?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp4(operation_2) {
    return operation_2?.operation === $6f43a2e4204022e9$var$MANAGE_PUBLIC_LINKS && operation_2?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp5(operation_3) {
    return operation_3?.operation === $6f43a2e4204022e9$var$VIEW_ANALYTICS && operation_3?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp6(operation_4) {
    return operation_4?.operation === "delete" && operation_4?.targetType === "space";
}
function $6f43a2e4204022e9$var$_temp7(operation_5) {
    return operation_5?.operation === $6f43a2e4204022e9$var$ARCHIVE && operation_5?.targetType === "space";
}



var $ENihE = parcelRequire("ENihE");




/**
 * @generated SignedSource<<1c6387c3ead8cdcd65a8b84d53f56cdf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e00178ae9521a52a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceLinks_spaceSidebarLinks",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "includeHidden",
                    "value": true
                }
            ],
            "concreteType": "SpaceSidebarLink",
            "kind": "LinkedField",
            "name": "main",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "webItemCompleteKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "position"
                },
                {
                    "kind": "ScalarField",
                    "name": "hidden"
                }
            ],
            "storageKey": "main(includeHidden:true)"
        }
    ],
    "type": "SpaceSidebarLinks"
};
$e00178ae9521a52a$var$node.hash = "26e483dae4ed854796f11e515ee4e767";
var $e00178ae9521a52a$export$2e2bcd8739ae039 = $e00178ae9521a52a$var$node;












var $euL71 = parcelRequire("euL71");











var $28oQf = parcelRequire("28oQf");

const $078c23c8ca6acb4f$export$ec7e3f071e25a7f5 = (0, $e00178ae9521a52a$export$2e2bcd8739ae039);
const $078c23c8ca6acb4f$var$SpaceLinksFromFragment = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { spaceSidebarLinksFragmentRef: spaceSidebarLinksFragmentRef } = t0;
    const spaceSidebarLinks = (0, $6SsN4.useFragment)($078c23c8ca6acb4f$export$ec7e3f071e25a7f5, spaceSidebarLinksFragmentRef);
    let result;
    if ($[0] !== spaceSidebarLinks.main) {
        result = [];
        for (const link of spaceSidebarLinks.main ?? [])if (link) result.push(link);
        $[0] = spaceSidebarLinks.main;
        $[1] = result;
    } else result = $[1];
    const links = result;
    let t1;
    if ($[2] !== links) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$SpaceLinksInner, {
            links: links
        });
        $[2] = links;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
const $078c23c8ca6acb4f$export$5ff3b51f9b84be4d = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.links || $[1] !== props.spaceSidebarLinksFragmentRef) {
        t0 = props.spaceSidebarLinksFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$SpaceLinksFromFragment, {
            spaceSidebarLinksFragmentRef: props.spaceSidebarLinksFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$SpaceLinksInner, {
            links: props.links
        });
        $[0] = props.links;
        $[1] = props.spaceSidebarLinksFragmentRef;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $078c23c8ca6acb4f$var$SpaceLinksInner = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { links: links } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremiumEdition = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isPremiumEdition || $[2] !== routeDataRef) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "spaceNavigationItem",
                        source: "containerNavigation",
                        attributes: {
                            navigationLayer: "container",
                            itemId: itemId,
                            selectedItemPageContext: routeDataRef.current?.routeName,
                            navVersion: "4",
                            isPremiumEdition: isPremiumEdition
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = isPremiumEdition;
        $[2] = routeDataRef;
        $[3] = t1;
    } else t1 = $[3];
    const sendItemClickedAnalytics = t1;
    let t2;
    if ($[4] !== sendItemClickedAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$CalendarsLink, {
            key: "calendars-link",
            onClick: sendItemClickedAnalytics("calendars")
        });
        $[4] = sendItemClickedAnalytics;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== sendItemClickedAnalytics) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
            key: "questions-native-link",
            onClick: sendItemClickedAnalytics("questions")
        });
        $[6] = sendItemClickedAnalytics;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== links || $[9] !== t2 || $[10] !== t3) {
        const builtInitemsMapping = {
            [(0, $28oQf.CALENDARS_KEY)]: t2,
            [(0, $28oQf.QUESTIONS_NATIVE_KEY)]: t3
        };
        t4 = links.filter($078c23c8ca6acb4f$var$_temp).slice().sort($078c23c8ca6acb4f$var$_temp2).map((t5)=>{
            const { webItemCompleteKey: webItemCompleteKey } = t5;
            return webItemCompleteKey && builtInitemsMapping[webItemCompleteKey] || null;
        });
        $[8] = links;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    const renderedLinks = t4;
    let t5;
    if ($[12] !== renderedLinks) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderedLinks);
        $[12] = renderedLinks;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
});

const $078c23c8ca6acb4f$var$CalendarsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HaydR",
    name: "CalendarsLink",
    loader: async ()=>(await (parcelRequire("29Vr1"))).CalendarsLink
});

const $078c23c8ca6acb4f$var$QuestionsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8uaMN",
    name: "QuestionsLink",
    loader: async ()=>(await (parcelRequire("3vaGk"))).QuestionsLink
});
function $078c23c8ca6acb4f$var$_temp(link) {
    return !link.hidden;
}
function $078c23c8ca6acb4f$var$_temp2(a, b) {
    return Number(a.position) - Number(b.position);
}



var $aWrnw = parcelRequire("aWrnw");


var $dJFqB = parcelRequire("dJFqB");


var $dGmBZ = parcelRequire("dGmBZ");


const $c83507daffd5a949$var$ErrorView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "NxOnG",
    name: "ErrorView",
    loader: async ()=>(await (parcelRequire("3gezS"))).ErrorView
});

const $c83507daffd5a949$var$SpaceApps = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MuuSQ",
    name: "SpaceApps",
    loader: async ()=>(await (parcelRequire("2Dj8l"))).SpaceApps
});
const $c83507daffd5a949$var$spaceLinksStyles = null;
const $c83507daffd5a949$var$SidebarContent = /*#__PURE__*/ (0, $cozmU.memo)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1wydGWPgdg _1mT5xdRAKS _313842IZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}));
const $c83507daffd5a949$var$relatedContentStyles = {
    container: "_1mT5xdHE3j _0Bm75GdnbC _0KLXrulfZc _1wydGW8HPE _42Yu6B7dHp"
};
const $c83507daffd5a949$var$separatorStyles = null;
const $c83507daffd5a949$var$separatorStylesFallback = null;
const $c83507daffd5a949$export$ec7f7d400376dc53 = (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = (!(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") || !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_space_views_frag_reader") || !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_trees_frag_reader") || !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_creation_frag_reader")) && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$RouteBackedSpaceNavigationContent, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$LegacySpaceNavigationContent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const content = t0;
    let t1;
    if ($[2] !== content || $[3] !== props.navigationProps) {
        t1 = !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_affordances_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dJFqB.SpaceNavigationAffordanceDataProvider), {
            spaceKey: props.navigationProps.spaceKey,
            variables: props.navigationProps.routeReaderVariables
        }, content) : content;
        $[2] = content;
        $[3] = props.navigationProps;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};
const $c83507daffd5a949$var$RouteBackedSpaceNavigationContent = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    let props;
    if ($[0] !== t0) {
        ({ ...props } = t0);
        $[0] = t0;
        $[1] = props;
    } else props = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9HB34.getRelayEnvironment)();
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
            environment: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$RouteBackedSpaceNavigationContentInner, props));
        $[3] = props;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $c83507daffd5a949$var$RouteBackedSpaceNavigationContentInner = (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    let navigationProps;
    let props;
    if ($[0] !== t0) {
        ({ navigationProps: navigationProps, ...props } = t0);
        $[0] = t0;
        $[1] = navigationProps;
        $[2] = props;
    } else {
        navigationProps = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            fetchPolicy: "store-only"
        };
        $[3] = t1;
    } else t1 = $[3];
    const routeData = (0, $6SsN4.useLazyLoadQuery)((0, $dGmBZ.default), navigationProps.routeReaderVariables, t1);
    if (!routeData.space || !routeData.spaceSidebarLinks && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false)) {
        let t2;
        if ($[4] !== navigationProps || $[5] !== props) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$LegacySpaceNavigationContent, {
                navigationProps: navigationProps,
                ...props
            });
            $[4] = navigationProps;
            $[5] = props;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    let t2;
    if ($[7] !== routeData.creationEligibilitySpace) {
        t2 = !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_creation_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? routeData.creationEligibilitySpace ?? null : null;
        $[7] = routeData.creationEligibilitySpace;
        $[8] = t2;
    } else t2 = $[8];
    const t3 = routeData.spaceSidebarLinks ?? undefined;
    const t4 = routeData.userPreferences ?? undefined;
    let t5;
    if ($[9] !== routeData || $[10] !== t3 || $[11] !== t4) {
        t5 = {
            query: routeData,
            space: routeData.space,
            spaceSidebarLinks: t3,
            userPreferences: t4
        };
        $[9] = routeData;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== navigationProps || $[14] !== props || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$SpaceNavigationContentLayout, {
            navigationProps: navigationProps,
            routeFragmentRefs: t5,
            ...props
        });
        $[13] = navigationProps;
        $[14] = props;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== t2 || $[18] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pKmQ.SpaceCreationEligibilityProvider), {
            spaceFragmentRef: t2
        }, t6);
        $[17] = t2;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
};
const $c83507daffd5a949$var$LegacySpaceNavigationContent = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$SpaceNavigationContentLayout, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $c83507daffd5a949$var$SpaceNavigationContentLayout = (t0)=>{
    const $ = (0, $bDgLe.c)(63);
    const { navigationProps: navigationProps, errorProps: errorProps, spaceDetails: spaceDetails, routeFragmentRefs: routeFragmentRefs } = t0;
    const affordanceData = (0, $dJFqB.useSpaceNavigationAffordanceData)();
    const { loading: loading, hasSpace: hasSpace, space: space, spaceKey: spaceKey, homepageId: homepageId, main: main, quick: quick, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, showShortcutsSection: showShortcutsSection, shouldRenderSpaceApps: shouldRenderSpaceApps, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, loadingForgeApps: loadingForgeApps, onContentTreeLoadComplete: onContentTreeLoadComplete } = navigationProps;
    const { canManageSettingsAutomation: canManageSettingsAutomation } = spaceDetails;
    const t1 = spaceKey || "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            spaceKey: t1,
            operation: (0, $lfBMY.OperationTypes).CREATE,
            contentType: "page"
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const [canCreateContent] = (0, $2wo33.useCanPerformSpaceOperation)(t2);
    const { unhandledError: unhandledError, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, anonymousAccessQueryError: anonymousAccessQueryError } = errorProps;
    if (unhandledError || hasRestrictedError || hasNotFoundError || anonymousAccessQueryError || !loading && !hasSpace) {
        const t3 = unhandledError || anonymousAccessQueryError;
        let t4;
        if ($[2] !== hasNotFoundError || $[3] !== hasRestrictedError || $[4] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$ErrorView, {
                unhandledError: t3,
                hasRestrictedError: hasRestrictedError,
                hasNotFoundError: hasNotFoundError
            });
            $[2] = hasNotFoundError;
            $[3] = hasRestrictedError;
            $[4] = t3;
            $[5] = t4;
        } else t4 = $[5];
        return t4;
    }
    let t3;
    if ($[6] !== affordanceData?.isUserExternalCollaborator || $[7] !== affordanceData?.spaceFragmentRef || $[8] !== routeFragmentRefs || $[9] !== spaceDetails) {
        t3 = routeFragmentRefs && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6f43a2e4204022e9$export$533fb76256978163), {
            spaceFragmentRef: routeFragmentRefs.space,
            isExternalCollaborator: affordanceData?.isUserExternalCollaborator ?? Boolean(spaceDetails.isExternalCollaborator),
            externalCollaboratorsSpaceFragmentRef: affordanceData?.spaceFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6f43a2e4204022e9$export$533fb76256978163), {
            ...spaceDetails,
            externalCollaboratorsSpaceFragmentRef: affordanceData?.spaceFragmentRef
        });
        $[6] = affordanceData?.isUserExternalCollaborator;
        $[7] = affordanceData?.spaceFragmentRef;
        $[8] = routeFragmentRefs;
        $[9] = spaceDetails;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== loading) {
        t4 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
        $[11] = loading;
        $[12] = t4;
    } else t4 = $[12];
    const t5 = routeFragmentRefs?.spaceSidebarLinks && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? routeFragmentRefs.spaceSidebarLinks : undefined;
    const t6 = routeFragmentRefs && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_trees_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? routeFragmentRefs.query : undefined;
    const t7 = routeFragmentRefs && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_space_views_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? routeFragmentRefs.space : undefined;
    const t8 = routeFragmentRefs && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_space_views_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? routeFragmentRefs.userPreferences : undefined;
    let t9;
    if ($[13] !== blogsHidden || $[14] !== homepageId || $[15] !== isBlogNavigation || $[16] !== isSpaceAdmin || $[17] !== loading || $[18] !== onContentTreeLoadComplete || $[19] !== onDragDropSuccess || $[20] !== pageTreeFinishedLoading || $[21] !== quick || $[22] !== showShortcutsSection || $[23] !== space || $[24] !== spaceKey || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $72da3bb5b7695f3e$export$7716f65eb5d1a3fd), {
            showShortcutsSection: showShortcutsSection,
            space: space,
            spaceKey: spaceKey,
            quick: quick,
            homepageId: homepageId,
            loading: loading,
            isSpaceAdmin: isSpaceAdmin,
            isBlogNavigation: isBlogNavigation,
            blogsHidden: blogsHidden,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            onDragDropSuccess: onDragDropSuccess,
            onContentTreeLoadComplete: onContentTreeLoadComplete,
            shortcutsFragmentRef: t5,
            treeInitialDataFragmentRef: t6,
            spaceViewsRootFragmentRef: t7,
            spaceViewsPersistenceFragmentRef: t8
        });
        $[13] = blogsHidden;
        $[14] = homepageId;
        $[15] = isBlogNavigation;
        $[16] = isSpaceAdmin;
        $[17] = loading;
        $[18] = onContentTreeLoadComplete;
        $[19] = onDragDropSuccess;
        $[20] = pageTreeFinishedLoading;
        $[21] = quick;
        $[22] = showShortcutsSection;
        $[23] = space;
        $[24] = spaceKey;
        $[25] = t5;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $hekY6.default)([
            "_2XghbEPgdg _4FKVYEPgdg _1LMyvKYbGa _254aKfPgdg"
        ]);
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== loading || $[32] !== main || $[33] !== routeFragmentRefs) {
        t11 = loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ENihE.ContainerSkeleton), {
            header: false
        }) : routeFragmentRefs?.spaceSidebarLinks && !(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_core_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_space_nav_contract", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $078c23c8ca6acb4f$export$5ff3b51f9b84be4d), {
            spaceSidebarLinksFragmentRef: routeFragmentRefs.spaceSidebarLinks
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $078c23c8ca6acb4f$export$5ff3b51f9b84be4d), {
            links: main
        });
        $[31] = loading;
        $[32] = main;
        $[33] = routeFragmentRefs;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== t10 || $[36] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            "data-testid": "space-links",
            className: t10
        }, t11);
        $[35] = t10;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== allAppLinks || $[39] !== allVisibleAppLinks || $[40] !== canManageSettingsAutomation || $[41] !== loading || $[42] !== loadingForgeApps || $[43] !== shouldRenderSpaceApps || $[44] !== spaceKey) {
        t13 = !loading && !loadingForgeApps && shouldRenderSpaceApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_APPS_METRIC)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$SpaceApps, {
            spaceKey: spaceKey,
            canManageSettingsAutomation: canManageSettingsAutomation,
            allAppLinks: allAppLinks,
            allVisibleAppLinks: allVisibleAppLinks
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
        $[38] = allAppLinks;
        $[39] = allVisibleAppLinks;
        $[40] = canManageSettingsAutomation;
        $[41] = loading;
        $[42] = loadingForgeApps;
        $[43] = shouldRenderSpaceApps;
        $[44] = spaceKey;
        $[45] = t13;
    } else t13 = $[45];
    let t14;
    if ($[46] !== affordanceData?.suggestionCountFragmentRef || $[47] !== canCreateContent || $[48] !== loading || $[49] !== space?.id) {
        t14 = !loading && canCreateContent && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_autonomous_space_curation", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $c83507daffd5a949$var$relatedContentStyles.container
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "space-curation",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4516149d204af1cd$export$8372b97ddec977cb), {
            spaceId: space?.id,
            suggestionCountFragmentRef: affordanceData?.suggestionCountFragmentRef
        })));
        $[46] = affordanceData?.suggestionCountFragmentRef;
        $[47] = canCreateContent;
        $[48] = loading;
        $[49] = space?.id;
        $[50] = t14;
    } else t14 = $[50];
    let t15;
    if ($[51] !== t12 || $[52] !== t13 || $[53] !== t14 || $[54] !== t4 || $[55] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c83507daffd5a949$var$SidebarContent, {
            "data-vc": "space-navigation-sidebar-content"
        }, t4, t9, t12, t13, t14);
        $[51] = t12;
        $[52] = t13;
        $[53] = t14;
        $[54] = t4;
        $[55] = t9;
        $[56] = t15;
    } else t15 = $[56];
    let t16;
    if ($[57] !== loading) {
        t16 = !loading && ((0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $hekY6.default)([
                "_30huDKPgdg _2YLqiKB0rP _1x1D3gOeNX _3138428HPE"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $hekY6.default)([
                "_30huDKdnbC _2YLqiKB0rP _1x1D3gOeNX _3138428HPE"
            ])
        }));
        $[57] = loading;
        $[58] = t16;
    } else t16 = $[58];
    let t17;
    if ($[59] !== t15 || $[60] !== t16 || $[61] !== t3) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t15, t16);
        $[59] = t15;
        $[60] = t16;
        $[61] = t3;
        $[62] = t17;
    } else t17 = $[62];
    return t17;
};
module.exports["SpaceNavigationContent"] = $c83507daffd5a949$export$ec7f7d400376dc53;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $hZpML = parcelRequire("hZpML");


var $cemw8 = parcelRequire("cemw8");


var $8zKDl = parcelRequire("8zKDl");


var $dAPGk = parcelRequire("dAPGk");

const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $dAPGk.useSuspenseBoundaryName)();
} : ()=>(0, $dAPGk.useSuspenseBoundaryName)();
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $cozmU.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $cozmU.useContext)((0, $dAPGk.SuspenseBoundaryNameContext));
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = (0, $cozmU.useMemo)(()=>[
            ...parentBoundaryChain,
            dataFetcherName
        ], [
        parentBoundaryChain,
        dataFetcherName
    ]);
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAPGk.SuspenseBoundaryNameContext).Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cemw8.HydrationSafeSuspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.end`))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("cemw8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1P7Cq = parcelRequire("1P7Cq");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("1P7Cq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5c11702222c9ae97$export$10d6d9579eb80191 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const includeNonHydratingInitialRender = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [isSSROrHydrating, setIsSSROrHydrating] = (0, $cozmU.useState)(includeNonHydratingInitialRender ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            {
                if (window.__SSR_RENDERED__) (0, $cozmU.startTransition)(()=>{
                    setIsSSROrHydrating(false);
                });
                else setIsSSROrHydrating(false);
            }
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isSSROrHydrating;
};
module.exports["useIsSSROrHydrating"] = $5c11702222c9ae97$export$10d6d9579eb80191;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("k8jyJ", function(module, exports) {
var $9d3782c3b842cfbc$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["SUGGEST"] = "SUGGEST";
    Action["ACCEPT"] = "ACCEPT";
    Action["REJECT"] = "REJECT";
    Action["IGNORE"] = "IGNORE";
    return Action;
}({});
const $9d3782c3b842cfbc$export$f0c7a43b2eefe22f = {
    LOOM: 'loom',
    GOOGLE_DRIVE: 'drive',
    MICROSOFT: 'microsoft'
};
const $9d3782c3b842cfbc$export$fcdafa222e2a08e2 = Object.values($9d3782c3b842cfbc$export$f0c7a43b2eefe22f);
const $9d3782c3b842cfbc$var$PROVIDER_INTEGRATION_TO_CONNECTION = {
    google: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE,
    'google-drive': $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE,
    loom: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.LOOM,
    microsoft: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT,
    'microsoft-teams': $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT
};
const $9d3782c3b842cfbc$export$d499d92aec747a1e = (providerId)=>{
    const integration = providerId.split('integration/')[1]?.split('/')[0];
    return integration ? $9d3782c3b842cfbc$var$PROVIDER_INTEGRATION_TO_CONNECTION[integration] : undefined;
};
const $9d3782c3b842cfbc$export$f092255c909e2b34 = [
    $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE,
    $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT
];
const $9d3782c3b842cfbc$var$PRODUCT_ICON_MAP = [
    {
        pattern: 'docs.google.com/document',
        product: 'Google Docs',
        productKey: 'googleDocs',
        logoKey: 'google-docs',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE
    },
    {
        pattern: 'docs.google.com/spreadsheets',
        product: 'Google Sheets',
        productKey: 'googleSheets',
        logoKey: 'google-sheets',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE
    },
    {
        pattern: 'docs.google.com/presentation',
        product: 'Google Slides',
        productKey: 'googleSlides',
        logoKey: 'google-slides',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE
    },
    {
        pattern: 'drive.google.com',
        product: 'Google Drive',
        productKey: 'googleDrive',
        logoKey: 'google-drive',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.GOOGLE_DRIVE
    },
    {
        pattern: 'loom.com',
        product: 'Loom',
        productKey: 'loom',
        logoKey: 'loom',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.LOOM
    },
    {
        pattern: 'teams.microsoft.com',
        product: 'Microsoft Teams',
        productKey: 'microsoftTeams',
        logoKey: 'microsoft-teams',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT
    },
    {
        pattern: 'sharepoint.com',
        product: 'Microsoft SharePoint',
        productKey: 'microsoftTeams',
        logoKey: 'microsoft-sharepoint',
        connection: $9d3782c3b842cfbc$export$f0c7a43b2eefe22f.MICROSOFT
    }
];
function $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url) {
    return $9d3782c3b842cfbc$var$PRODUCT_ICON_MAP.find((entry)=>url.includes(entry.pattern));
}
function $9d3782c3b842cfbc$export$39b141cbf41f04f3(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.productKey ?? 'link';
}
function $9d3782c3b842cfbc$export$e71ceae9ed8d683e(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.logoKey;
}
function $9d3782c3b842cfbc$export$bb60325743692ab0(url) {
    return $9d3782c3b842cfbc$var$getProductIconMapEntryForContentUrl(url)?.connection;
}
module.exports["Action"] = $9d3782c3b842cfbc$export$e19cd5f9376f8cee;
module.exports["EXTERNAL_PRODUCT_CONNECTION"] = $9d3782c3b842cfbc$export$f0c7a43b2eefe22f;
module.exports["getConnectionForProviderId"] = $9d3782c3b842cfbc$export$d499d92aec747a1e;
module.exports["AUTH_OPTIONS"] = $9d3782c3b842cfbc$export$f092255c909e2b34;
module.exports["getSuggestionProductKeyFromContentUrl"] = $9d3782c3b842cfbc$export$39b141cbf41f04f3;
module.exports["getSuggestionLogoKeyFromContentUrl"] = $9d3782c3b842cfbc$export$e71ceae9ed8d683e;
module.exports["getConnectionFromContentUrl"] = $9d3782c3b842cfbc$export$bb60325743692ab0;

});

parcelRegister("431p7", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $cJ0FD = parcelRequire("cJ0FD");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $7xXfm = parcelRequire("7xXfm");

const $672c665181f62065$var$rootStyles = (0, $buxP3.xcss)({
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',
    objectPosition: 'center'
});
const $672c665181f62065$var$fillStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    inset: 'space.0',
    width: '100%',
    height: '100%'
});
const $672c665181f62065$var$autoDarkStyles = (0, $buxP3.xcss)({
    filter: 'invert(1) hue-rotate(180deg)'
});
const $672c665181f62065$export$75e378065cb7d6c0 = ({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps })=>{
    const isDarkMode = document.documentElement.getAttribute('data-theme') === 'dark';
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        xcss: [
            $672c665181f62065$var$rootStyles,
            ...fill ? [
                $672c665181f62065$var$fillStyles
            ] : [],
            ...isDarkMode && srcDark === srcLight && autoDark ? [
                $672c665181f62065$var$autoDarkStyles
            ] : []
        ],
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cJ0FD.default), {
            src: isDarkMode && srcDark ? srcDark : srcLight,
            srcDark: srcDark,
            alt: alt,
            testId: testId,
            ...imgProps
        })
    });
};
function $672c665181f62065$export$d43c2e2ca9b2c105({ ...props }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($672c665181f62065$export$75e378065cb7d6c0, {
        ...props
    });
}
const $672c665181f62065$export$785d3703e302bc58 = ({ illustrationKey: illustrationKey, ...props })=>{
    const illustration = (0, $7xXfm.getIllustration)(illustrationKey);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($672c665181f62065$export$d43c2e2ca9b2c105, {
        illustrationKey: illustrationKey,
        srcLight: illustration.light,
        srcDark: illustration.dark,
        ...props
    });
};
const $672c665181f62065$export$60247ecb8593cd70 = Object.keys((0, $7xXfm.illustrationMap));
module.exports["Illustration"] = $672c665181f62065$export$d43c2e2ca9b2c105;
module.exports["IllustrationComponent"] = $672c665181f62065$export$785d3703e302bc58;

});

parcelRegister("7xXfm", function(module, exports) {
const $c34e8ca54dbc708b$export$3baf7546f5f75a65 = {
    Roadmap: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7jw212gilh0pq8s0hyul84fdi678bf3k.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0j3wjupcj175311cn17hjvu3505dfeui.svg'
    },
    LetterOpen: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0rq27e55o54h8b5712rj4y7w6pyw77k4.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3d1701i21867ve0bh5o0mbsj03713erf.svg'
    },
    ErrorStateSearchNoResults: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j6orj168ea4wt8pf7gmy3f34fvhe5dhf.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/duh2c4s6cuwgu70xrp0phjc8q6mb214q.svg'
    },
    AddUser: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/320g85q2c1i2bb3r68d03w53mfbgf80a.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b70i6y7u7xe1xl0tb6imq53e8jq76iul.svg'
    },
    AddTeam: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25k7w5wf47sb030idd3p8473kw6jx812.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/443ly120bio7a4626h3vu431o8af6v65.svg'
    },
    BasicsUserManagement: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x30s04076y6v8m351n3f1s8vtbb1fr28.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fy16p5y4vm63ojm2f244m21pb66l64wq.svg'
    },
    RefreshUpdate: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v2c0s81enc43u8c8yp1425nju6lm4hja.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o3nxb5ua68n5h1s67d6x0750a07y55co.svg'
    },
    EmptyStateDone: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8xyyd278180s44355m6ai1u0q36aedgu.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/77c3l22p8jr18230f77r34ud130xua44.svg'
    },
    ErrorStateSearch: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h5b4hajdmg7555sxeguvler50nh26m2b.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k611370iv6do1622kj2wyto863oe82w8.svg'
    },
    DevOps: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p5xhuk78014yagtkpu4r6f0x1n5105dt.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x32yp5sb5q5340t3j57r24bv54vsfxdy.svg'
    },
    BasicsDone: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4fx5w8c7ygm211h3hk56gd063r12iuxx.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1p180c132m3w8pn6lwd050i5131qg7u5.svg'
    },
    BasicsMap: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k501d3mq2mr856ifm73xw0f54ld05hi5.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/80487c5lci30v652q126ob2v7lg5hxqm.svg'
    },
    BasicsCloud: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k87t038hjt8ug7b4e74hcxfjj725yh0a.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mt0g72401sly7i6817l0pmy50g7ux1gs.svg'
    },
    BasicsToolbox: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7bl2xobvtdl5l087p3ekiif3245mh5bq.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7b3hyne70j556m3386dq524lm8604054.svg'
    },
    BasicsIntegration: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i6h32pl6kgxhw4rnvv6032y2m2g12k58.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4vx3hb148215x8k2nmoo6c6i1d24ctm6.svg'
    },
    BasicsNetwork: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hkom1wq6850fkil8l387x661p5i618v6.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2718224l1o08ub15ckk8y40gkv4a0htm.svg'
    },
    BasicsTelescope: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7j80s288m4qhgsetie6sve68n2ej1405.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mfdrhx07ec534x8u6883a1g8304a5wkf.svg'
    },
    BasicsMigrations: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/02h181332ob0bb0h8y01dn463ac85650.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/e41m7730o4jx767sr3q0wqxy40q478d0.svg'
    },
    EmptyStateAddCard: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qxxv401l02xqijm865431t77jlj56o42.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cs314684x4sdec707ruwgkw7s4l2j238.svg'
    },
    PurchaseSolutions: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1m6mj7is0crda1j8k4001pf33f5ayg3v.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4836vvm76sj7b5bk4nlnrlf2w7156ahp.svg'
    },
    BasicsToggle: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q5jk78i1638850vvywhnq3a88fkulcgg.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1ugf4n1b1obwy3x50o3cy7b1cb2ogvlt.svg'
    },
    Gear: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2054s3i80cnl0rj21onct4wni4503y2f.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/pe4r106m14js5axb1104afiy6u86q1q7.svg'
    },
    Clipboard: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x261nhq5uvo03ck303l448ok54we4s40.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v6k72hphq6iy40h02b06x4tjn0pp1xg2.svg'
    },
    BasicsPadlockKey: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8mdy4ly4472iy7oe1so16p7n8tg0tq4j.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m780xv54x0c80rl10fj7st2827143du8.svg'
    },
    BasicsSafe: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/61515r0ky6w25rgox71ikg8xr8ews7c2.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/84gvg2c6ne2404470v8nhm20t50o141n.svg'
    },
    BasicsCompliance: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v02gk84pk8m4615us43275j34152ao8e.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/64px0476b1560y7213q21d838a5h536w.svg'
    },
    BasicsTracking: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/jw6pndhya20421lupo7fa1lrq838jjt6.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/720328508vo54hxd37g211kgq785r20l.svg'
    },
    BasicsGear: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b5fd2x7vyous80066drr052o0fv54jq7.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/42fqbi1p3krj77y4x35027s6bhykshj6.svg'
    },
    BasicsSearchDocuments: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/481u3aim7rr8i4ody7g8x73851400u66.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/86a33isl2idxkh3l7p0h577h02f66lq7.svg'
    },
    IdBadge: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/583882gc55qf4rc6r65e42x73o6y8050.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0kqc63x6c2g52f53c42543m284q2r01b.svg'
    },
    DataPrivacy: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/203264h64h0jjak63j4844s47b2d0hi4.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l33xi5x21ktjj23c6403663u6oy1g0bu.svg'
    },
    Firewall: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/88100e300go74n6bpg2xl2o2y42s85jh.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/54v6f06r1lefsgmppt70v086q5cy00ca.svg'
    },
    BasicsCalendar: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kaw757yfmx4x318281etb8x1x73tdnr1.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xuah062301y0cf7hg8f17tp7s6d1l17p.svg'
    },
    BasicsCaptureUsers: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wh17145204218s6k8ob72577fk02733b.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y5e147js1ix8263j84t6hd20m475lqs4.svg'
    },
    EmptyStateAddItem: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/457n14i63u567yex70d3f7whn3muk424.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4kc212md11dd2sf8p3br83cltr1l5pfl.svg'
    },
    BasicsPlatform: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/214yy1pd03tl403v5a2b52540y8001y1.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ngr7gg603m7xa7p387t5lp4346ocmn28.svg'
    },
    Coins: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/06fh24615yc78k4m6f425t5ubds7u2od.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vhu2f73mpr4umr41oku53wac1ymjjl7o.svg'
    },
    ErrorColor: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2e655j87263160n28qbq8w21442ap32e.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/027e8530v08n5no10q4531pn3bj2xff2.svg'
    },
    EmptyStateLinkProduct: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vw8wnk2l1ir45e3paqo112k1o7pe7651.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8o713f7rqa14ybt1h2p607p8q7trs07i.svg'
    },
    EmptyStateAddDomain: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5w8wk47o7bk5tnc0kaobgli411ewr670.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/24fyu3u2u7w1te42ey0kbp0vkw7my7o3.svg'
    },
    Target: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/td5b33i7s8eo54p44y0g8sc514qh3yt5.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eey6g3u233r4ed2od7vxfj5k8jpe00y6.svg'
    },
    Keys: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/78p40jv6as05i5igau72l3g786t60v6d.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l6s154tgi0x86c5d8fmbe8w25tappa8y.svg'
    },
    LegalSignature: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r1kv0fypxbw3b87dw51b1s87g3sbye7j.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4tvrp0lg435g3ul8qtf1k0mul2202ld2.svg'
    },
    Certificate: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/olc6ly6444j28201xvy1l47u875c7ni5.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/45mu552reqn43g0ll8247215v73357l2.svg'
    },
    Book: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/rgls54sa2ht127b36w6gtrn007hq540r.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ta66oqj1j4p06b78dj0lgsrnsrn7v8g0.svg'
    },
    Scalability: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/e43505bjv28k04y3p1op386fl3bbv635.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p51k45qsv122cmfk7l346kghiduaoai1.svg'
    },
    Launch: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mo4ruaiviisypd0843v5122af3058412.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ghd3w62kfhyuut0712ft7aml7r31rhea.svg'
    },
    Safe: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3tgmc31cmtkh1f15850ljn63ij8c780q.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/083e51o6yx24qd652c4516osh7l7m3xp.svg'
    },
    FileCabinet: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3s5fh384d6711v6v8nh25i62p87s3234.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0h181827yev84ha3143f8gwdv2211l4j.svg'
    },
    BasicsSearchFiles: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m06sfph6ghm12alyp2qbjduo138s717k.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/14ck50342nk275nrd1kb61i274071537.svg'
    },
    BasicsEncryption: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/34806iiapwi25t3e6prty1362w8q1q30.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/14ra46smb04xi65x078mu23je85p8gv7.svg'
    },
    BasicsUpload: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fgry4p8x7a41p0rgy602e2ihd8m3t1f2.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nvr5bibqhna6f8s62txcp74uy0l1a817.svg'
    },
    BasicsIntergrations: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3ej70r224drtwu8rp5rme5r8jca4b3t7.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g06n8681o6xlgg2m85166viix55trhvx.svg'
    },
    BasicsPadlock: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xm6yhtu41o0a72s0120656i5635i0psh.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3tk03r230nw0qj42m10hu78bb8g8v686.svg'
    },
    ErrorGeneral: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y57gh135brj0y5636ry8373s216388ll.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ma5w4y4y8fpe380ty61yb76737387358.svg'
    },
    GeneralSpeed: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s4whr5562p47uxh3e53w28c873hc02eg.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/f5k75b0e166640ia64560hf14644107x.svg'
    },
    GeneralFolder: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/uuxyrbe462u44513566nt718214bf703.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/745g31l520pn56wy4qge851et537of67.svg'
    },
    EmptyStateAddPage: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2mp148gy6fg4b7dhyw31cjj3261oej2v.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3h018oh050r4v4058l7544f5xxk4s6h5.svg'
    },
    CreditCard: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nh0bbp8rjwq8mk2r1w342ke3j24uoi02.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/r1rn72wjhah5mfg5muyk81mactw8m5f6.svg'
    },
    PowerfulFeature: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2o22x8xvx8g8264iug346lp75n281520.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/67my2r0s61mbw76b5oxcyfs5s88k72q3.svg'
    },
    HourGlass: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y3mm3ad1u5kpvr68j3jb0e8e7d00o5r0.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/456r68qp3q717ln3q431n5gw0871gc27.svg'
    },
    ValueDiamond: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/55y50mimx1v7p7713d4k71v26o15u0ru.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ihgmiq546710w63n2u3yl453t36127sk.svg'
    },
    TeamValues: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d3rf5ch87s3xw25n8uw0jm3844171n0h.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/888g5f0t3480wi2soeu231gl2tu40uyh.svg'
    },
    RainIncident: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/icukl8b50y8ob6353w2o542843177n01.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q046fj32r665n7677ggmt554kpm27ven.svg'
    },
    PageBarChart: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5h2511y7u13g4pkjb0r5gbqdajts3a7p.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/575j1hj7237ocbtqr7c800ice3d50523.svg'
    },
    GlobalNetwork: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y0uarnxka84le10408im250c41v1xl7r.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/op3g5cwa212b37uechd58dmqysc2504v.svg'
    },
    Users: {
        light: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v60acd80fl8007s5g101hh76yfb7ne7v.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4nqf045g7731f2lk1p78ktc8eq3j4qqr.svg'
    },
    FlagLogo: {
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12PK9.svg',
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT15WPF.svg'
    }
};
const $c34e8ca54dbc708b$export$60247ecb8593cd70 = Object.keys($c34e8ca54dbc708b$export$3baf7546f5f75a65);
const $c34e8ca54dbc708b$export$6754ebb763d0f990 = (key)=>{
    const illustration = $c34e8ca54dbc708b$export$3baf7546f5f75a65[key];
    if (typeof illustration === 'string') return {
        light: illustration,
        dark: illustration
    };
    return illustration;
};
module.exports["illustrationMap"] = $c34e8ca54dbc708b$export$3baf7546f5f75a65;
module.exports["getIllustration"] = $c34e8ca54dbc708b$export$6754ebb763d0f990;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $5tsXU = parcelRequire("5tsXU");


var $hT3jf = parcelRequire("hT3jf");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t2 = emoji || "";
        let t3;
        if ($[0] !== height || $[1] !== t2 || $[2] !== type) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t2,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t2;
            $[2] = type;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) {
        let t2;
        if ($[4] !== color) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
                label: "",
                size: "small",
                color: color,
                testId: "icons.content-icon.label.managed-folder"
            });
            $[4] = color;
            $[5] = t2;
        } else t2 = $[5];
        return t2;
    }
    const actualType = isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t2;
    if ($[6] !== Icon || $[7] !== color || $[8] !== label.id) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[6] = Icon;
        $[7] = color;
        $[8] = label.id;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    if ((0, $hT3jf.isSmartFolder)({
        type: type,
        subType: subType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
        label: "",
        size: "small",
        color: color,
        testId: "icons.content-icon.label.managed-folder"
    });
    const actualType = isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e8b2cdb4a7b2569268a3fe6ec068354>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_iconNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/notepad
 * Usage guidance:
 * Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_iconNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9feda705e9481f913d0df858359ce6d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_iconNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_iconNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("7CNwI"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("7CNwI", function(module, exports) {

let $58d27ff903855c90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $58d27ff903855c90$var$load("gFeoL"),
    $58d27ff903855c90$var$load("6wr18"),
    $58d27ff903855c90$var$load("kwZ86"),
    $58d27ff903855c90$var$load("ffEVr"),
    $58d27ff903855c90$var$load("4Ldt2"),
    $58d27ff903855c90$var$load("3LYaV"),
    $58d27ff903855c90$var$load("20wSi"),
    $58d27ff903855c90$var$load("9LDVS"),
    $58d27ff903855c90$var$load("kiMHu"),
    $58d27ff903855c90$var$load("8OeKT"),
    $58d27ff903855c90$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $51W2Z = parcelRequire("51W2Z");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    // For signed-in users, allowAnonymousAccess does not change the provider config. Sharing the
    // resource lets uploads propagate immediately between editor, title, and reaction pickers.
    const allowAnonymousAccessCacheKey = userId ? false : allowAnonymousAccess;
    return `${cloudId}_${userId}_${allowAnonymousAccessCacheKey}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    if (cloudId && userId && (0, $6mKj3.expValEquals)('confluence_on_demand_emoji_repository', 'isEnabled', true)) return new (0, $51W2Z.OnDemandEmojiResource)({
        ...emojiConfig,
        options: {
            onlyFetchOnDemand: true
        },
        singleEmojiApi: {
            getUrl: ({ id: id, shortName: shortName })=>`${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/${encodeURIComponent(id ?? shortName)}`
        }
    });
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $drRzc = parcelRequire("drRzc");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("51W2Z", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");

const $20b5b351e69bef6e$var$isMediaRepresentation = (representation)=>!!representation && 'mediaPath' in representation;
class $20b5b351e69bef6e$export$cfbb91621ad16c67 extends (0, $kwzZh.default) {
    // filter() reports "not ready" without waiting, so it has to start the fetch itself. The fetch
    // re-runs the last filter when it completes.
    filter(query, options) {
        this.startRepositoryFetch();
        super.filter(query, options);
    }
    async fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder) {
        if (!this.emojiProviderConfig.singleEmojiApi || !emojiId.id || this.isRepositoryLoaded()) return super.fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder);
        // Emoji ids never contain a slash, but page icons can be URLs, such as a favicon. No emoji list
        // has them, and the single-emoji endpoint rejects them, which would download the repository.
        if (emojiId.id.includes('/')) return undefined;
        // With `optimistic` true, the base class requests just this emoji from singleEmojiApi instead of
        // waiting for the repository. ResourcedEmoji passes its `optimistic` prop, which
        // @atlaskit/reactions leaves off, so force it on until the repository has loaded.
        const emoji = await super.fetchByEmojiId(emojiId, true, emojiProviderLookupOrder);
        // The single-emoji request falls back to the repository when it fails, but not when it finds
        // nothing. With `optimistic` false, the base class waits for the repository, and
        // retryIfLoading starts downloading it.
        return emoji ?? super.fetchByEmojiId(emojiId, false, emojiProviderLookupOrder);
    }
    findById(id) {
        if (!this.emojiProviderConfig.singleEmojiApi || this.isRepositoryLoaded()) return super.findById(id);
        return this.fetchByEmojiId({
            id: id,
            shortName: ''
        }, true);
    }
    retryIfLoading(retry, defaultResponse) {
        this.startRepositoryFetch();
        return super.retryIfLoading(retry, defaultResponse);
    }
    // The single-emoji response can be the first to carry a media token. SiteEmojiResource keeps the
    // URL it is created with for uploads, deletes and token refreshes, so it must get the site provider
    // rather than the single-emoji URL. The base class primes the resource with the first emoji, which
    // throws for a standard or Atlassian emoji and makes the lookup fall back to the repository, so only
    // media emoji are passed on.
    initSiteEmojiResource(emojiResponse, provider) {
        const siteProvider = this.emojiProviderConfig.providers.find(({ url: url })=>url.endsWith('/site'));
        return super.initSiteEmojiResource({
            ...emojiResponse,
            emojis: emojiResponse.emojis.filter(({ representation: representation })=>$20b5b351e69bef6e$var$isMediaRepresentation(representation))
        }, siteProvider ?? provider);
    }
    isRepositoryLoaded() {
        return !!this.emojiRepository && this.initialLoaders !== 0 && this.activeLoaders === 0;
    }
    startRepositoryFetch() {
        if (!this.isInitialised) // Failures are reported through notifyError and the pending retries.
        this.fetchEmojiProvider().catch(()=>{});
    }
}
module.exports["OnDemandEmojiResource"] = $20b5b351e69bef6e$export$cfbb91621ad16c67;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("5tsXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Custom icon for a managed (synced) closed folder.
 * Renders a folder with a circle badge in the bottom-right corner.
 * Uses currentColor so the icon responds to theming and dark mode.
 */ const $3216f3fcd316d4ef$export$75f34eec99819e9c = ({ label: label, size: size = 'medium', color: color, testId: testId })=>{
    const dimensions = size === 'small' ? 16 : 24;
    const fillColor = color || 'currentColor';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": testId,
        width: dimensions,
        height: dimensions,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": !label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.31055 2.75H13C14.1046 2.75 15 3.64543 15 4.75V10H13.5V7.5H2.5V13C2.5 13.2761 2.72386 13.5 3 13.5H10V15H3C1.89543 15 1 14.1046 1 13V3C1 1.89543 1.89543 1 3 1H6.56055L8.31055 2.75ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V6H13.5V4.75C13.5 4.47386 13.2761 4.25 13 4.25H7.68945L5.93945 2.5H3Z",
        fill: fillColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15.75 13.75C15.75 14.8546 14.8546 15.75 13.75 15.75C12.6454 15.75 11.75 14.8546 11.75 13.75C11.75 12.6454 12.6454 11.75 13.75 11.75C14.8546 11.75 15.75 12.6454 15.75 13.75Z",
        fill: fillColor
    }));
};
module.exports["ManagedFolderClosedIcon"] = $3216f3fcd316d4ef$export$75f34eec99819e9c;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("fSlSx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6Ec6w = parcelRequire("6Ec6w");


var $lb2PL = parcelRequire("lb2PL");


var $jx3SX = parcelRequire("jx3SX");


var $4zc1o = parcelRequire("4zc1o");


var $1448l = parcelRequire("1448l");


var $2XmSX = parcelRequire("2XmSX");


var $5TdBT = parcelRequire("5TdBT");


var $8RTwe = parcelRequire("8RTwe");


var $aKu7b = parcelRequire("aKu7b");


var $k8jyJ = parcelRequire("k8jyJ");

const $6cfcd88ce0ff451c$var$CONNECTION_LOGO_KEY = {
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).GOOGLE_DRIVE]: 'google-drive',
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).MICROSOFT]: 'onedrive',
    [(0, $k8jyJ.EXTERNAL_PRODUCT_CONNECTION).LOOM]: 'loom'
};
const $6cfcd88ce0ff451c$export$62989d7cb9b14377 = ({ logoKey: logoKey, size: size = 'xsmall', label: label = '', testId: testId })=>{
    switch(logoKey){
        case 'google-drive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zc1o.GoogleDriveIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'google-docs':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jx3SX.GoogleDocsIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'google-sheets':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1448l.GoogleSheetsIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'google-slides':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2XmSX.GoogleSlidesIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'onedrive':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TdBT.MicrosoftOneDriveIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'microsoft-teams':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKu7b.MicrosoftTeamsIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'microsoft-sharepoint':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8RTwe.MicrosoftSharePointIcon), {
                label: label,
                size: size,
                testId: testId
            });
        case 'loom':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lb2PL.LoomIcon), {
                label: label,
                size: size,
                testId: testId
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                label: label,
                color: "var(--ds-icon-subtle, #505258)",
                testId: testId
            });
    }
};
const $6cfcd88ce0ff451c$export$465a3683f8bbe7a6 = ({ connection: connection, size: size, label: label, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6cfcd88ce0ff451c$export$62989d7cb9b14377, {
        logoKey: $6cfcd88ce0ff451c$var$CONNECTION_LOGO_KEY[connection],
        size: size,
        label: label,
        testId: testId
    });
module.exports["ProductLogo"] = $6cfcd88ce0ff451c$export$62989d7cb9b14377;
module.exports["ConnectionLogo"] = $6cfcd88ce0ff451c$export$465a3683f8bbe7a6;

});

parcelRegister("lb2PL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c420f5a156d6b7cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
const $c420f5a156d6b7cf$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Loom" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $c420f5a156d6b7cf$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function LoomIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $c420f5a156d6b7cf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["LoomIcon"] = $c420f5a156d6b7cf$export$8d789f76fde3e05;

});

parcelRegister("aR3ec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $1f4e40c711db0c72$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $1f4e40c711db0c72$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $1f4e40c711db0c72$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
const $1f4e40c711db0c72$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconWrapper(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { size: t1, label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: t2, iconColor: customIconColor, isAssets: t3, type: t4 } = t0;
    const size = t1 === undefined ? "20" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t5 = customIconColor || "initial";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            "--themed-icon-color": t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const t7 = t6;
    const t8 = label ? label : undefined;
    const t9 = label ? "img" : undefined;
    const t10 = label === "" ? true : undefined;
    const t11 = isCustomThemed ? customThemeSvg : svg;
    let t12;
    if ($[2] !== t11) {
        t12 = {
            __html: t11
        };
        $[2] = t11;
        $[3] = t12;
    } else t12 = $[3];
    const t13 = $1f4e40c711db0c72$var$sizeMap[size];
    const t14 = colorMode === "dark" ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance];
    const t15 = type === "rovo" ? colorMode === "dark" ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance];
    let t16;
    if ($[4] !== appearance || $[5] !== isAssets || $[6] !== t13 || $[7] !== t14 || $[8] !== t15) {
        t16 = (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            t13,
            t14,
            t15,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ]);
        $[4] = appearance;
        $[5] = isAssets;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
    } else t16 = $[9];
    let t17;
    if ($[10] !== t10 || $[11] !== t12 || $[12] !== t16 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t7,
            "aria-label": t8,
            role: t9,
            "aria-hidden": t10,
            dangerouslySetInnerHTML: t12,
            className: t16
        });
        $[10] = t10;
        $[11] = t12;
        $[12] = t16;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function IconWrapper({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            $1f4e40c711db0c72$var$sizeMap[size],
            colorMode === 'dark' ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ])
    });
};
module.exports["IconWrapper"] = $1f4e40c711db0c72$export$be58b4326e23250f;

});

parcelRegister("ij4CE", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $7EPz1 = parcelRequire("7EPz1");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");


var $bqzdu = parcelRequire("bqzdu");


var $kWvcF = parcelRequire("kWvcF");


var $cjdbm = parcelRequire("cjdbm");


var $81Pid = parcelRequire("81Pid");


var $86okN = parcelRequire("86okN");

// While a Relay-native optimistic layer is active (inside commitMutation's optimisticUpdater/updater),
// route the fragment write onto that layer's store proxy instead of committing permanently, so it
// participates in the disposable layer Relay reverts atomically. writeFragmentShim only uses
// `environment.commitUpdate`, so a thin env shim runs its in-place write against the provided proxy.
// Outside an updater this returns false and the normal permanent write path is used.
function $7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragment, fragmentId, data, variables) {
    const ambientStore = (0, $bqzdu.getAmbientStoreProxy)();
    if (!ambientStore || !fragment) return false;
    const ambientEnv = {
        commitUpdate: (updater)=>updater(ambientStore)
    };
    (0, $kWvcF.writeFragmentShim)(ambientEnv, fragment, fragmentId, data, variables);
    return true;
}
const $7fd39030140cad16$export$6e64625354109aa5 = (data, fragmentArtifact)=>(0, $kWvcF.addTypenameToData)(data, fragmentArtifact);
const $7fd39030140cad16$var$useWriteFragmentInteropRelay = (0, $3u0dr.isReactCompilerActiveV2)() ? function useWriteFragmentInteropRelay(args) {
    const $ = (0, $bDgLe.c)(4);
    const { fragmentSpec: fragmentSpec, __callerPackage__: __callerPackage__ } = args;
    const env = (0, $6SsN4.useRelayEnvironment)();
    let t0;
    if ($[0] !== __callerPackage__ || $[1] !== env || $[2] !== fragmentSpec) {
        t0 = (t1)=>{
            const { data: data, fragmentId: fragmentId, variables: variables } = t1;
            if ((0, $9wGTI.fg)("confluence_relay_migration_diagnostics_enabled")) {
                const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
                (0, $cjdbm.logRelayMigrationDiagnostic)("Fragment access", {
                    phase: "fragment",
                    action: "write",
                    api: "useWriteFragmentInterop",
                    callerPackage: __callerPackage__,
                    fragmentName: fragmentName,
                    fragmentType: fragmentType,
                    fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                    relayEnabled: true
                });
            }
            if ($7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragmentSpec, fragmentId, data, variables)) return;
            (0, $kWvcF.writeFragmentShim)(env, fragmentSpec, fragmentId, data, variables);
        };
        $[0] = __callerPackage__;
        $[1] = env;
        $[2] = fragmentSpec;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : function useWriteFragmentInteropRelay(args) {
    const { fragmentSpec: fragmentSpec, __callerPackage__: __callerPackage__ } = args;
    const env = (0, $6SsN4.useRelayEnvironment)();
    return (0, $cozmU.useCallback)(({ data: data, fragmentId: fragmentId, variables: variables })=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('confluence_relay_migration_diagnostics_enabled')) {
            const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
            (0, $cjdbm.logRelayMigrationDiagnostic)('Fragment access', {
                phase: 'fragment',
                action: 'write',
                api: 'useWriteFragmentInterop',
                callerPackage: __callerPackage__,
                fragmentName: fragmentName,
                fragmentType: fragmentType,
                fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                relayEnabled: true
            });
        }
        if ($7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragmentSpec, fragmentId, data, variables)) return;
        (0, $kWvcF.writeFragmentShim)(env, fragmentSpec, fragmentId, data, variables);
    }, [
        env,
        fragmentSpec,
        __callerPackage__
    ]);
};
const $7fd39030140cad16$var$useWriteFragmentInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useWriteFragmentInteropApollo(args) {
    const $ = (0, $bDgLe.c)(5);
    const { fragmentSpec: fragmentSpec, fragmentArtifact: fragmentArtifact, __callerPackage__: __callerPackage__ } = args;
    const apolloClient = (0, $7EPz1.useApolloClient)();
    let t0;
    if ($[0] !== __callerPackage__ || $[1] !== apolloClient || $[2] !== fragmentArtifact || $[3] !== fragmentSpec) {
        t0 = (t1)=>{
            const { data: data, fragmentId: fragmentId, variables: variables, useAggClient: useAggClient } = t1;
            if ((0, $9wGTI.fg)("confluence_relay_migration_diagnostics_enabled")) {
                const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
                (0, $cjdbm.logRelayMigrationDiagnostic)("Fragment access", {
                    phase: "fragment",
                    action: "write",
                    api: "useWriteFragmentInterop",
                    callerPackage: __callerPackage__,
                    fragmentName: fragmentName,
                    fragmentType: fragmentType,
                    fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                    relayEnabled: false
                });
            }
            const dataToWrite = $7fd39030140cad16$export$6e64625354109aa5(data, fragmentArtifact);
            const client = useAggClient && typeof window !== "undefined" ? window.GLOBAL_APOLLO_AGG_CLIENT : apolloClient;
            if (client) client.writeFragment({
                id: fragmentId,
                fragment: (0, $86okN.toDocumentNode)(fragmentSpec),
                data: dataToWrite,
                variables: variables
            });
        };
        $[0] = __callerPackage__;
        $[1] = apolloClient;
        $[2] = fragmentArtifact;
        $[3] = fragmentSpec;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : function useWriteFragmentInteropApollo(args) {
    const { fragmentSpec: fragmentSpec, fragmentArtifact: fragmentArtifact, __callerPackage__: __callerPackage__ } = args;
    const apolloClient = (0, $7EPz1.useApolloClient)();
    return (0, $cozmU.useCallback)(({ data: data, fragmentId: fragmentId, variables: variables, useAggClient: useAggClient })=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('confluence_relay_migration_diagnostics_enabled')) {
            const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
            (0, $cjdbm.logRelayMigrationDiagnostic)('Fragment access', {
                phase: 'fragment',
                action: 'write',
                api: 'useWriteFragmentInterop',
                callerPackage: __callerPackage__,
                fragmentName: fragmentName,
                fragmentType: fragmentType,
                fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                relayEnabled: false
            });
        }
        // Add __typename to data using the fragment artifact's type information
        const dataToWrite = $7fd39030140cad16$export$6e64625354109aa5(data, fragmentArtifact);
        // Guard window for server usage while preserving Apollo as the original write target.
        const client = useAggClient && typeof window !== 'undefined' ? window.GLOBAL_APOLLO_AGG_CLIENT : apolloClient;
        if (client) client.writeFragment({
            id: fragmentId,
            fragment: (0, $86okN.toDocumentNode)(fragmentSpec),
            data: dataToWrite,
            variables: variables
        });
    }, [
        apolloClient,
        fragmentSpec,
        fragmentArtifact,
        __callerPackage__
    ]);
};
function $7fd39030140cad16$export$b3a20d310cac24ba(args) {
    return (0, $iffSy.isRelayEnabled)(args.__callerPackage__, {
        phase: 'fragment'
    }) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fd39030140cad16$var$useWriteFragmentInteropRelay(args) : // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fd39030140cad16$var$useWriteFragmentInteropApollo(args);
}
function $7fd39030140cad16$export$a2dd3f95e566e3ed(options) {
    const { fragmentId: fragmentId, data: data, fragment: fragment, variables: variables, useAggClient: useAggClient, __callerPackage__: __callerPackage__ } = options;
    if (!data) return;
    const source = (0, $iffSy.isRelayEnabled)(__callerPackage__, {
        phase: 'fragment'
    }) ? 'relay' : 'apollo';
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('confluence_relay_migration_diagnostics_enabled')) {
        const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragment);
        (0, $cjdbm.logRelayMigrationDiagnostic)('Fragment access', {
            phase: 'fragment',
            action: 'write',
            api: 'writeFragmentInterop',
            callerPackage: __callerPackage__,
            fragmentName: fragmentName,
            fragmentType: fragmentType,
            fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
            relayEnabled: source === 'relay'
        });
    }
    if (source === 'relay') {
        const env = window['GLOBAL_RELAY_ENV'];
        if (fragment) {
            if ($7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragment, fragmentId, data, variables)) return;
            (0, $kWvcF.writeFragmentShim)(env, fragment, fragmentId, data, variables);
        }
        return;
    }
    const client = useAggClient && typeof window !== 'undefined' ? window['GLOBAL_APOLLO_AGG_CLIENT'] : window['GLOBAL_APOLLO_CLIENT'];
    if (client && fragment) {
        const dataToWrite = (0, $kWvcF.addTypenameToData)(data, fragment);
        client.writeFragment({
            id: fragmentId,
            fragment: (0, $86okN.toDocumentNode)(fragment),
            data: dataToWrite,
            variables: variables
        });
    }
}
module.exports["useWriteFragmentInterop"] = $7fd39030140cad16$export$b3a20d310cac24ba;
module.exports["writeFragmentInterop"] = $7fd39030140cad16$export$a2dd3f95e566e3ed;

});

parcelRegister("e0Gob", function(module, exports) {
/* ContentPreviewPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");

var $320cc310d84c5b29$exports = {};
$320cc310d84c5b29$exports = new URL("preview-no-selection.14e43eee.svg", import.meta.url).toString();


var $39054e692c50a9dd$exports = {};
$39054e692c50a9dd$exports = new URL("content-preview-squiggle.027b5d84.svg", import.meta.url).toString();


const $32647b41ad829cc7$var$styles = {
    container: "_1mT5xdRAKS _0jFU0VN91d",
    squiggleWrapper: "_43nrzTkG2W _0rIjykNHnM",
    skeletonBarFull: "_39xV02Qjzx _0jFU0VJg58 _0KLXrumhAQ",
    skeletonBarShortWrapper: "_43nrzT8HPE",
    skeletonBarShort: "_39xV023CA1 _0jFU0VJg58 _0KLXrumhAQ",
    skeletonBarBottom: "_39xV02zfVU _0jFU0VZimw _0KLXrumhAQ _1mT5xdWVPG _0Bm75GPgdg _3OE6xYPgdg"
};
const $32647b41ad829cc7$export$5589fb4f49509a9b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.container,
        testId: "content-preview-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($320cc310d84c5b29$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.squiggleWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($39054e692c50a9dd$exports))),
        alt: "",
        "aria-hidden": "true",
        width: "84",
        height: "15"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarFull
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarFull
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarShortWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarShort
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $32647b41ad829cc7$var$styles.skeletonBarBottom
    }));
};
module.exports["ContentPreviewPlaceholder"] = $32647b41ad829cc7$export$5589fb4f49509a9b;

});

parcelRegister("dJySn", function(module, exports) {
module.exports = new URL("preview-background.054f72c1.svg", import.meta.url).toString();

});

parcelRegister("3WMx1", function(module, exports) {
module.exports = new URL("content-preview-sparkle.2c80a83f.svg", import.meta.url).toString();

});

parcelRegister("eKTWO", function(module, exports) {

var $hU1C8 = parcelRequire("hU1C8");


var $jwbRi = parcelRequire("jwbRi");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jMyy4 = parcelRequire("jMyy4");

const $862814430f69e6aa$export$47d4842719bdb071 = (0, $jwbRi.default);
const $862814430f69e6aa$export$aad7e27ed56b51fc = (0, $hU1C8.default);
const $862814430f69e6aa$export$ba9e49b520a30a69 = ({ spaceKey: spaceKey, cloudId: cloudId })=>$862814430f69e6aa$var$useFetchSuggestionCountInternal({
        spaceKey: spaceKey,
        cloudId: cloudId
    });
const $862814430f69e6aa$export$d39f13847aa08df3 = ({ spaceKey: spaceKey, cloudId: cloudId, suggestionCountFragmentRef: suggestionCountFragmentRef })=>{
    const fragmentData = (0, $6SsN4.useFragment)($862814430f69e6aa$export$47d4842719bdb071, suggestionCountFragmentRef);
    return $862814430f69e6aa$var$useFetchSuggestionCountInternal({
        spaceKey: spaceKey,
        cloudId: cloudId
    }, fragmentData);
};
const $862814430f69e6aa$var$useFetchSuggestionCountInternal = ({ spaceKey: spaceKey, cloudId: cloudId }, fragmentData)=>{
    const usesRouteData = fragmentData !== undefined;
    const { data: apolloData, loading: apolloLoading, refetch: apolloRefetch } = (0, $jMyy4.useQueryInterop)($862814430f69e6aa$export$aad7e27ed56b51fc, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: !spaceKey || usesRouteData,
        interopApolloAggClient: true,
        __callerPackage__: "space-curation"
    });
    return (0, $cozmU.useMemo)(()=>{
        const hasChildQueryData = apolloData != null;
        const raw = hasChildQueryData ? apolloData.confluence_remoteObjectSuggestionCount : fragmentData?.confluence_remoteObjectSuggestionCount;
        const isLoading = usesRouteData && !hasChildQueryData ? false : apolloLoading;
        // null data is the suppression signal — this includes the case where the
        // backend returns errors alongside null data (e.g. NotFoundException when
        // the user has been permanently suppressed). Do not gate on apolloError.
        const isSuppressed = !isLoading && raw == null;
        return {
            count: raw ?? 0,
            isLoading: isLoading,
            isSuppressed: isSuppressed,
            refetch: ()=>{
                apolloRefetch();
            }
        };
    }, [
        apolloData,
        apolloLoading,
        apolloRefetch,
        fragmentData,
        usesRouteData
    ]);
};
module.exports["RemoteObjectSuggestionCountQuery"] = $862814430f69e6aa$export$aad7e27ed56b51fc;
module.exports["useFetchSuggestionCount"] = $862814430f69e6aa$export$ba9e49b520a30a69;
module.exports["useFetchSuggestionCountFromFragment"] = $862814430f69e6aa$export$d39f13847aa08df3;

});

parcelRegister("hU1C8", function(module, exports) {
/**
 * @generated SignedSource<<7ed3a2785ef14914cca4babcea9ce45a>>
 * @relayHash 2928057d03b4f5d5a1a268a9759b926b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492
const $41493c5c0e5e4e0b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2928057d03b4f5d5a1a268a9759b926b",
            "id": "e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492",
            "metadata": {},
            "name": "useFetchSuggestionCountQuery",
            "operationKind": "query",
            "text": "query useFetchSuggestionCountQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}"
        }
    };
}();
$41493c5c0e5e4e0b$var$node.hash = "050919681608acb31690dce800b52bae";
var $41493c5c0e5e4e0b$export$2e2bcd8739ae039 = $41493c5c0e5e4e0b$var$node;
module.exports["default"] = $41493c5c0e5e4e0b$export$2e2bcd8739ae039;

});

parcelRegister("jwbRi", function(module, exports) {
/**
 * @generated SignedSource<<38626ff8705a6c0de9b2d1e6d56973af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b18ce3bc11082c03$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useFetchSuggestionCount_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ],
    "type": "Query"
};
$b18ce3bc11082c03$var$node.hash = "b4d0196e6c2004ac771cb71891cd74af";
var $b18ce3bc11082c03$export$2e2bcd8739ae039 = $b18ce3bc11082c03$var$node;
module.exports["default"] = $b18ce3bc11082c03$export$2e2bcd8739ae039;

});

parcelRegister("lbRgq", function(module, exports) {

let $f6d3f1286a8027b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6d3f1286a8027b3$var$load("536mm").then(()=>parcelRequire('l3QM4'));

});

parcelRegister("7xVCs", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kNIYN = parcelRequire("kNIYN");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $kNIYN.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("3pKmQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $f8iFu = parcelRequire("f8iFu");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");

const $780d238694391607$var$SpaceCreationEligibilityContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $780d238694391607$export$b1c2e13182f232fa = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { spaceFragmentRef: spaceFragmentRef, children: children } = t0;
    const space = (0, $6SsN4.useFragment)((0, $f8iFu.default), spaceFragmentRef);
    const t1 = space ?? null;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($780d238694391607$var$SpaceCreationEligibilityContext.Provider, {
            value: t1
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};
const $780d238694391607$export$556556d6d4191a9f = (spaceKey)=>{
    const space = (0, $cozmU.useContext)($780d238694391607$var$SpaceCreationEligibilityContext);
    return space?.key === spaceKey ? space : null;
};
module.exports["SpaceCreationEligibilityProvider"] = $780d238694391607$export$b1c2e13182f232fa;
module.exports["useSpaceCreationEligibility"] = $780d238694391607$export$556556d6d4191a9f;

});

parcelRegister("f8iFu", function(module, exports) {
/**
 * @generated SignedSource<<0e68ca969e6af973adcac73b40f14e68>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $194444c20a95b36b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceCreationEligibility_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "FragmentSpread",
            "name": "FooterCreateButtons_space"
        },
        {
            "kind": "FragmentSpread",
            "name": "useSpaceEnabledContentTypes_space"
        },
        {
            "kind": "FragmentSpread",
            "name": "ContextualCreateContentButton_space"
        }
    ],
    "type": "Space"
};
$194444c20a95b36b$var$node.hash = "86ebdf059e3b96c0adbb17f3a4baea25";
var $194444c20a95b36b$export$2e2bcd8739ae039 = $194444c20a95b36b$var$node;
module.exports["default"] = $194444c20a95b36b$export$2e2bcd8739ae039;

});

parcelRegister("huaOC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4Qc44 = parcelRequire("4Qc44");


var $lmzCg = parcelRequire("lmzCg");


var $hLtfj = parcelRequire("hLtfj");


var $KuePV = parcelRequire("KuePV");


var $4o9cR = parcelRequire("4o9cR");

const $e30c6d4ea2de4ef1$var$listItemStyles = {
    root: "_2pQraJ0Qmj"
};
const $e30c6d4ea2de4ef1$var$LinkMenuItemNoRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(26);
    const { testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const itemRef = (0, $cozmU.useRef)(null);
    const t1 = isSelected ?? false;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            elementRef: itemRef,
            isSelected: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    (0, $4o9cR.useScrollMenuItemIntoView)(t2);
    const t3 = listItemRef ?? null;
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $lmzCg.default)([
            itemRef,
            t3
        ]);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    const ref = t4;
    let t5;
    if ($[4] !== actions || $[5] !== actionsOnHover || $[6] !== children || $[7] !== description || $[8] !== dropIndicator || $[9] !== elemAfter || $[10] !== elemBefore || $[11] !== forwardedRef || $[12] !== hasDragIndicator || $[13] !== href || $[14] !== interactionName || $[15] !== isContentTooltipDisabled || $[16] !== isDragging || $[17] !== isSelected || $[18] !== onClick || $[19] !== target || $[20] !== testId || $[21] !== visualContentRef) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children);
        $[4] = actions;
        $[5] = actionsOnHover;
        $[6] = children;
        $[7] = description;
        $[8] = dropIndicator;
        $[9] = elemAfter;
        $[10] = elemBefore;
        $[11] = forwardedRef;
        $[12] = hasDragIndicator;
        $[13] = href;
        $[14] = interactionName;
        $[15] = isContentTooltipDisabled;
        $[16] = isDragging;
        $[17] = isSelected;
        $[18] = onClick;
        $[19] = target;
        $[20] = testId;
        $[21] = visualContentRef;
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== ref || $[24] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
            ref: ref,
            xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
        }, t5);
        $[23] = ref;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    return t6;
} : ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $4o9cR.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $cozmU.useMemo)(()=>{
        return (0, $lmzCg.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $hLtfj.ListItem), {
        ref: ref,
        xcss: $e30c6d4ea2de4ef1$var$listItemStyles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
        testId: testId,
        description: description,
        actions: actions,
        elemAfter: elemAfter,
        elemBefore: elemBefore,
        href: href,
        target: target,
        actionsOnHover: actionsOnHover,
        isSelected: isSelected,
        onClick: onClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
};
const $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f = (0, $4Qc44.default)($e30c6d4ea2de4ef1$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $e30c6d4ea2de4ef1$export$d2cad7a1cce7b35f;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("4o9cR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $8AWCX = parcelRequire("8AWCX");

function $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element) {
    /**
   * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
   * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
   * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
   *
   * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
   */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
const $9fe3f1218f1710c7$export$2c52ec851fcc6058 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScrollMenuItemIntoView(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { elementRef: elementRef, isSelected: isSelected } = t0;
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            type: "waiting-to-be-selected-and-all-ancestors-expanded"
        };
        $[0] = t1;
    } else t1 = $[0];
    const waitingStateRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[1] !== areAllAncestorsExpanded || $[2] !== elementRef || $[3] !== isSelected) {
        t2 = ()=>{
            if (waitingStateRef.current.type === "waiting-to-be-selected-and-all-ancestors-expanded") {
                const shouldScroll = areAllAncestorsExpanded && isSelected;
                if (!shouldScroll) return;
                const element = elementRef.current;
                (0, $bB0i2.default)(element, "Element ref must be set");
                $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
                waitingStateRef.current.type = "waiting-to-be-unselected";
                return;
            }
            if (waitingStateRef.current.type === "waiting-to-be-unselected") {
                if (!isSelected) waitingStateRef.current.type = "waiting-to-be-selected-and-all-ancestors-expanded";
                return;
            }
        };
        t3 = [
            areAllAncestorsExpanded,
            elementRef,
            isSelected
        ];
        $[1] = areAllAncestorsExpanded;
        $[2] = elementRef;
        $[3] = isSelected;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : function useScrollMenuItemIntoView({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $cozmU.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $cozmU.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $bB0i2.default)(element, 'Element ref must be set');
            $9fe3f1218f1710c7$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
};
module.exports["useScrollMenuItemIntoView"] = $9fe3f1218f1710c7$export$2c52ec851fcc6058;

});

parcelRegister("04jMq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e27872478384c0$export$7f1bcb54a9a4d80e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kWSCB",
    name: "ShortcutsSection",
    loader: async ()=>(await (parcelRequire("bjsaZ"))).ShortcutsSection
});
module.exports["ShortcutsSection"] = $16e27872478384c0$export$7f1bcb54a9a4d80e;

});

parcelRegister("bjsaZ", function(module, exports) {

let $83c75346ce418a4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $83c75346ce418a4c$var$load("ea3NB"),
    $83c75346ce418a4c$var$load("45r7q"),
    $83c75346ce418a4c$var$load("6wr18"),
    $83c75346ce418a4c$var$load("2ZSSd"),
    $83c75346ce418a4c$var$load("hgxd4"),
    $83c75346ce418a4c$var$load("llcQo"),
    $83c75346ce418a4c$var$load("Wowvf"),
    $83c75346ce418a4c$var$load("4fTpk"),
    $83c75346ce418a4c$var$load("7oAXW"),
    $83c75346ce418a4c$var$load("jXx9i"),
    $83c75346ce418a4c$var$load("ffEVr"),
    $83c75346ce418a4c$var$load("a6kGP"),
    $83c75346ce418a4c$var$load("dB5kj"),
    $83c75346ce418a4c$var$load("fwbNS"),
    $83c75346ce418a4c$var$load("7J1PC"),
    $83c75346ce418a4c$var$load("446Ip"),
    $83c75346ce418a4c$var$load("ckGjo"),
    $83c75346ce418a4c$var$load("aqs28"),
    $83c75346ce418a4c$var$load("hhss7"),
    $83c75346ce418a4c$var$load("7EorR"),
    $83c75346ce418a4c$var$load("1NnjK")
]).then(()=>parcelRequire('eTFt9'));

});

parcelRegister("d5um7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5Dlqn = parcelRequire("5Dlqn");


var $h11I1 = parcelRequire("h11I1");


var $8AWCX = parcelRequire("8AWCX");

const $6b9c8550570135b2$var$relativeStyles = {
    root: "_1mT5xdRAKS"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $6b9c8550570135b2$export$341dea48c30b36ff = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(21);
    const { isExpanded: isExpandedControlled, isDefaultExpanded: t1, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId } = t0;
    const isDefaultExpanded = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isDefaultExpanded) {
        t2 = ()=>isDefaultExpanded;
        $[0] = isDefaultExpanded;
        $[1] = t2;
    } else t2 = $[1];
    const [isExpanded, setIsExpanded] = (0, $5Dlqn.default)(isExpandedControlled, t2);
    const t3 = onExpansionToggle ?? null;
    const t4 = dropIndicator && $6b9c8550570135b2$var$relativeStyles.root;
    let t5;
    if ($[2] !== t4) {
        t5 = (0, $hekY6.default)([
            t4
        ]);
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== children || $[5] !== dropIndicator || $[6] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t5
        }, children, dropIndicator);
        $[4] = children;
        $[5] = dropIndicator;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== forwardedRef || $[9] !== t6 || $[10] !== testId) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $h11I1.MenuListItem), {
            ref: forwardedRef,
            testId: testId
        }, t6);
        $[8] = forwardedRef;
        $[9] = t6;
        $[10] = testId;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t3 || $[13] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.OnExpansionToggleContext).Provider, {
            value: t3
        }, t7);
        $[12] = t3;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== setIsExpanded || $[16] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.SetIsExpandedContext).Provider, {
            value: setIsExpanded
        }, t8);
        $[15] = setIsExpanded;
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== isExpanded || $[19] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.IsExpandedContext).Provider, {
            value: isExpanded
        }, t9);
        $[18] = isExpanded;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    return t10;
} : ({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $5Dlqn.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.IsExpandedContext).Provider, {
        value: isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.SetIsExpandedContext).Provider, {
        value: setIsExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.OnExpansionToggleContext).Provider, {
        value: onExpansionToggle ?? null
    }, /*#__PURE__*/ $cozmU.createElement((0, $h11I1.MenuListItem), {
        ref: forwardedRef,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            dropIndicator && $6b9c8550570135b2$var$relativeStyles.root
        ])
    }, children, dropIndicator)))));
});
module.exports["ExpandableMenuItem"] = $6b9c8550570135b2$export$341dea48c30b36ff;

});

parcelRegister("jZuGB", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $k27u5 = parcelRequire("k27u5");


var $8AWCX = parcelRequire("8AWCX");

const $9c28a97efb757560$var$expandableMenuItemIndentation = '12px';
const $9c28a97efb757560$var$styles = {
    content: "_0LQT5ExpxF",
    collapsedContent: "_3iDTPbYbGa"
};
const $9c28a97efb757560$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $8AWCX.useIsExpanded)();
    const level = (0, $8AWCX.useLevel)();
    const hasExpanded = (0, $cozmU.useRef)(false);
    const areAllAncestorsExpanded = (0, $8AWCX.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.LevelContext).Provider, {
        value: level + 1
    }, /*#__PURE__*/ $cozmU.createElement((0, $8AWCX.AreAllAncestorsExpandedContext).Provider, {
        value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded
    }, /*#__PURE__*/ $cozmU.createElement((0, $k27u5.List), {
        ref: forwardedRef,
        xcss: (0, $k12R1.cx)($9c28a97efb757560$var$styles.content, !isExpanded && $9c28a97efb757560$var$styles.collapsedContent)
    }, children)));
});
module.exports["ExpandableMenuItemContent"] = $9c28a97efb757560$export$bd680a81504a92e9;

});

parcelRegister("k27u5", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");

function $3028fcb6dba16eaa$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ $cozmU.createElement("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId
    }, children));
}
const $3028fcb6dba16eaa$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $cozmU.forwardRef)($3028fcb6dba16eaa$var$_List);
module.exports["List"] = $3028fcb6dba16eaa$export$54c2e3dc7acea9f5;

});

parcelRegister("gMhPZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $4Qc44 = parcelRequire("4Qc44");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $KuePV = parcelRequire("KuePV");


var $4o9cR = parcelRequire("4o9cR");


var $8AWCX = parcelRequire("8AWCX");

const $17b37eab23d553a8$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $17b37eab23d553a8$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $17b37eab23d553a8$var$wrapperStyles = {
    root: "_3RTSTAQ4SZ _2MvGBxYbGa",
    showProvidedElemBefore: "_3RTSTAYbGa _2MvGBxcK7c _3g4o8sQ4SZ _1H0K9XYbGa _0Jml7pQ4SZ _4sQNN8Q4SZ _2zl65PYbGa _1FfrqxYbGa"
}; // Merge back into the `wrapperStyles` after cleanup
const $17b37eab23d553a8$var$nestedOpenPopupStyles = {
    showProvidedElemBefore: "_3g4o8sQ4SZ _1H0K9XYbGa"
};
const $17b37eab23d553a8$var$iconStyles = {
    chevron: "_3iDTPbismd _4lYzgRyz1h",
    providedElemBefore: "_3iDTPbC5M9",
    providedElemBeforeSelected: "_1UtDYzrFwf"
};
const $17b37eab23d553a8$var$ExpandableMenuItemIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore } = t0;
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const t1 = isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined;
    let t2;
    if ($[0] !== ChevronIcon || $[1] !== iconProps || $[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
            ...iconProps,
            label: "",
            color: t1,
            size: "small"
        });
        $[0] = ChevronIcon;
        $[1] = iconProps;
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const chevronElem = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.chevron
        ]);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== chevronElem) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t3
        }, chevronElem);
        $[5] = chevronElem;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isSelected || $[8] !== providedElemBefore) {
        t5 = providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $17b37eab23d553a8$var$iconStyles.providedElemBefore,
                isSelected && $17b37eab23d553a8$var$iconStyles.providedElemBeforeSelected
            ])
        }, providedElemBefore);
        $[7] = isSelected;
        $[8] = providedElemBefore;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t4 || $[11] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t5);
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl)));
    const chevronElem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.chevron
        ])
    }, chevronElem), providedElemBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$iconStyles.providedElemBefore,
            isSelected && $17b37eab23d553a8$var$iconStyles.providedElemBeforeSelected
        ])
    }, providedElemBefore));
};
const $17b37eab23d553a8$export$fe6fe51056867f4d = (0, $4Qc44.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $cozmU.useId)();
    const onExpansionToggle = (0, $8AWCX.useOnExpansionToggle)();
    const isExpanded = (0, $8AWCX.useIsExpanded)();
    const setIsExpanded = (0, $8AWCX.useSetIsExpanded)();
    const itemRef = (0, $cozmU.useRef)(null);
    const handleIconClick = (0, $cozmU.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $4o9cR.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17b37eab23d553a8$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17b37eab23d553a8$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: itemRef,
        className: (0, $hekY6.default)([
            $17b37eab23d553a8$var$wrapperStyles.root,
            providedElemBefore && $17b37eab23d553a8$var$wrapperStyles.showProvidedElemBefore,
            $17b37eab23d553a8$var$nestedOpenPopupStyles.showProvidedElemBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KuePV.MenuItemBase), {
        id: id,
        actions: actions,
        actionsOnHover: actionsOnHover,
        elemBefore: elemBefore,
        ariaExpanded: isExpanded,
        elemAfter: elemAfter,
        href: href,
        isSelected: isSelected,
        onClick: handleMenuContentClick,
        ref: forwardedRef,
        visualContentRef: visualContentRef,
        testId: testId,
        interactionName: interactionName,
        isContentTooltipDisabled: isContentTooltipDisabled,
        isDragging: isDragging,
        hasDragIndicator: hasDragIndicator,
        dropIndicator: dropIndicator
    }, children));
});
module.exports["ExpandableMenuItemTrigger"] = $17b37eab23d553a8$export$fe6fe51056867f4d;

});

parcelRegister("3qtLb", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

const $674e09754a51af28$export$19ffb24f8071504 = 2;

const $674e09754a51af28$export$10d5dbd9dd81149f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-KKls",
    name: "PageTreeLoader",
    loader: async ()=>(await (parcelRequire("eF93Y"))).PageTree
});
const $674e09754a51af28$export$73500bf5f2e2b0c4 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($674e09754a51af28$export$10d5dbd9dd81149f, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["ANIMATE_TIME_SEC"] = $674e09754a51af28$export$19ffb24f8071504;
module.exports["PageTreeLoader"] = $674e09754a51af28$export$10d5dbd9dd81149f;
module.exports["PageTree"] = $674e09754a51af28$export$73500bf5f2e2b0c4;

});

parcelRegister("eF93Y", function(module, exports) {

let $aacbecc53f326147$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aacbecc53f326147$var$load("4a1y5"),
    $aacbecc53f326147$var$load("dZulV"),
    $aacbecc53f326147$var$load("llcQo"),
    $aacbecc53f326147$var$load("aLbuU"),
    $aacbecc53f326147$var$load("hR9G5"),
    $aacbecc53f326147$var$load("45r7q"),
    $aacbecc53f326147$var$load("6wr18"),
    $aacbecc53f326147$var$load("e4XZ1"),
    $aacbecc53f326147$var$load("b1J58"),
    $aacbecc53f326147$var$load("gbDLp"),
    $aacbecc53f326147$var$load("gUrlb"),
    $aacbecc53f326147$var$load("k1PJ7"),
    $aacbecc53f326147$var$load("4fYzp"),
    $aacbecc53f326147$var$load("jzPyj"),
    $aacbecc53f326147$var$load("bxj2D"),
    $aacbecc53f326147$var$load("4fTpk"),
    $aacbecc53f326147$var$load("i1I18"),
    $aacbecc53f326147$var$load("kHXvF"),
    $aacbecc53f326147$var$load("ffEVr"),
    $aacbecc53f326147$var$load("Wowvf"),
    $aacbecc53f326147$var$load("20wSi"),
    $aacbecc53f326147$var$load("9LDVS"),
    $aacbecc53f326147$var$load("kiMHu"),
    $aacbecc53f326147$var$load("7J1PC"),
    $aacbecc53f326147$var$load("446Ip"),
    $aacbecc53f326147$var$load("fwbNS"),
    $aacbecc53f326147$var$load("8OeKT"),
    $aacbecc53f326147$var$load("hhss7"),
    $aacbecc53f326147$var$load("7EorR"),
    $aacbecc53f326147$var$load("ltXeo")
]).then(()=>parcelRequire('bbZCI'));

});

parcelRegister("b3j2Y", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");

function $ff81fbcf85bdaf85$export$d56b0569bceb92ae(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { children: children, error: error } = t0;
    const [errorListenerIsReady, setErrorListenerIsReady] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== error) {
        t1 = ()=>{
            const listener = (event)=>{
                if (event.error === error) event.preventDefault();
            };
            window.addEventListener("error", listener);
            setErrorListenerIsReady(true);
            return ()=>{
                window.removeEventListener("error", listener);
                setErrorListenerIsReady(false);
            };
        };
        t2 = [
            error,
            setErrorListenerIsReady
        ];
        $[0] = error;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    const renderOnError = t3;
    let t4;
    if ($[5] !== error || $[6] !== errorListenerIsReady) {
        t4 = errorListenerIsReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff81fbcf85bdaf85$export$4d51f41a5e7cc382, {
            error: error
        }) : null;
        $[5] = error;
        $[6] = errorListenerIsReady;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== renderOnError || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).INHERIT,
            renderOnError: renderOnError
        }, t4);
        $[8] = renderOnError;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
}
function $ff81fbcf85bdaf85$export$4d51f41a5e7cc382({ error: error }) {
    throw error;
}
module.exports["ErrorDisplay"] = $ff81fbcf85bdaf85$export$d56b0569bceb92ae;

});

parcelRegister("k5uAm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $9eE57 = parcelRequire("9eE57");


var $jsQN1 = parcelRequire("jsQN1");

const $f35e894e447c6262$export$2de55e286c149cfa = 300;
const $f35e894e447c6262$export$1bbe776c3ae63e35 = 400;
const $f35e894e447c6262$export$3bba19b3f6dc31cd = (source)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn } = (0, $jsQN1.useHoverPageCardsOptStatus)();
    // the tree item id and the trigger should be grouped into one state as the trigger always corresponds with the itemID
    // this prevents unnecessary rerenders of the hover page card
    const [showHoverPageCardForItem, setShowHoverPageCardForItem] = (0, $cozmU.useState)({
        itemID: null,
        trigger: null
    });
    const openSidebarPopupTimerRef = (0, $cozmU.useRef)(null);
    const closeSidebarPopupTimerRef = (0, $cozmU.useRef)(null);
    /**
   * Cancel the open sidebar popup cards timer
   */ const clearOpenSidebarPopupTimer = (0, $cozmU.useCallback)(()=>{
        if (openSidebarPopupTimerRef?.current) {
            clearTimeout(openSidebarPopupTimerRef.current);
            openSidebarPopupTimerRef.current = null;
        }
    }, [
        openSidebarPopupTimerRef
    ]);
    /**
   * Cancel the close sidebar popup cards timer
   */ const clearCloseSidebarPopupTimer = (0, $cozmU.useCallback)(()=>{
        if (closeSidebarPopupTimerRef.current) {
            clearTimeout(closeSidebarPopupTimerRef?.current);
            closeSidebarPopupTimerRef.current = null;
        }
    }, [
        closeSidebarPopupTimerRef
    ]);
    /**
   * On mouse enter/focus of the hover target, create a hover card for that itemId
   * Start the timer which will open the popup if the user hovers on the tree item for HOVER_DELAY_TIME.
   * Clears any closePageCard timers since we don't need to close the popup, we can just replace the showHoverPageCardForItem.
   * This is called onMouseOver of page tree items.
   */ const onEnterHoverTarget = (0, $cozmU.useCallback)(({ itemID: itemID, isQuickActionsFocused: isQuickActionsFocused, hoverPageCardTriggerRef: hoverPageCardTriggerRef, isContextualCreateFocused: isContextualCreateFocused })=>{
        clearCloseSidebarPopupTimer();
        // only show a hover card if it matches to conditions to show it and it isn't already showing a card for the same itemID
        if (isHoverPageCardOptedIn && !isQuickActionsFocused && !isContextualCreateFocused && showHoverPageCardForItem.itemID !== itemID) {
            if (openSidebarPopupTimerRef.current === null) openSidebarPopupTimerRef.current = setTimeout(()=>{
                // this setstate is the one and only line that causes SpaceHoverPageCard to rerender
                setShowHoverPageCardForItem({
                    itemID: itemID,
                    trigger: hoverPageCardTriggerRef
                });
                experienceTracker.start({
                    name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).SPACE_VIEWS,
                    attributes: {
                        source: source
                    }
                });
                (0, $9eE57.perfMarkStart)({
                    subject: 'HoverPageCard',
                    subjectId: 'rendered'
                });
                openSidebarPopupTimerRef.current = null;
            }, $f35e894e447c6262$export$2de55e286c149cfa);
        }
    }, // adding showHoverPageCardForItem into the dependency array causes the entire page tree to rerender on any item hover.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        clearCloseSidebarPopupTimer,
        experienceTracker,
        isHoverPageCardOptedIn,
        source
    ]);
    /**
   * Closes all popups after CLOSE_DELAY_TIME if the closeSidebarPopupTimerRef timer has not been cleared before then
   * Called on mouse leave of a page tree item
   */ const startCloseHoverPageCardTimer = (0, $cozmU.useCallback)(()=>{
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
        clearOpenSidebarPopupTimer();
        if (closeSidebarPopupTimerRef.current === null) closeSidebarPopupTimerRef.current = setTimeout(()=>{
            setShowHoverPageCardForItem({
                itemID: null,
                trigger: null
            });
            closeSidebarPopupTimerRef.current = null;
        }, $f35e894e447c6262$export$1bbe776c3ae63e35);
    }, [
        experienceTracker,
        clearOpenSidebarPopupTimer
    ]);
    /**
   * Clear all the timers, called when the mouse reenters
   */ const clearHoverPageCardTimers = (0, $cozmU.useCallback)(()=>{
        clearOpenSidebarPopupTimer();
        clearCloseSidebarPopupTimer();
    }, [
        clearOpenSidebarPopupTimer,
        clearCloseSidebarPopupTimer
    ]);
    /**
   * Immediately force close all popups when this is called.
   * Called when the popup is clicked on or when the page is redirected
   */ const closeAllHoverPageCards = (0, $cozmU.useCallback)(()=>{
        clearHoverPageCardTimers();
        setShowHoverPageCardForItem({
            itemID: null,
            trigger: null
        });
        experienceTracker.abort({
            name: (0, $irVI7.SPACE_VIEWS_HOVER_PAGE_CARD_EXPERIENCE),
            reason: 'Popup closed'
        });
    }, [
        experienceTracker,
        clearHoverPageCardTimers
    ]);
    /**
   * On mouseleave of the hover target, start close timer for that item's hover card
   */ const onLeaveHoverTarget = (0, $cozmU.useCallback)(()=>{
        startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    /**
   * On blur of the hover target, start close timer for that item's hover card
   */ const onBlurHoverTarget = (0, $cozmU.useCallback)((e)=>{
        if (!e.currentTarget.contains(e.relatedTarget)) startCloseHoverPageCardTimer();
    }, [
        startCloseHoverPageCardTimer
    ]);
    return {
        closeAllHoverPageCards: closeAllHoverPageCards,
        startCloseHoverPageCardTimer: startCloseHoverPageCardTimer,
        clearHoverPageCardTimers: clearHoverPageCardTimers,
        showHoverPageCardForItem: showHoverPageCardForItem,
        isHoverPageCardOptedIn: isHoverPageCardOptedIn,
        onEnterHoverTarget: onEnterHoverTarget,
        onLeaveHoverTarget: onLeaveHoverTarget,
        onBlurHoverTarget: onBlurHoverTarget
    };
};
module.exports["useHoverPageCard"] = $f35e894e447c6262$export$3bba19b3f6dc31cd;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("jsQN1", function(module, exports) {

var $4Tg4P = parcelRequire("4Tg4P");


var $bQm3c = parcelRequire("bQm3c");


var $5xaHK = parcelRequire("5xaHK");


var $jMyy4 = parcelRequire("jMyy4");

const $2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery = (0, $4Tg4P.default);
const $2d41bbac85093ab1$export$f824d805fc04fcb2 = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($2d41bbac85093ab1$var$useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery, {
        skip: !isLicensed,
        __callerPackage__: "page-card"
    });
    // don't render popups for anon users.
    // This is after the useQuery because conditionally running hooks isn't allowed.
    if (!isLicensed) return {
        isHoverPageCardOptedIn: false
    };
    const userPreference = data?.userPreferences?.shouldShowCardOnPageTreeHover;
    return {
        isHoverPageCardOptedIn: userPreference !== (0, $5xaHK.PageCardInPageTreeHoverPreference).NO_SHOW_PAGECARD
    };
};
module.exports["useHoverPageCardsOptStatus"] = $2d41bbac85093ab1$export$f824d805fc04fcb2;

});

parcelRegister("4Tg4P", function(module, exports) {
/**
 * @generated SignedSource<<a665c5157f59b317979b9478df22a2c3>>
 * @relayHash d1f433c5859a639556bc75700750a999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006
const $48c38c534b125c22$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "shouldShowCardOnPageTreeHover"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d1f433c5859a639556bc75700750a999",
            "id": "120a251ef0e72af4b4ef1b63e426a00a7b1a22b16ee4caccb4dd87acdfa9d006",
            "metadata": {},
            "name": "useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery",
            "operationKind": "query",
            "text": "query useHoverPageCardsOptStatusHoverPageCardsOptStatusQuery{userPreferences{shouldShowCardOnPageTreeHover}}"
        }
    };
}();
$48c38c534b125c22$var$node.hash = "1e92ca51a019c1c7e4b73556b6c593ea";
var $48c38c534b125c22$export$2e2bcd8739ae039 = $48c38c534b125c22$var$node;
module.exports["default"] = $48c38c534b125c22$export$2e2bcd8739ae039;

});

parcelRegister("5xaHK", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab = /*#__PURE__*/ function(PageCardInPageTreeHoverPreference) {
    PageCardInPageTreeHoverPreference["NO_OPTION_SELECTED"] = "NO_OPTION_SELECTED";
    PageCardInPageTreeHoverPreference["NO_SHOW_PAGECARD"] = "NO_SHOW_PAGECARD";
    PageCardInPageTreeHoverPreference["SHOW_PAGECARD"] = "SHOW_PAGECARD";
    return PageCardInPageTreeHoverPreference;
}({});
module.exports["PageCardInPageTreeHoverPreference"] = $f8a43fdc91a5738e$export$8d4d3d8b2da7ecab;

});

parcelRegister("lfFzM", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim,
        __callerPackage__: "super-admin"
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("6jrkJ", function(module, exports) {

var $68uaC = parcelRequire("68uaC");

const $00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE = 'confluence.asSuperAdmin';
function $00ee7f2affe27fcd$export$2fc1623749affa1a() {
    return Boolean((0, $68uaC.Cookies).get($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE));
}
function $00ee7f2affe27fcd$export$b097cdee5288154b() {
    (0, $68uaC.Cookies).removeStrictlyNecessary($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE);
}
async function $00ee7f2affe27fcd$export$f5d5d0f409509831() {
    await (0, $68uaC.Cookies).set($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE, 'true', undefined, (0, $68uaC.CookieLevel).NECESSARY);
}
module.exports["getSuperAdminClaim"] = $00ee7f2affe27fcd$export$2fc1623749affa1a;
module.exports["removeSuperAdminClaim"] = $00ee7f2affe27fcd$export$b097cdee5288154b;
module.exports["setSuperAdminClaim"] = $00ee7f2affe27fcd$export$f5d5d0f409509831;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<994231445f227a67e1aaccbbe4790b5b>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("i28ZW", function(module, exports) {

var $i0mmi = parcelRequire("i0mmi");


var $6mKj3 = parcelRequire("6mKj3");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");


var $jMyy4 = parcelRequire("jMyy4");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $i0mmi.default);
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$a7c1ec142e70d69d = 'archive';
const $981a614bc39b93a3$export$92f9e1ed9114d3a6 = 'copy';
const $981a614bc39b93a3$export$3ea24d3a964169d2 = 'view_analytics';
const $981a614bc39b93a3$export$df267ad9042b4cda = 'export';
const $981a614bc39b93a3$export$4111393d4921f4a7 = 'create';
const $981a614bc39b93a3$export$5c2e91d1aa10ff80 = 'attachment';
const $981a614bc39b93a3$export$b838cef2a8827875 = (operations, spaceOperation)=>{
    return operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
};
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled && !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        },
        __callerPackage__: "space-utils"
    });
    const operations = data?.space?.operations;
    return {
        canManageSomeUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a89133b28496ff30),
        canManageSettingsAutomation: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$50faaafd42078ad9),
        canArchive: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a7c1ec142e70d69d),
        canCopy: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$92f9e1ed9114d3a6),
        canViewAnalytics: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3ea24d3a964169d2),
        canExportSpace: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$df267ad9042b4cda),
        canAddAttachment: operations?.some((operation)=>operation?.operation === $981a614bc39b93a3$export$4111393d4921f4a7 && operation?.targetType === $981a614bc39b93a3$export$5c2e91d1aa10ff80) ?? false,
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["MANAGE_PUBLIC_LINKS"] = $981a614bc39b93a3$export$fae9e1a00840692e;
module.exports["ADMINISTER"] = $981a614bc39b93a3$export$80ed1bd55ccf4772;
module.exports["MANAGE_CONTENT"] = $981a614bc39b93a3$export$50faaafd42078ad9;
module.exports["hasSpaceOperation"] = $981a614bc39b93a3$export$b838cef2a8827875;
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("i0mmi", function(module, exports) {
/**
 * @generated SignedSource<<10e9286ab7437b1579bfb197b3cdf663>>
 * @relayHash 0a3dc9cecca8233daf01e0443fdaa5e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471
const $7dc84e66153faa36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0a3dc9cecca8233daf01e0443fdaa5e6",
            "id": "1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471",
            "metadata": {},
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "operationKind": "query",
            "text": "query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin},operations{operation,targetType}}}"
        }
    };
}();
$7dc84e66153faa36$var$node.hash = "4d967e32f567d3367490b1d8fb6f1ecf";
var $7dc84e66153faa36$export$2e2bcd8739ae039 = $7dc84e66153faa36$var$node;
module.exports["default"] = $7dc84e66153faa36$export$2e2bcd8739ae039;

});

parcelRegister("iquRY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !isLoggedIn;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1,
            onError: $cccaa992351fdb79$var$_temp
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t3 = data?.confluence_spaceRoleMode;
    let t4;
    if ($[5] !== isNotPreRoles || $[6] !== loading || $[7] !== t3) {
        t4 = {
            spaceRoleMode: t3,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[5] = isNotPreRoles;
        $[6] = loading;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<2ff02ee1cce578f61d9a435abf2def2c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("j3kZx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $cozmU.useState)();
    const isDefaultExpanded = (0, $cozmU.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $cozmU.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
    const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};
module.exports["useSpacePersistentExpansion"] = $748c02fb00e52ac9$export$a0aa95d2fbef03e8;

});

parcelRegister("gCFsY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d9810ba2fa073e42$export$d09f0ee316c3b5c1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "06Lgw",
    name: "LazySpaceHoverPageCard",
    loader: async ()=>(await (parcelRequire("fqaMD"))).SpaceHoverPageCard
});
module.exports["LazySpaceHoverPageCard"] = $d9810ba2fa073e42$export$d09f0ee316c3b5c1;

});

parcelRegister("fqaMD", function(module, exports) {

let $b3a1a61c1e3fbf68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b3a1a61c1e3fbf68$var$load("fEMSy"),
    $b3a1a61c1e3fbf68$var$load("1lDWJ"),
    $b3a1a61c1e3fbf68$var$load("9LDVS"),
    $b3a1a61c1e3fbf68$var$load("kiMHu"),
    $b3a1a61c1e3fbf68$var$load("7m6JR"),
    $b3a1a61c1e3fbf68$var$load("bb3WM"),
    $b3a1a61c1e3fbf68$var$load("hEj0j"),
    $b3a1a61c1e3fbf68$var$load("i35vr"),
    $b3a1a61c1e3fbf68$var$load("1GCFv"),
    $b3a1a61c1e3fbf68$var$load("30b92"),
    $b3a1a61c1e3fbf68$var$load("4nZ85"),
    $b3a1a61c1e3fbf68$var$load("gIO2h"),
    $b3a1a61c1e3fbf68$var$load("32NHR"),
    $b3a1a61c1e3fbf68$var$load("glmO2"),
    $b3a1a61c1e3fbf68$var$load("giX30"),
    $b3a1a61c1e3fbf68$var$load("lUYNi"),
    $b3a1a61c1e3fbf68$var$load("1cQg7"),
    $b3a1a61c1e3fbf68$var$load("le1z7"),
    $b3a1a61c1e3fbf68$var$load("4xsdA"),
    $b3a1a61c1e3fbf68$var$load("kHXvF"),
    $b3a1a61c1e3fbf68$var$load("iWnyc"),
    $b3a1a61c1e3fbf68$var$load("ea3NB"),
    $b3a1a61c1e3fbf68$var$load("6wr18"),
    $b3a1a61c1e3fbf68$var$load("59hV4"),
    $b3a1a61c1e3fbf68$var$load("fuOfV"),
    $b3a1a61c1e3fbf68$var$load("jL1Ke"),
    $b3a1a61c1e3fbf68$var$load("5MQ0D"),
    $b3a1a61c1e3fbf68$var$load("3LYaV"),
    $b3a1a61c1e3fbf68$var$load("ffEVr"),
    $b3a1a61c1e3fbf68$var$load("20wSi"),
    $b3a1a61c1e3fbf68$var$load("fwbNS"),
    $b3a1a61c1e3fbf68$var$load("7J1PC"),
    $b3a1a61c1e3fbf68$var$load("446Ip"),
    $b3a1a61c1e3fbf68$var$load("8OeKT"),
    $b3a1a61c1e3fbf68$var$load("h4Nf7"),
    $b3a1a61c1e3fbf68$var$load("Wowvf"),
    $b3a1a61c1e3fbf68$var$load("bSSct"),
    $b3a1a61c1e3fbf68$var$load("hhss7"),
    $b3a1a61c1e3fbf68$var$load("7EorR"),
    $b3a1a61c1e3fbf68$var$load("cQVtz")
]).then(()=>parcelRequire('k8aVt'));

});

parcelRegister("2vuKf", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $kBr4q.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0,
                loadingDescendantIds: new Set()
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $kBr4q.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $kBr4q.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("bOLC6", function(module, exports) {
/**
 * @generated SignedSource<<894f0475d89546b8f8ba914dd859e916>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3f5a4229d0143cd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsSpaceViewsPersistenceWriteFragment",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "UserPreferences"
};
$a3f5a4229d0143cd$var$node.hash = "9ec903133829a75826057a66a4a62727";
var $a3f5a4229d0143cd$export$2e2bcd8739ae039 = $a3f5a4229d0143cd$var$node;



var $3AeIf = parcelRequire("3AeIf");

/**
 * @generated SignedSource<<baa83179ea6ec445b8b4849c98f06252>>
 * @relayHash 197595cb76d03c058f5fbb845dc266a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b
const $2bef0e4e0b22cfa3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "persistenceOption"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "persistenceOption",
                                    "variableName": "persistenceOption"
                                },
                                v2 /*: any*/ 
                            ],
                            "kind": "ObjectValue",
                            "name": "spaceViewsPersistence"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        v2 /*: any*/ 
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "197595cb76d03c058f5fbb845dc266a1",
            "id": "89a76fcc88ae0753908f2aaff4b8debcf7a025d460506fe67d47266e32c2ec9b",
            "metadata": {},
            "name": "useSpaceViewsOptionsSpaceViewsPersistenceMutation",
            "operationKind": "mutation",
            "text": "mutation useSpaceViewsOptionsSpaceViewsPersistenceMutation($spaceKey:String!,$persistenceOption:SpaceViewsPersistenceOption!){updateUserPreferences(userPreferences:{spaceViewsPersistence:{spaceKey:$spaceKey,persistenceOption:$persistenceOption}}){spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$2bef0e4e0b22cfa3$var$node.hash = "c904b4b947ce0e659a2538aaffec18be";
var $2bef0e4e0b22cfa3$export$2e2bcd8739ae039 = $2bef0e4e0b22cfa3$var$node;


/**
 * @generated SignedSource<<d93db42c439d7cbbb31ca1a955877b2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a3e602a39b045224$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useSpaceViewsOptionsPersistence_userPreferences",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "spaceViewsPersistence"
        }
    ],
    "type": "UserPreferences"
};
$a3e602a39b045224$var$node.hash = "6e14a936c397037e855ea8ebac2ce34c";
var $a3e602a39b045224$export$2e2bcd8739ae039 = $a3e602a39b045224$var$node;



var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


const $c39f0c35d43dec0d$export$48adb441ab08928c = (0, $a3e602a39b045224$export$2e2bcd8739ae039);
const $c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation = (0, $2bef0e4e0b22cfa3$export$2e2bcd8739ae039);
const $c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery = (0, $3AeIf.default);
const $c39f0c35d43dec0d$export$1723fb5a667b3274 = (0, $kSwu1.defineMessages)({
    TREE: {
        id: "space-views.tree",
        defaultMessage: "Tree"
    },
    RECENTLY_VIEWED: {
        id: "space-views.recently.viewed",
        defaultMessage: "My visits"
    },
    RECENTLY_MODIFIED: {
        id: "space-views.recently.modified",
        defaultMessage: "Last updated"
    },
    TITLE_AZ: {
        id: "space-views.a-z.desc",
        defaultMessage: "Title - A to Z"
    }
});
const $c39f0c35d43dec0d$export$d285edfa1d91469 = (spaceKey, isLicensed = false, initialPersistenceData)=>{
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsPersistenceQuery, {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: !spaceKey || !isLicensed || initialPersistenceData !== undefined && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_space_views_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_space_nav_contract', 'isEnabled', false),
        __callerPackage__: "space-views"
    });
    const [updatePersistence, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($c39f0c35d43dec0d$var$useSpaceViewsOptionsSpaceViewsPersistenceMutation, {
        __callerPackage__: "space-views"
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039),
        fragmentSpec: (0, $a3f5a4229d0143cd$export$2e2bcd8739ae039),
        __callerPackage__: "space-views"
    });
    const setSpaceViewsSort = (0, $cozmU.useCallback)((newSort)=>{
        if (!spaceKey) return;
        updatePersistence({
            variables: {
                spaceKey: spaceKey,
                persistenceOption: newSort
            }
        }).catch(()=>{}); // ignoring errors here because we are consuming error from useMutation
        // Update the cache to keep UI updated regardless of whether the mutation succeeds
        writeFragmentInterop({
            fragmentId: `$ROOT_QUERY.userPreferences`,
            data: {
                spaceViewsPersistence: newSort,
                __typename: 'UserPreferences'
            },
            variables: {
                spaceKey: spaceKey
            }
        });
    }, [
        spaceKey,
        updatePersistence,
        writeFragmentInterop
    ]);
    const spaceViewsSort = initialPersistenceData?.spaceViewsPersistence || data?.userPreferences?.spaceViewsPersistence || 'TREE'; //tree is default
    return {
        spaceViewsSort: spaceViewsSort,
        setSpaceViewsSort: setSpaceViewsSort,
        queryLoading: initialPersistenceData ? false : queryLoading,
        queryError: initialPersistenceData ? undefined : queryError,
        mutationLoading: mutationLoading,
        mutationError: mutationError
    };
};
module.exports["SpaceViewsOptionsPersistenceFragment"] = $c39f0c35d43dec0d$export$48adb441ab08928c;
module.exports["sortI18n"] = $c39f0c35d43dec0d$export$1723fb5a667b3274;
module.exports["useSpaceViewsOptions"] = $c39f0c35d43dec0d$export$d285edfa1d91469;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<30433c300b34114d28e5a73869e7e5f1>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "ed56952e91ea2d83611b306fd16f1677";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("arWla", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _2sNsIg7NXe _0Of8r2HZdu _1Znuxb4Y4b _1wydGWHZdu _2Zuz6Q4Y4b _0KLXruDMqu _1UtDYzy7kJ _1kk5Tkmb2E",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$74be2ccc72ce5bce = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0jFU0VoWWg _39xV02oWWg",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$11b902a59791d036 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _2O5Vij7dHp",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$bbba74ab4c493bc2 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XghbEGDOm",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$97bdf39f6b82bb0 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYE8HPE _2XghbErjwI _2sNsIgmnOE _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _2fwxA5DIqT _0jFU0VWD6W _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});
const $c4de3c3a60bbeec4$export$b2471e0920d79944 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1DCdHi2ADO",
            __cmplp.className
        ])
    });
});
module.exports["DefaultLabel"] = $c4de3c3a60bbeec4$export$7d1bd82e49cf3a3b;
module.exports["NoIcon"] = $c4de3c3a60bbeec4$export$74be2ccc72ce5bce;
module.exports["FlexCenter"] = $c4de3c3a60bbeec4$export$11b902a59791d036;
module.exports["MoreButtonContainer"] = $c4de3c3a60bbeec4$export$bbba74ab4c493bc2;
module.exports["ErrorContainer"] = $c4de3c3a60bbeec4$export$97bdf39f6b82bb0;
module.exports["ErrorIconWrapper"] = $c4de3c3a60bbeec4$export$b2471e0920d79944;

});

parcelRegister("4AohO", function(module, exports) {

let $356d5cfdc4ea8e7e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $356d5cfdc4ea8e7e$var$load("iWnyc"),
    $356d5cfdc4ea8e7e$var$load("7J1PC"),
    $356d5cfdc4ea8e7e$var$load("446Ip"),
    $356d5cfdc4ea8e7e$var$load("8OeKT"),
    $356d5cfdc4ea8e7e$var$load("5TCys")
]).then(()=>parcelRequire('1wIcl'));

});

parcelRegister("24ns6", function(module, exports) {

let $181e259fa20d3761$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $181e259fa20d3761$var$load("aM1Vm"),
    $181e259fa20d3761$var$load("jrVkD"),
    $181e259fa20d3761$var$load("8Y23K"),
    $181e259fa20d3761$var$load("6gmSt")
]).then(()=>parcelRequire('5SYww'));

});

parcelRegister("beVTK", function(module, exports) {

let $82ede9e050da2cc6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $82ede9e050da2cc6$var$load("7J1PC"),
    $82ede9e050da2cc6$var$load("446Ip"),
    $82ede9e050da2cc6$var$load("kJLy8"),
    $82ede9e050da2cc6$var$load("jzPyj"),
    $82ede9e050da2cc6$var$load("hhss7"),
    $82ede9e050da2cc6$var$load("eQlG4")
]).then(()=>parcelRequire('32xcy'));

});

parcelRegister("jzS7A", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2956b96ada85ef60$export$a2e535ad780a85fe = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9L4J0",
    name: "BlogTree",
    loader: async ()=>(await (parcelRequire("6UPXX"))).BlogTree
});
module.exports["BlogTree"] = $2956b96ada85ef60$export$a2e535ad780a85fe;

});

parcelRegister("6UPXX", function(module, exports) {

let $5090486d0ea8c8bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5090486d0ea8c8bd$var$load("6damH"),
    $5090486d0ea8c8bd$var$load("9LDVS"),
    $5090486d0ea8c8bd$var$load("kiMHu"),
    $5090486d0ea8c8bd$var$load("ea3NB"),
    $5090486d0ea8c8bd$var$load("45r7q"),
    $5090486d0ea8c8bd$var$load("6wr18"),
    $5090486d0ea8c8bd$var$load("e4XZ1"),
    $5090486d0ea8c8bd$var$load("b1J58"),
    $5090486d0ea8c8bd$var$load("bxj2D"),
    $5090486d0ea8c8bd$var$load("llcQo"),
    $5090486d0ea8c8bd$var$load("4fTpk"),
    $5090486d0ea8c8bd$var$load("Wowvf"),
    $5090486d0ea8c8bd$var$load("aLbuU"),
    $5090486d0ea8c8bd$var$load("ffEVr"),
    $5090486d0ea8c8bd$var$load("20wSi"),
    $5090486d0ea8c8bd$var$load("7J1PC"),
    $5090486d0ea8c8bd$var$load("446Ip"),
    $5090486d0ea8c8bd$var$load("8OeKT"),
    $5090486d0ea8c8bd$var$load("hhss7"),
    $5090486d0ea8c8bd$var$load("7EorR"),
    $5090486d0ea8c8bd$var$load("hDNUK")
]).then(()=>parcelRequire('esUj7'));

});

parcelRegister("6jT5w", function(module, exports) {

let $499f3fc3dd87b5d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $499f3fc3dd87b5d3$var$load("jzPyj"),
    $499f3fc3dd87b5d3$var$load("bdsZU")
]).then(()=>parcelRequire('aiYSz'));

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Only the everything mode proceeds to data preloading.
        if (preloadOptions?.preloadingMode !== "everything") return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("lXV4d"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("lXV4d", function(module, exports) {

let $ffdb5ffe164d52e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ffdb5ffe164d52e8$var$load("hhss7"),
    $ffdb5ffe164d52e8$var$load("kyxdN")
]).then(()=>parcelRequire('asonV'));

});

parcelRegister("j7B9O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $6mKj3 = parcelRequire("6mKj3");


var $aqBZ0 = parcelRequire("aqBZ0");


var $gFF2G = parcelRequire("gFF2G");

/** The id of the node if it is archived, null if it isn't, undefined if the status isn't in the store. */ const $498d9fac54b01ff5$var$readArchivedIdFromStore = (environment, operation)=>{
    if (environment.check(operation).status !== 'available') return undefined;
    const data = environment.lookup(operation.fragment).data;
    const node = data?.content?.nodes?.[0];
    if (!node) return undefined;
    return node.status === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED) ? node.id ?? null : null;
};
const $498d9fac54b01ff5$export$2a442ff37ac56de5 = (contentId)=>{
    // Read the environment from context instead of `useRelayEnvironment`, which throws without a provider.
    // Callers such as the move dialog's tree can render outside one (e.g. Apollo-only tests); with no
    // environment there is nothing to read or fetch, so the hook reports "not archived".
    const environment = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext))?.environment;
    const [fetchedArchivedId, setFetchedArchivedId] = (0, $cozmU.useState)(null);
    // Bumped when the stored status changes (e.g. the page is restored) so the sync read stays fresh.
    const [storeVersion, setStoreVersion] = (0, $cozmU.useState)(0);
    // Gated by `confluence_archive_folder`: with it off there is no operation, so nothing is read or
    // fetched and every consumer of this hook sees `false` (the existing behavior).
    const operation = (0, $cozmU.useMemo)(()=>contentId && environment && (0, $6mKj3.expVal)('confluence_archive_folder', 'isEnabled', false) ? (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $gFF2G.default)), {
            contentId: contentId
        }) : null, [
        contentId,
        environment
    ]);
    const storedArchivedId = (0, $cozmU.useMemo)(()=>operation && environment ? $498d9fac54b01ff5$var$readArchivedIdFromStore(environment, operation) : undefined, // eslint-disable-next-line react-hooks/exhaustive-deps -- `storeVersion` re-reads the store after it changes
    [
        environment,
        operation,
        storeVersion
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!contentId || !operation || !environment) {
            setFetchedArchivedId(null);
            return;
        }
        const fetchSubscription = (0, $eqEJl.fetchQuery)(environment, (0, $gFF2G.default), {
            contentId: contentId
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                const node = data?.content?.nodes?.[0];
                setFetchedArchivedId(node?.status === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED) ? node.id ?? null : null);
            },
            error: ()=>setFetchedArchivedId(null)
        });
        const storeDisposable = environment.subscribe(environment.lookup(operation.fragment), ()=>setStoreVersion((version)=>version + 1));
        return ()=>{
            fetchSubscription.unsubscribe();
            storeDisposable.dispose();
        };
    }, [
        environment,
        operation,
        contentId
    ]);
    if (!contentId) return false;
    const archivedId = storedArchivedId !== undefined ? storedArchivedId : fetchedArchivedId;
    return archivedId === contentId;
};
module.exports["useIsContentArchived"] = $498d9fac54b01ff5$export$2a442ff37ac56de5;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("gFF2G", function(module, exports) {
/**
 * @generated SignedSource<<b09412736b8beecddca9546c0e2759d4>>
 * @relayHash 30a7ec0bd1bc84739eda7e4fe244b93f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d
const $385b63e5393fb4b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "30a7ec0bd1bc84739eda7e4fe244b93f",
            "id": "0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerContainerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$385b63e5393fb4b0$var$node.hash = "c639141edd782146ad296893dc79f146";
var $385b63e5393fb4b0$export$2e2bcd8739ae039 = $385b63e5393fb4b0$var$node;
module.exports["default"] = $385b63e5393fb4b0$export$2e2bcd8739ae039;

});

parcelRegister("c9Rq0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $c3b64ab3db691a18$var$styles = {
    'above.xs': "_2rTNeWYbGa",
    'above.sm': "_2UeR8bYbGa",
    'above.md': "_0THHewYbGa",
    'above.lg': "_1hlSbsYbGa",
    'above.xl': "_4pVFIkYbGa",
    'below.xs': "_3PnjIVYbGa",
    'below.sm': "_1U2uuEYbGa",
    'below.md': "_3RxhahYbGa",
    'below.lg': "_1q55U0YbGa",
    'below.xl': "_2HqVMBYbGa"
};
const $c3b64ab3db691a18$export$bed28288a051538 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { above: above, below: below, children: children, as: t1, xcss: xcss } = t0;
    const AsElement = t1 === undefined ? "div" : t1;
    const t2 = above && $c3b64ab3db691a18$var$styles[`above.${above}`];
    const t3 = below && $c3b64ab3db691a18$var$styles[`below.${below}`];
    let t4;
    if ($[0] !== t2 || $[1] !== t3 || $[2] !== xcss) {
        t4 = (0, $hekY6.default)([
            t2,
            t3,
            xcss
        ]);
        $[0] = t2;
        $[1] = t3;
        $[2] = xcss;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== AsElement || $[5] !== children || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)(AsElement, {
            className: t4,
            children: children
        });
        $[4] = AsElement;
        $[5] = children;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)(AsElement, {
        className: (0, $hekY6.default)([
            above && $c3b64ab3db691a18$var$styles[`above.${above}`],
            below && $c3b64ab3db691a18$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};
module.exports["Hide"] = $c3b64ab3db691a18$export$bed28288a051538;

});

parcelRegister("3SChL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $kBr4q.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $kBr4q.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $cozmU.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $cozmU.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("3Awqk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $kSwu1.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $kSwu1.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $kSwu1.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $kSwu1.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("2AgON", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $cozmU.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $cozmU.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $cozmU.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("35Nok", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $cd2e96a49affba4b$export$4b64aca38e15f2eb = ({ gif: gif, placeholder: placeholder, skip: skip = false })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const gifSrc = gif[colorMode ?? 'light'];
    const placeholderSrc = placeholder[colorMode ?? 'light'];
    const [isReady, setIsReady] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        setIsReady(false);
        const image = new Image();
        image.onload = ()=>{
            setIsReady(true);
        };
        image.onerror = ()=>{
            setIsReady(false);
        };
        image.src = gifSrc;
        // If the image has already loaded (cached), handle it immediately
        if (image.complete) setIsReady(true);
    }, [
        gifSrc,
        skip
    ]);
    return isReady ? gifSrc : placeholderSrc;
};
module.exports["usePreloadGif"] = $cd2e96a49affba4b$export$4b64aca38e15f2eb;

});

parcelRegister("eGUIL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $cozmU.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("cYvjs", function(module, exports) {

let $972360bb4cc62e2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $972360bb4cc62e2e$var$load("dZulV"),
    $972360bb4cc62e2e$var$load("6wr18"),
    $972360bb4cc62e2e$var$load("diMTQ"),
    $972360bb4cc62e2e$var$load("7EorR"),
    $972360bb4cc62e2e$var$load("aLbuU"),
    $972360bb4cc62e2e$var$load("ffEVr"),
    $972360bb4cc62e2e$var$load("PkFdp")
]).then(()=>parcelRequire('hSgLQ'));

});

parcelRegister("inA63", function(module, exports) {

let $d6166006e155d91d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d6166006e155d91d$var$load("4tFwP"),
    $d6166006e155d91d$var$load("6oFhK")
]).then(()=>parcelRequire('iwt54'));

});

parcelRegister("28oQf", function(module, exports) {
const $a5e3205ff2d8ec91$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-space-analytics';
const $a5e3205ff2d8ec91$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-moderate-space-analytics';
const $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-automation';
const $a5e3205ff2d8ec91$export$dad26f289a3f773e = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-blogs';
const $a5e3205ff2d8ec91$export$27d01545acc1e1ca = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';
const $a5e3205ff2d8ec91$export$a1081c7e806b45a0 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-k15t-orderly-databases-database';
const $a5e3205ff2d8ec91$export$de45ec31104af09 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-atlassian-confluence-plugins-confluence-questions-question';
const $a5e3205ff2d8ec91$export$1b86edccef2dd51 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-questions';
const $a5e3205ff2d8ec91$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
const $a5e3205ff2d8ec91$export$9727611105a72ba4 = 'com.atlassian.plugins.atlassian-connect-plugin';
const $a5e3205ff2d8ec91$export$35d69df876e79a8b = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-shortcuts';
const $a5e3205ff2d8ec91$export$28596511f20e98f2 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-apps';
const $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-content-manager';
module.exports["ANALYTICS_KEY"] = $a5e3205ff2d8ec91$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $a5e3205ff2d8ec91$export$6c3d789a4f56bea2;
module.exports["BLOG_KEY"] = $a5e3205ff2d8ec91$export$dad26f289a3f773e;
module.exports["CALENDARS_KEY"] = $a5e3205ff2d8ec91$export$27d01545acc1e1ca;
module.exports["DATABASES_KEY"] = $a5e3205ff2d8ec91$export$a1081c7e806b45a0;
module.exports["QUESTIONS_KEY"] = $a5e3205ff2d8ec91$export$de45ec31104af09;
module.exports["QUESTIONS_NATIVE_KEY"] = $a5e3205ff2d8ec91$export$1b86edccef2dd51;
module.exports["CONNECT_ADDON_KEY"] = $a5e3205ff2d8ec91$export$9727611105a72ba4;
module.exports["SHORTCUTS_KEY"] = $a5e3205ff2d8ec91$export$35d69df876e79a8b;
module.exports["APPS_KEY"] = $a5e3205ff2d8ec91$export$28596511f20e98f2;

});

parcelRegister("29Vr1", function(module, exports) {

let $1928f96b85f18df7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1928f96b85f18df7$var$load("6wr18"),
    $1928f96b85f18df7$var$load("ffEVr"),
    $1928f96b85f18df7$var$load("c08ou")
]).then(()=>parcelRequire('99rcJ'));

});

parcelRegister("3vaGk", function(module, exports) {

let $28cc8d87dd6f2ca6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $28cc8d87dd6f2ca6$var$load("6wr18"),
    $28cc8d87dd6f2ca6$var$load("ffEVr"),
    $28cc8d87dd6f2ca6$var$load("8uhuz")
]).then(()=>parcelRequire('ar6Ga'));

});

parcelRegister("dJFqB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $euL71 = parcelRequire("euL71");


var $9HB34 = parcelRequire("9HB34");


var $bQm3c = parcelRequire("bQm3c");


var $8Lx5S = parcelRequire("8Lx5S");


var $1xpoY = parcelRequire("1xpoY");


var $dGmBZ = parcelRequire("dGmBZ");

const $ec7296adc394eb50$var$SpaceNavigationAffordanceDataContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $ec7296adc394eb50$export$8290219e59a270d8 = ()=>{
    return (0, $cozmU.useContext)($ec7296adc394eb50$var$SpaceNavigationAffordanceDataContext);
};
const $ec7296adc394eb50$var$SpaceNavigationAffordanceDataProviderInner = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { children: children, spaceKey: spaceKey, variables: variables } = t0;
    const { cloudId: cloudId, edition: edition, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = (0, $8Lx5S.useIsLicensed)();
    let t1;
    if ($[0] !== edition || $[1] !== hasLicensedAccess || $[2] !== isLicensed || $[3] !== isLoggedIn) {
        t1 = edition !== (0, $euL71.ConfluenceEdition).FREE && isLoggedIn && (!(0, $1xpoY.default).isKillSwitchOn("confluence_space_nav_license_error_fix") ? hasLicensedAccess : isLicensed);
        $[0] = edition;
        $[1] = hasLicensedAccess;
        $[2] = isLicensed;
        $[3] = isLoggedIn;
        $[4] = t1;
    } else t1 = $[4];
    const includePersistentInviteLicense = t1;
    let t2;
    if ($[5] !== cloudId || $[6] !== includePersistentInviteLicense || $[7] !== isLicensed || $[8] !== spaceKey || $[9] !== variables) {
        t2 = variables ?? {
            cloudId: cloudId,
            spaceKey: spaceKey,
            isLicensed: isLicensed,
            includePersistentInviteLicense: includePersistentInviteLicense,
            includeSpaceCurationCount: false,
            includeSpaceViewsPersistence: false
        };
        $[5] = cloudId;
        $[6] = includePersistentInviteLicense;
        $[7] = isLicensed;
        $[8] = spaceKey;
        $[9] = variables;
        $[10] = t2;
    } else t2 = $[10];
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            fetchPolicy: "store-only"
        };
        $[11] = t3;
    } else t3 = $[11];
    const routeData = (0, $6SsN4.useLazyLoadQuery)((0, $dGmBZ.default), t2, t3);
    routeData.user?.confluence?.permissionType;
    let t4;
    bb0: {
        if (!routeData.space) {
            t4 = undefined;
            break bb0;
        }
        const t5 = routeData.user?.confluence?.permissionType === "EXTERNAL";
        let t6;
        if ($[12] !== routeData.license || $[13] !== routeData.space || $[14] !== routeData.spaceCurationSuggestionCount || $[15] !== t5) {
            t6 = {
                spaceFragmentRef: routeData.space,
                licenseFragmentRef: routeData.license,
                suggestionCountFragmentRef: routeData.spaceCurationSuggestionCount,
                isUserExternalCollaborator: t5
            };
            $[12] = routeData.license;
            $[13] = routeData.space;
            $[14] = routeData.spaceCurationSuggestionCount;
            $[15] = t5;
            $[16] = t6;
        } else t6 = $[16];
        t4 = t6;
    }
    const affordanceData = t4;
    if (!affordanceData) {
        let t5;
        if ($[17] !== children) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[17] = children;
            $[18] = t5;
        } else t5 = $[18];
        return t5;
    }
    let t5;
    if ($[19] !== affordanceData || $[20] !== children) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ec7296adc394eb50$var$SpaceNavigationAffordanceDataContext.Provider, {
            value: affordanceData
        }, children);
        $[19] = affordanceData;
        $[20] = children;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
};
const $ec7296adc394eb50$export$653a8018007c119 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, spaceKey: spaceKey, variables: variables } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9HB34.getRelayEnvironment)();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== spaceKey || $[3] !== variables) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6SsN4.RelayEnvironmentProvider), {
            environment: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ec7296adc394eb50$var$SpaceNavigationAffordanceDataProviderInner, {
            spaceKey: spaceKey,
            variables: variables
        }, children));
        $[1] = children;
        $[2] = spaceKey;
        $[3] = variables;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["useSpaceNavigationAffordanceData"] = $ec7296adc394eb50$export$8290219e59a270d8;
module.exports["SpaceNavigationAffordanceDataProvider"] = $ec7296adc394eb50$export$653a8018007c119;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$9df55620e365effa = ()=>{
    const { isLoggedIn: isLoggedIn, hasConfluenceUser: hasConfluenceUser } = (0, $bQm3c.useSessionData)();
    return isLoggedIn && !hasConfluenceUser;
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useIsAuthenticatedWithoutConfluenceUser"] = $30f02aa82d7102bc$export$9df55620e365effa;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("3gezS", function(module, exports) {

let $25fe2c8b764ddc96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $25fe2c8b764ddc96$var$load("6wr18"),
    $25fe2c8b764ddc96$var$load("ffEVr"),
    $25fe2c8b764ddc96$var$load("klGUa")
]).then(()=>parcelRequire('8o2bj'));

});

parcelRegister("2Dj8l", function(module, exports) {

let $1eae10cd0fc3cda9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1eae10cd0fc3cda9$var$load("6wr18"),
    $1eae10cd0fc3cda9$var$load("ffEVr"),
    $1eae10cd0fc3cda9$var$load("aLbuU"),
    $1eae10cd0fc3cda9$var$load("7EorR"),
    $1eae10cd0fc3cda9$var$load("kZjBp")
]).then(()=>parcelRequire('1xLOH'));

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("dYU3e", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $iffSy = parcelRequire("iffSy");



var $7Lnfv = parcelRequire("7Lnfv");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$addExtraInfoToError = (error, extraInfo)=>{
    try {
        const existingExtraInfo = Reflect.get(error, 'extraInfo');
        const existingExtraInfoObject = typeof existingExtraInfo === 'object' && existingExtraInfo !== null ? existingExtraInfo : undefined;
        Reflect.set(error, 'extraInfo', {
            ...existingExtraInfoObject,
            ...extraInfo
        });
    } catch  {
    // Some error shapes can be non-extensible. Extra info is best-effort diagnostics.
    }
};
const $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors = (errors, extraInfo)=>{
    errors?.forEach((error)=>{
        $48ba6fb41a85dc7e$var$addExtraInfoToError(error, extraInfo);
    });
};
const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__, relayQueryPreloadRetention: relayQueryPreloadRetention }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    const preloaderErrorExtraInfo = {
        operationName: name ?? 'unknown',
        callerPackage: __callerPackage__
    };
    const queryContext = {
        ...context
    };
    queryContext.headers = {
        ...context?.headers,
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__,
        relayQueryPreloadRetention: relayQueryPreloadRetention
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        if (result.error) $48ba6fb41a85dc7e$var$addExtraInfoToError(result.error, preloaderErrorExtraInfo);
        $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors(errors, preloaderErrorExtraInfo);
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeAggQuery"] = $48ba6fb41a85dc7e$export$5e270d77b1b480de;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $2OQaT = parcelRequire("2OQaT");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const personalization = (0, $cozmU.useContext)((0, $2OQaT.OnboardingPersonalizationContext));
    // Compare key values so inline arrays do not invalidate the filtered result on every render.
    const serializedKeys = (0, $cozmU.useMemo)(()=>JSON.stringify(Array.isArray(key) ? key : [
            key
        ]), [
        key
    ]);
    const keys = (0, $cozmU.useMemo)(()=>JSON.parse(serializedKeys), [
        serializedKeys
    ]);
    const hasPersonalization = !!personalization && keys.every((item)=>personalization.keys.includes(item));
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: hasPersonalization ? [
                ...personalization.keys
            ] : key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    const filteredData = (0, $cozmU.useMemo)(()=>data && hasPersonalization ? {
            onboardingState: data.onboardingState?.filter((item)=>keys.includes(item.key)) ?? null
        } : data, [
        data,
        hasPersonalization,
        keys
    ]);
    const refetchRequestedKeys = (0, $cozmU.useCallback)((vars)=>refetch({
            key: keys,
            ...vars
        }), [
        refetch,
        keys
    ]);
    return {
        data: filteredData,
        error: error,
        loading: loading,
        refetch: hasPersonalization ? refetchRequestedKeys : refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<2e96995cd41622171f58df93d4ef5369>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true,
        "throwOnFieldError": true
    },
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "da011c9ee7ee2f3537016ecf931bb29c";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("2OQaT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ba20d15733355e18$export$9bb9b7f6216e0638 = (0, $cozmU.createContext)(undefined);
module.exports["OnboardingPersonalizationContext"] = $ba20d15733355e18$export$9bb9b7f6216e0638;

});

parcelRegister("cbOce", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("6Q8Dd", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $4fae4b715d22864c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $4fae4b715d22864c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $4fae4b715d22864c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $4fae4b715d22864c$var$getValidCacheKeyFn(options);
        this._cacheMap = $4fae4b715d22864c$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $4fae4b715d22864c$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $4fae4b715d22864c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$4fae4b715d22864c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $4fae4b715d22864c$var$enqueuePostPromiseJob = typeof $1P2f3 === 'object' && typeof $1P2f3.nextTick === 'function' ? function(fn) {
    if (!$4fae4b715d22864c$var$resolvedPromise) $4fae4b715d22864c$var$resolvedPromise = Promise.resolve();
    $4fae4b715d22864c$var$resolvedPromise.then(function() {
        $1P2f3.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $4fae4b715d22864c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $4fae4b715d22864c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $4fae4b715d22864c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $4fae4b715d22864c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $4fae4b715d22864c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$4fae4b715d22864c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $4fae4b715d22864c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $4fae4b715d22864c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $4fae4b715d22864c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $4fae4b715d22864c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $4fae4b715d22864c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $4fae4b715d22864c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $4fae4b715d22864c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $4fae4b715d22864c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $4fae4b715d22864c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $4fae4b715d22864c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $4fae4b715d22864c$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $4fae4b715d22864c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $4fae4b715d22864c$var$DataLoader;

});

parcelRegister("lPEt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
}); //# sourceMappingURL=lru.js.map

});

parcelRegister("fExfj", function(module, exports) {

var $92rGz = parcelRequire("92rGz");


var $8FkVw = parcelRequire("8FkVw");

const $6d29423afdca551a$export$eab97d15b1788b8d = $8FkVw;
const $6d29423afdca551a$export$3b4c04cf7dad0e50 = $92rGz;
module.exports["utils"] = $6d29423afdca551a$export$eab97d15b1788b8d;

});

parcelRegister("92rGz", function(module, exports) {

var $1Udvu = parcelRequire("1Udvu");


var $6kV7w = parcelRequire("6kV7w");


var $gG4RG = parcelRequire("gG4RG");


var $4sHaf = parcelRequire("4sHaf");


var $8F9fo = parcelRequire("8F9fo");


var $eCMSo = parcelRequire("eCMSo");

const $feac65a19c55a1da$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $8F9fo.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $4sHaf.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $gG4RG.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $eCMSo.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $1Udvu.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $feac65a19c55a1da$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};
module.exports["requestServiceMultipart"] = $feac65a19c55a1da$export$8b13532c81e8ac89;

});

parcelRegister("1Udvu", function(module, exports) {
async function $16357f97c0090164$export$74e0a034be2368c7(e, t) {
    if (!e.ok || !e.body || e.bodyUsed) return e;
    let n = e.headers.get("content-type");
    if (!n || !~n.indexOf("multipart/")) return e;
    let i = n.indexOf("boundary="), l = "-";
    if (~i) {
        let e = i + 9, t = n.indexOf(";", e);
        l = n.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(e, t, n) {
        let i, l, r, d = new TextDecoder("utf8"), o = e.getReader(), a = !n || !n.multiple, f = t.length, s = "", c = [];
        try {
            let e;
            e: for(; !(e = await o.read()).done;){
                let n = d.decode(e.value, {
                    stream: !0
                });
                i = s.length, s += n;
                let o = n.indexOf(t);
                for(~o ? i += o : i = s.indexOf(t), c = []; ~i;){
                    let e = s.slice(0, i), n = s.slice(i + f);
                    if (l) {
                        let t = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", t), l = !1, d = e.slice(t, i > -1 ? void 0 : i), o = String(e.slice(0, t)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; r = o[--s]; r = r.split(": "), f[r.shift().toLowerCase()] = r.join(": "));
                        if (r = f["content-type"], r && ~r.indexOf("application/json")) try {
                            d = JSON.parse(d), l = !0;
                        } catch (e) {}
                        if (r = {
                            headers: f,
                            body: d,
                            json: l
                        }, a ? yield r : c.push(r), "--" === n.slice(0, 2)) break e;
                    } else t = "\r\n" + t, l = f += 2;
                    s = n, i = s.indexOf(t);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(e.body, `--${l}`, t);
}
module.exports["meros"] = $16357f97c0090164$export$74e0a034be2368c7;

});

parcelRegister("gG4RG", function(module, exports) {
const $e76949c2aa479bf9$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $e76949c2aa479bf9$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $e76949c2aa479bf9$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $e76949c2aa479bf9$var$addToHeaders(headers, secOptions.headers);
    return headers;
};
module.exports["buildHeaders"] = $e76949c2aa479bf9$export$7d6ed858a91629c3;

});

parcelRegister("4sHaf", function(module, exports) {
const $1060d48a7c3c566e$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
module.exports["buildUrl"] = $1060d48a7c3c566e$export$b5cd97dee32de81d;

});

parcelRegister("8F9fo", function(module, exports) {
const $39f3fe1498ecdf1b$export$160dbda113bfad3b = {};
module.exports["defaultRequestServiceOptions"] = $39f3fe1498ecdf1b$export$160dbda113bfad3b;

});

parcelRegister("eCMSo", function(module, exports) {
const $e0f49dd64fe47409$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};
module.exports["buildCredentials"] = $e0f49dd64fe47409$export$2ac26f1ab7eda637;

});

parcelRegister("8FkVw", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => (parcelRequire("d42dq")).extractTracingHeaders);
$parcel$export(module.exports, "requestService", () => (parcelRequire("i3nsM")).requestService);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { extractTracingHeaders } from '@atlaskit/util-service-support/extractTracingHeaders'` instead.
 */ 
var $d42dq = parcelRequire("d42dq");


var $i3nsM = parcelRequire("i3nsM");


});

parcelRegister("d42dq", function(module, exports) {
const $4b6ed4b3c47c9806$var$TRACING_RESPONSE_HEADERS = [
    'x-trace-id',
    'atl-request-id'
];
const $4b6ed4b3c47c9806$export$4f34edf253146101 = (response)=>{
    const headers = {};
    for (const name of $4b6ed4b3c47c9806$var$TRACING_RESPONSE_HEADERS){
        const value = response.headers.get(name);
        if (value) headers[name] = value;
    }
    return headers;
};
module.exports["extractTracingHeaders"] = $4b6ed4b3c47c9806$export$4f34edf253146101;

});

parcelRegister("i3nsM", function(module, exports) {

var $6kV7w = parcelRequire("6kV7w");


var $gG4RG = parcelRequire("gG4RG");


var $4sHaf = parcelRequire("4sHaf");


var $d42dq = parcelRequire("d42dq");


var $8F9fo = parcelRequire("8F9fo");


var $eCMSo = parcelRequire("eCMSo");

const $1269a5671963131d$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $8F9fo.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $4sHaf.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $gG4RG.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $eCMSo.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (options?.reportTracingHeaders) {
            const tracingHeaders = (0, $d42dq.extractTracingHeaders)(response);
            if (Object.keys(tracingHeaders).length > 0) options.reportTracingHeaders(tracingHeaders);
        }
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $1269a5671963131d$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
module.exports["requestService"] = $1269a5671963131d$export$97bfde5a702aaeca;

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("4o0zT", function(module, exports) {

var $cha5E = parcelRequire("cha5E");

function $36a5a3af492bc91f$export$336b018592dc9972(experimentName) {
    return (0, $cha5E.expVal)(experimentName, 'isEnabled', false) === true;
}
module.exports["isExperimentEnabled"] = $36a5a3af492bc91f$export$336b018592dc9972;

});

parcelRegister("cha5E", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $62f475419a76226b$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, true);
}
module.exports["expVal"] = $62f475419a76226b$export$9db1624a8af791a4;

});

parcelRegister("a4RZV", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $7OZjB = parcelRequire("7OZjB");


var $gvJlB = parcelRequire("gvJlB");

function $9b4163a3d03875dc$export$48708229abf6ab93(experimentName, param, defaultValue, fireExperimentExposure) {
    // Dev-mode override (platform website dev panel, Gemini VR test harness).
    if ((0, $gvJlB.devOverrides).has(experimentName)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const overrideParams = (0, $gvJlB.devOverrides).get(experimentName);
        const overrideValue = overrideParams[param];
        if (overrideValue !== undefined) {
            (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, overrideValue);
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return overrideValue;
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return defaultValue;
    }
    // If Statsig is not initialized, return the default.
    if (!(0, $cXtTj.default).initializeCompleted()) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return defaultValue;
    // Live Statsig value.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const value = (0, $cXtTj.default).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    (0, $7OZjB.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
module.exports["expValInternal"] = $9b4163a3d03875dc$export$48708229abf6ab93;

});

parcelRegister("gvJlB", function(module, exports) {
const $bd07fe7ea4e784d1$export$89f9222be8849d61 = new Map();
let $bd07fe7ea4e784d1$export$1443858d5f82511f = false;
function $bd07fe7ea4e784d1$export$6bce865e33a255c3(value) {
    $bd07fe7ea4e784d1$export$1443858d5f82511f = value;
}
module.exports["devOverrides"] = $bd07fe7ea4e784d1$export$89f9222be8849d61;

});

parcelRegister("2pQiO", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $1295d9cf79f622cc$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, false);
}
module.exports["UNSAFE_expValNoExposure"] = $1295d9cf79f622cc$export$da472ee01c19d92e;

});

parcelRegister("ipkS0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $3GQl6 = parcelRequire("3GQl6");

const $689b0be44fd5c2f8$var$logger = (0, $7W8i8.getLogger)('trackReactLazy');
// Marks a subtree whose code only loads when a render-time lazy component renders. The client
// cannot load it before hydration, so lazy components inside it must not hold hydration.
const $689b0be44fd5c2f8$var$RenderTimeLazyAncestor = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $689b0be44fd5c2f8$var$warnedRenderTimeIds = new Set();
// React 18's lazy initializer checks the component's status as soon as `then` returns, and suspends
// unless `then` has already called back. `Promise.resolve(loaded)` always calls back in a
// microtask, so it would suspend even for a loaded module. This Promise overrides `then` to call
// back synchronously. The rest of the Promise API goes through `then`, so `catch`, `finally` and
// `Promise.all` still work.
const $689b0be44fd5c2f8$var$resolvedThenable = (value)=>{
    const promise = new Promise((resolve)=>resolve(value));
    promise.then = (onFulfilled)=>Promise.resolve(onFulfilled ? onFulfilled(value) : value);
    return promise;
};
function $689b0be44fd5c2f8$var$withServerTracking(id, module, { renderTime: renderTime, source: source }) {
    const Original = module.default;
    const TrackedLazy = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        const hasRenderTimeAncestor = (0, $cozmU.useContext)($689b0be44fd5c2f8$var$RenderTimeLazyAncestor);
        const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Original, {
            ...props,
            ref: ref
        });
        if (renderTime) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($689b0be44fd5c2f8$var$RenderTimeLazyAncestor.Provider, {
            value: true
        }, element);
        // Effects do not run during SSR, so render is the only place to record the rendered split.
        if (!hasRenderTimeAncestor && (0, $6mKj3.expValEquals)('confluence_ssr_react_lazy_preload', 'isEnabled', true)) (0, $3GQl6.addLoadableId)(id);
        return element;
    });
    TrackedLazy.displayName = `TrackedLazy(${Original.displayName || Original.name || 'Component'})`;
    return {
        ...module,
        default: TrackedLazy
    };
}
function $689b0be44fd5c2f8$export$fb5c897fe5d03fec(id, loader, options = {}) {
    // process.env.REACT_SSR is read inline so each build can drop the other side's branch. None of
    // these branches changes rendered markup, so they cannot cause a hydration mismatch.
    const prepare = (module)=>module;
    if (options.renderTime) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return loader;
    let loaded;
    let pending;
    const load = ()=>{
        pending ?? (pending = loader().then((module)=>{
            loaded = prepare(module);
            return loaded;
        }, (error)=>{
            pending = undefined;
            throw error;
        }));
        return pending;
    };
    let preloaded = false;
    // preloadIfNeeded can start loading at once. Waiting a microtask lets the defining module
    // finish evaluating before the loader reads any of its bindings.
    (0, $3GQl6.preloadIfNeeded)(id, undefined, ()=>Promise.resolve().then(load).then(()=>{
            preloaded = true;
        }));
    return ()=>{
        if (!loaded) return load();
        // The client only answers synchronously after the preload the server asked for, so lazy
        // components behave as before when the experiment is off.
        const canResolveSynchronously = preloaded;
        return canResolveSynchronously ? $689b0be44fd5c2f8$var$resolvedThenable(loaded) : load();
    };
}
module.exports["trackReactLazy"] = $689b0be44fd5c2f8$export$fb5c897fe5d03fec;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("iDdJP", function(module, exports) {

var $k27u5 = parcelRequire("k27u5");

const $c514d668c0af497d$export$d4c4e98c5044dc8 = (0, $k27u5.List);
module.exports["MenuList"] = $c514d668c0af497d$export$d4c4e98c5044dc8;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("4K4h4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $61f85e63c6992485$export$e511f243d20dd25e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g-l5_",
    name: "ContentTreeIconLoader",
    loader: async ()=>(await (parcelRequire("gSu53"))).ContentTreeIcon
});
module.exports["ContentTreeIconLoader"] = $61f85e63c6992485$export$e511f243d20dd25e;

});

parcelRegister("gSu53", function(module, exports) {

let $c49905dc6f37c0aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c49905dc6f37c0aa$var$load("6wr18"),
    $c49905dc6f37c0aa$var$load("ffEVr"),
    $c49905dc6f37c0aa$var$load("YfZEx")
]).then(()=>parcelRequire('iU0gR'));

});

parcelRegister("6bZDi", function(module, exports) {
const $a8768b1a0c8c67c8$export$ee7a362b3ed8b036 = [
    'page',
    'whiteboard',
    'database',
    'slide',
    'folder',
    'liveDoc'
];
const $a8768b1a0c8c67c8$export$a73714094b2817b7 = (obj)=>typeof obj === 'string' && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(obj);
const $a8768b1a0c8c67c8$export$204659eac14d740b = (obj)=>$a8768b1a0c8c67c8$export$a73714094b2817b7(obj) ? obj : undefined;
const $a8768b1a0c8c67c8$export$c7c48cc42c0546b7 = (contentType)=>{
    const contentTreeType = $a8768b1a0c8c67c8$export$204659eac14d740b(contentType);
    return !!contentTreeType && $a8768b1a0c8c67c8$export$ee7a362b3ed8b036.includes(contentTreeType);
};
module.exports["isContentTreeType"] = $a8768b1a0c8c67c8$export$a73714094b2817b7;
module.exports["toContentTreeType"] = $a8768b1a0c8c67c8$export$204659eac14d740b;
module.exports["includesValidContentTreeType"] = $a8768b1a0c8c67c8$export$c7c48cc42c0546b7;

});


//# sourceMappingURL=SpaceNavigationContent.5c0e25a2.js.map
